/* cm-mamontre.js : rendu partage de la fiche "Ma montre" facon page produit (v5.15.1, 2026-08-27).
   v6.40 (2026-09-22, demande Lino) : garde-fou MARQUES DEPOSEES. Un texte libre du client (cadran,
   gravures) qui contient une marque ou un nom de modele depose desactive le bouton d achat et dit
   pourquoi, en 7 langues. Voir MARQUES et marqueInterdite().
   v6.23 (2026-09-13) : evenements de mesure vue / add_to_cart / save / fermeture, sur GA4 (gtag),
   Clarity, Klaviyo et pixels Shopify, avec la surface (overlay / fiche / page).
   v6.24 (2026-09-13, verdict Marc) : ligne 3x sur le prix, gravure en tete du recapitulatif et filtre des
   lignes techniques, trois engagements sous le tableau, croix libellee « Modifier ma montre » a gauche,
   ligne de confiance remontee (haut du flux / sous le bouton en fenetre), specs repliees hors fenetre,
   montre a 560 px en fenetre, carte d identite lisible.
   v6.30 (2026-09-14, Lino) : la fiche d un favori retrouve une croix de fermeture, en haut a GAUCHE de
   la scene, au style exact de la loupe et du partage (meme taille, meme retrait, meme fond).
   Utilise par : snippets/cm-favoris.liquid (ecran instantane par-dessus le configurateur)
   et sections/cm-fav-review.liquid (page /pages/my-watch pour les liens emails/favoris).
   API : window.cmMaMontre.render(host, ctx) -> { majAchat }
   ctx = { T, data {title,image,price,currency,handle,options[[k,v]],logo?}, trust, productJsonUrl,
           favPageUrl, showClose, fenetre, interceptKey, hideSave, fmtPrice, addToCart, sendEmail,
           savedEmail, isClaimed?, lienSecondaire?, cta?, meta?, traduitOptions?,
           onClose?, onFavKept?, onFavClaim?, onFavUndo? }
   Valeur rendue : { majAchat: function } . majAchat rejoue le SEUL bloc d achat, dans ses deux
   conteneurs, sans redessiner la fiche. C est ce que l appelant doit employer apres un ajout au
   panier reussi ou echoue : rappeler render() a chaque ajout redessine tout l ecran, le fait
   clignoter sous le doigt du client et empile les ecouteurs.
   ctx.cta : { texte, desactive, lien } optionnel, RELU A CHAQUE garniture du bloc d achat, et
   non capture a l ouverture. Il porte l etat du bouton noir quand l appelant en sait plus que
   le moteur : « deja au panier » (texte pose, desactive vrai, lien vers le panier), ou « sans
   ligne memorisee » (le bouton dit la reprise, puisque c est la seule action possible). Son
   lien, s il existe, REMPLACE ctx.lienSecondaire pour cet etat au lieu de s y ajouter. Absent,
   le bouton dit ctx.T.addCart et rien ne bouge : l ecran d apres configuration ne le pose pas.
   ctx.meta : ligne discrete rendue SOUS le titre. La date de sauvegarde de « Mes montres » y
   vit ; le sur-titre, en capitales espacees, la rendait plus grosse que le nom du modele.
   ctx.traduitOptions : passe les cles ET les valeurs des options par libelle(), donc par le
   glossaire, pour une fiche dont les options ont ete choisies dans une autre langue que celle
   de la page. Defaut faux : les options de l ecran d apres configuration viennent d etre
   choisies, elles sont deja dans la bonne langue.
   lienSecondaire : { texte, href } optionnel. Un lien discret pose SOUS le bouton noir, dans
   les deux conteneurs d achat (le bloc sous la montre sur PC, la barre du bas sur telephone).
   Il existe parce que la fiche d une montre favorite doit garder « Reprendre ma configuration »
   la ou l ecran d apres configuration n a rien a proposer de tel : sans lui, fusionner les deux
   ecrans serait une regression fonctionnelle meme avec un affichage correct. Absent = rien de
   rendu, l ecran d apres configuration ne bouge pas d un pixel.
   fenetre : l appelant declare que son ecran est une COUCHE posee sur le site, pas une page.
   Pose par snippets/cm-favoris.liquid uniquement. Au-dessus du seuil MQ_FENETRE il fait de
   .cm-mm une carte centree bornee, barre d achat en pied de carte, et il arme la sortie par
   Echap et par le clic sur le voile. ABSENT depuis sections/cm-fav-review.liquid, parce que
   /pages/my-watch EST une page : URL propre, historique, header et pied de page reels,
   adresse envoyee dans les emails Klaviyo. Le drapeau est POSE et non deduit : le deduire de
   showClose fusionnerait deux decisions independantes, et comme la vraie garde de la croix
   est (showClose && onClose), un appelant qui passerait showClose sans onClose obtiendrait
   une carte bornee sur fond assombri sans aucune sortie. Defaut faux = rendu page, le rendu
   sur, celui qui n enferme jamais personne.
   v3 (passe 100x Marc) : ordre emotion avant prix, fusion save+email, interception croix.
   v4 : sections composants facon Rolex (images isolees de window.cmComponents).
   v5 (demande Lino 26/08, 3h) : la DESCRIPTION du modele est SUPPRIMEE (plus de bloc
   "Le modele", plus de specs, plus de photos produit generiques, plus de fetch product.json).
   A la place, UNE bande composant : image de la lunette A GAUCHE, texte A DROITE
   (libelle de l'option, valeur choisie, puis un texte universel qui nomme la lunette ET le
   boitier du client). Repli sur l'image du boitier si la lunette n'a pas d'image en table.
   ctx.productJsonUrl est accepte mais ignore (compatibilite avec les surfaces appelantes).
   v5.1 : la bande retient la premiere option lunette QUI A UNE IMAGE en table (SeaRanger
   pose d'abord le style de lunette, sans image, puis la couleur qui elle en a une).
   v6 (retour Lino du 03/09) : la barre collante existe sur PC comme sur mobile, et elle
   porte DEUX gestes, "Ajouter au panier" et "Mettre en favoris". La mise en favori cesse
   d'etre une consequence du chargement : elle attend le clic (ctx.onFavClaim). La colonne
   ne reproduit plus ces boutons, la barre les porte a toutes les tailles. Le bouton
   enveloppe du v5186 disparait : le coeur ouvre le meme bloc email, et il dit vrai.
   v6.2 (revue du 04/09 sur la fusion de la fiche « Mes montres ») : le moteur gagne trois
   entrees de contrat OPTIONNELLES et une valeur de retour, tout cela pour une seule raison :
   la fiche d une montre favorite en sait plus que lui sur l etat du bouton d achat, et jusqu ici
   elle n avait aucun moyen de le lui dire. ctx.cta porte cet etat, ctx.meta la date de
   sauvegarde, ctx.traduitOptions la mise en langue des options, et render() rend une poignee
   qui rejoue le seul bloc d achat. Aucune n est posee par l ecran d apres configuration, dont
   le rendu ne bouge pas. Sont corriges au passage, pour les deux surfaces : la reserve de la
   barre du telephone (mesuree et non plus devinee), l etiquette de la croix (7 langues au lieu
   du mot anglais en dur) et l ecouteur Echap, qui s empilait a chaque ouverture.
   v6.1 (retour Lino du 03/09, second passage) : au-dessus de MQ_FENETRE l ecran devient une
   FENETRE centree sur fond assombri, facon modale Kickflip ou Mercedes, barre d achat en pied
   de carte donc toujours visible. Sous le seuil, rien ne change : le rendu telephone est
   declare parfait par Lino et il n est pas touche. */
(function () {
  'use strict';
  window.cmMaMontreVersion = '6000';
  if (window.cmMaMontre) return;

  /* --- textes de la bande composant, 7 langues, {bezel} et {case} remplaces au rendu --- */
  var COPY = {
    en: { both: 'A {bezel} bezel on a {case} case. You will get a photo of your finished watch before it ships.',
          one: 'A {bezel} bezel. You will get a photo of your finished watch before it ships.' },
    fr: { both: 'Une lunette {bezel} sur un boîtier {case}. Vous recevrez la photo de votre montre terminée avant son expédition.',
          one: 'Une lunette {bezel}. Vous recevrez la photo de votre montre terminée avant son expédition.' },
    de: { both: 'Eine {bezel} Lünette auf einem {case} Gehäuse. Sie erhalten ein Foto Ihrer fertigen Uhr, bevor sie versandt wird.',
          one: 'Eine {bezel} Lünette. Sie erhalten ein Foto Ihrer fertigen Uhr, bevor sie versandt wird.' },
    it: { both: 'Una lunetta {bezel} su una cassa {case}. Riceverai la foto del tuo orologio finito prima della spedizione.',
          one: 'Una lunetta {bezel}. Riceverai la foto del tuo orologio finito prima della spedizione.' },
    es: { both: 'Un bisel {bezel} sobre una caja {case}. Recibirá la foto de su reloj terminado antes de su envío.',
          one: 'Un bisel {bezel}. Recibirá la foto de su reloj terminado antes de su envío.' },
    nl: { both: 'Een {bezel} bezel op een {case} kast. Je ontvangt een foto van je afgewerkte horloge voordat het wordt verzonden.',
          one: 'Een {bezel} bezel. Je ontvangt een foto van je afgewerkte horloge voordat het wordt verzonden.' },
    pt: { both: 'Um bisel {bezel} numa caixa {case}. Receberá a foto do seu relógio terminado antes do envio.',
          one: 'Um bisel {bezel}. Receberá a foto do seu relógio terminado antes do envio.' }
  };

  /* --- carte d'identite : 3 lignes sous la configuration ---------------------------------
     Valeurs relevees une par une sur les fiches produit le 26/08. Le mouvement change selon
     le master : ne JAMAIS ecrire une ligne generique. Jamais la marque du mouvement. */
  var MOUVEMENT = {
    en: { auto: 'Japanese automatic movement', gmt: 'Japanese automatic dual-time movement',
          daydate: 'Japanese automatic movement, day-date', mq: 'Japanese meca-quartz chronograph' },
    fr: { auto: 'Mouvement automatique japonais', gmt: 'Mouvement automatique japonais double fuseau',
          daydate: 'Mouvement automatique japonais, jour-date', mq: 'Chronographe méca-quartz japonais' },
    de: { auto: 'Japanisches Automatikwerk', gmt: 'Japanisches Automatikwerk mit zweiter Zeitzone',
          daydate: 'Japanisches Automatikwerk, Tag-Datum', mq: 'Japanischer Meca-Quarz-Chronograph' },
    it: { auto: 'Movimento automatico giapponese', gmt: 'Movimento automatico giapponese doppio fuso',
          daydate: 'Movimento automatico giapponese, giorno-data', mq: 'Cronografo meca-quarzo giapponese' },
    es: { auto: 'Movimiento automático japonés', gmt: 'Movimiento automático japonés de doble huso',
          daydate: 'Movimiento automático japonés, día-fecha', mq: 'Cronógrafo meca-cuarzo japonés' },
    nl: { auto: 'Japans automatisch uurwerk', gmt: 'Japans automatisch uurwerk met tweede tijdzone',
          daydate: 'Japans automatisch uurwerk, dag-datum', mq: 'Japanse meca-kwarts chronograaf' },
    pt: { auto: 'Movimento automático japonês', gmt: 'Movimento automático japonês de duplo fuso',
          daydate: 'Movimento automático japonês, dia-data', mq: 'Cronógrafo meca-quartzo japonês' }
  };
  var ACIER = { en: '316L stainless steel', fr: 'Acier inoxydable 316L', de: 'Edelstahl 316L',
                it: 'Acciaio inossidabile 316L', es: 'Acero inoxidable 316L', nl: 'Roestvrij staal 316L',
                pt: 'Aço inoxidável 316L' };
  /* v6.3 (05/09/2026, reponses Lino) : matieres de boitier autres que l'acier. Une seule
     s'affiche a la fois, A LA PLACE de ACIER, quand la reponse boitier du client la designe.
     La table qui fait ce lien est BOITIERS, plus bas. */
  var CARBONE = { en: 'Forged carbon', fr: 'Carbone forgé', de: 'Forged Carbon',
                  it: 'Carbonio forgiato', es: 'Carbono forjado', nl: 'Forged carbon',
                  pt: 'Carbono forjado' };
  var TITANE = { en: 'Grade 2 titanium', fr: 'Titane grade 2', de: 'Titan Grade 2',
                 it: 'Titanio grado 2', es: 'Titanio grado 2', nl: 'Titanium graad 2',
                 pt: 'Titânio grau 2' };
  /* v6.5 : matieres de BRACELET. Le boitier et le bracelet ne sont pas dans le meme acier et
     c'est voulu : boitier 316L, bracelet 904L (superaustenitique, resiste mieux a la sueur et
     prend un poli plus vif). L'argument n'etait publie nulle part sur cet ecran. Deux masters
     font exception, Apex et Horizon, dont le bracelet integre est en 316L (Lino, 07/09/2026). */
  var ACIER904 = { en: '904L stainless steel', fr: 'Acier 904L', de: 'Edelstahl 904L',
                   it: 'Acciaio 904L', es: 'Acero 904L', nl: 'Roestvrij staal 904L',
                   pt: 'Aço 904L' };
  var CAOUT = { en: 'Rubber', fr: 'Caoutchouc', de: 'Kautschuk', it: 'Caucciù',
                es: 'Caucho', nl: 'Rubber', pt: 'Borracha' };
  var CUIR = { en: 'Leather', fr: 'Cuir', de: 'Leder', it: 'Pelle', es: 'Cuero',
               nl: 'Leer', pt: 'Couro' };
  var BRAC_316 = { 'apex': 1, 'horizon': 1 };
  var SAPHIR = { en: 'Sapphire crystal', fr: 'Verre saphir', de: 'Saphirglas', it: 'Vetro zaffiro',
                 es: 'Cristal de zafiro', nl: 'Saffierglas', pt: 'Vidro de safira' };
  var ETANCHE = { en: 'water resistant to', fr: 'étanche à', de: 'wasserdicht bis',
                  it: 'impermeabile fino a', es: 'sumergible hasta', nl: 'waterdicht tot',
                  pt: 'resistente à água até' };
  /* handle du master -> [type de mouvement, etancheite en metres (0 = non affichee)] */
  /* [type de mouvement, etancheite en metres, reference du calibre si elle est certaine].
     La reference n'est renseignee que la ou le master n'a qu'un seul calibre possible : sur
     Classic Date il depend du cadran choisi (NH35, Miyota 8285, NH70, NH72), et un calibre
     annonce a tort a deja valu un litige client. */
  /* Etancheites reprises une par une avec Lino le 05/09/2026. Le releve d'origine datait du
     26/08, donc d'AVANT la regle fond en verre = 3 ATM tranchee le 31/08 : six lignes sur
     douze annoncaient plus que la montre ne tient. Ne rien changer ici sans une reponse du
     fondateur, ce sont des allegations techniques que le client peut verifier.
       horizon 50 -> 30, odyssey 50 -> 30, marina-guard 0 -> 30 (fond saphir, regle du 31/08)
       landmaster 100 -> 30 (il n'y a que du verre saphir a l'arriere, Lino 05/09)
       oceanmaster 100 -> 30 (fiche fournisseur 3 ATM, Lino 05/09)
       searanger 200 -> 100 (fiche fournisseur 100 m, Lino 05/09)
     Le SeaRanger garde son NH36 jour-date : seule son etancheite etait fausse.
     Et un mouvement repris le 05/09, sur reponse de Lino :
       apex : NH35, NH70 ou NH72 selon le cadran, donc aucun calibre affiche, SAUF la version
       Case Type = Chronograph, qui est un VK63 meca-quartz et non un automatique (table
       BOITIERS ci-dessous). */
  /* v6.27 (13/09, Lino : « mets le mouvement en fonction de la montre ») : chaque master porte
     son calibre PAR DEFAUT, celui des cadrans classiques (NH35A partout sauf GMT NH34A, SeaRanger
     NH36A, Lady Date NH05A, Modena VK63). Les configurateurs posent eux-memes la question du
     mouvement quand le cadran en change (DeptMaster / Classic Date / Apex « Skeleton Movement »
     NH70A ou NH72A, Horizon « Movement » NH35A ou NH38A) : la reponse du client PRIME, voir
     calibreChoisi. Sources : Specs officielles des 12 masters (05/09), brand book, commandes
     reelles du 30/08 au 13/09. */
  var SPECS = {
    'apex': ['auto', 30, 'NH35A'], 'classic-date': ['auto', 100, 'NH35A'], 'deptmaster': ['auto', 100, 'NH35A'],
    'gmt': ['gmt', 100, 'NH34A'], 'horizon': ['auto', 30, 'NH35A'], 'lady-date': ['auto', 50, 'NH05A'],
    'landmaster': ['auto', 30, 'NH35A'], 'marina-guard': ['auto', 30, 'NH35A'],
    'modena': ['mq', 100, 'VK63'], 'oceanmaster': ['auto', 30, 'NH35A'],
    'odyssey': ['auto', 30, 'NH35A'], 'searanger': ['daydate', 100, 'NH36A']
  };
  /* Le calibre que le client a CHOISI, lu dans ses reponses. Trois formes rencontrees dans les
     commandes : la reponse commence par la reference (« NH72A, gray », « NH72A, grau »,
     « NH35A — Automatic Date »), ou la question la porte (Apex « mouvement nh72 » repondue
     « Skeleton dial »). Une reference lue chez le client prime sur la table, c est la piece
     qui sera montee. Aucune deduction a partir du NOM du cadran, sauf les deux cas ci-dessous,
     documentes : le litige #3583 est ne d un calibre annonce a tort. */
  var RE_MVT_CLE = /movement|mouvement|werk|movimento|movimiento|uurwerk/i;
  var RE_CAL_VAL = /^\s*NH\s?(\d{2})\s?A?\b/i;
  var RE_CAL_CLE = /\bNH\s?(\d{2})\s?A?\b/i;
  var RE_DAYDATE = /day[ -]?date|jour[ -]?date|tag[ -]?datum|giorno[ -]?data|d[ií]a[ -]?fecha|dag[ -]?datum|dia[ -]?data/i;
  var RE_OPENHEART = /open[ -]?heart|c(oe|œ)ur ouvert|offenes herz|cuore aperto|coraz[oó]n abierto|open hart|cora[cç][aã]o aberto/i;
  function calibreChoisi(master, options) {
    var cal = null, type = null, dayDate = false, openHeart = false;
    (options || []).forEach(function (p) {
      var k = String(p[0] || ''), v = String(p[1] || '');
      var m = v.match(RE_CAL_VAL);
      if (!m && RE_MVT_CLE.test(k)) m = k.match(RE_CAL_CLE);
      if (m && !cal) cal = 'NH' + m[1] + 'A';
      if (RE_DIAL.test(k) || /dial/.test(canon(k))) {
        if (RE_DAYDATE.test(v)) dayDate = true;
        if (RE_OPENHEART.test(v)) openHeart = true;
      }
    });
    if (cal) {
      if (cal === 'NH34A') type = 'gmt';
      else if (cal === 'NH36A') type = 'daydate';
      return { cal: cal, type: type };
    }
    /* Classic Date : le cadran jour-date recoit un Miyota 8285 (le NH35 n a pas le jour) ;
       Lino, 13/09 : « Day-Date c est bien 8285 », et « Without Date » reste un NH35A, donc le
       defaut de la table. Le brand book disait 8205 : c est le 8285 qui est monte. */
    if (master === 'classic-date' && dayDate) return { cal: 'Miyota 8285', type: 'daydate' };
    /* Horizon : la question « Movement » porte la reference ; si elle manque, l Open Heart est
       un NH38A sans date (Specs officielles des 12 masters, audit des specs de septembre). */
    if (master === 'horizon' && openHeart) return { cal: 'NH38A', type: null };
    return null;
  }
  /* Handles catalogue dont les specs NE SUIVENT PAS leur master. Egalite EXACTE, testee AVANT
     la resolution par prefixe : sans cela modena-forged-carbon-chronograph retombe sur
     'modena' et annonce acier 316L etanche a 100 m, alors que ces deux montres sont en carbone
     et tiennent 30 m. 4e element = matiere. */
  var SPECS_A_PART = {
    'modena-forged-carbon-chronograph': ['mq', 30, 'VK63', 'carbone'],
    'modena-carbon-yellow-chronograph': ['mq', 30, 'VK63', 'carbone']
  };
  var MATIERES = { acier: null, carbone: CARBONE, titane: TITANE };
  /* Reponses du configurateur qui changent la MATIERE du boitier, donc l'etancheite et les
     cotes. Indexe par MASTER : Stealth est le nom maison d'une finition NOIRE chez cinq autres
     masters, une regle globale sur ce mot ferait passer des boitiers acier pour du carbone.
     Modena : les 5 autres finitions sont de l'acier 316L revetu PVD (Lino, 05/09/2026). */
  var BOITIERS = {
    'modena':     [{ mot: /stealth/, mat: 'carbone', eau: 30, boitier: '38.4 mm', ep: '12.46 mm', poids: '70 g', l2l: '46 mm' }],
    /* le titane ne change pas les cotes, seulement la matiere et le poids : 90 g contre 140 sur
       le DeptMaster, 95 contre 140 sur le GMT (mesures Lino, 07/09). Les deux fiches titane du
       catalogue publient 140 g, le chiffre de l'acier, et c'est faux depuis toujours. */
    'deptmaster': [{ mot: /titan/, mat: 'titane', poids: '90 g' }],
    'gmt':        [{ mot: /titan/, mat: 'titane', poids: '95 g' }],
    /* q : la question a lire quand ce n'est pas la finition du boitier. L'Apex en pose trois qui
       parlent de boitier (Case Color, Case Type, Case Side - Engraving) : sans q, la premiere
       venue deciderait, et l'ordre des options n'est pas garanti. */
    'apex':       [{ q: /case type|type de bo|geh(a|ä)usetyp|tipo di cassa|tipo de caja|kasttype|tipo de caixa/i,
                     mot: /chrono/, mvt: 'mq', cal: 'VK63', ep: '12 mm', l2l: '52.5 mm' }]
  };
  /* La reponse boitier, et elle seule. findParts pose out.cas sur la PREMIERE question qui
     parle de boitier, ce qui peut etre Case Side engraving selon l'ordre des options : on ne
     peut pas s'en servir ici, une gravure ferait manquer le carbone en silence. */
  var RE_CASE_GRAV = /engrav|gravure|gravur|incision|grabado|grava/i;
  function reponseA(options, q) {
    var v = null;
    (options || []).forEach(function (p) {
      if (v) return;
      var k = p[0] || '';
      if (RE_CASE_GRAV.test(k)) return;
      var kc = canon(k);
      if (q) { if (!(q.test(k) || q.test(kc))) return; }
      else if (RE_CASE_NOT.test(k) || !(RE_CASE.test(k) || /case/.test(kc))) return;
      v = p[1] || '';
    });
    return v;
  }
  function varianteMaster(master, options) {
    var regles = BOITIERS[master];
    if (!regles) return null;
    var trouve = null;
    regles.forEach(function (r) {
      if (trouve) return;
      var rep = reponseA(options, r.q);
      if (!rep) return;
      if (r.mot.test(normalise(rep)) || r.mot.test(String(rep).toLowerCase())) trouve = r;
    });
    return trouve;
  }
  function specsFor(handle, l, options) {
    var key = null, s = SPECS_A_PART[String(handle || '')] || null;
    if (!s) {
      for (var k in SPECS) { if (handle === k || handle.indexOf(k + '-') === 0) { key = k; break; } }
      if (!key) return null;
      s = SPECS[key];
    }
    var mat = s[3] || 'acier', eau = s[1], type = s[0], cal = s[2];
    var choix = key ? varianteMaster(key, options) : null;
    if (choix) {
      if (choix.mat) mat = choix.mat;
      if (choix.eau !== undefined) eau = choix.eau;
      if (choix.mvt) type = choix.mvt;
      if (choix.cal !== undefined) cal = choix.cal;
    }
    /* v6.27 : le calibre lu dans les reponses du client prime, sauf sur un meca-quartz (Apex
       Chronograph) ou aucune question de mouvement n est posee. */
    var lu = (type !== 'mq') ? calibreChoisi(key, options) : null;
    if (lu) {
      cal = lu.cal;
      if (lu.type) type = lu.type;
    }
    var verre = SAPHIR[l];
    if (eau) verre += ', ' + ETANCHE[l] + ' ' + eau + ' m';
    var mvt = MOUVEMENT[l][type];
    if (cal) mvt += ' ' + cal;
    return [mvt, (MATIERES[mat] || ACIER)[l], verre];
  }

  /* v5.6 : texte de la bande bracelet, 7 langues, {strap} remplace au rendu */
  var COPY_STRAP = {
    en: 'A {strap} bracelet, fitted and adjusted by hand before your watch ships.',
    fr: 'Un bracelet {strap}, monté et ajusté à la main avant son expédition.',
    de: 'Ein {strap} Armband, von Hand montiert und eingestellt, bevor Ihre Uhr versandt wird.',
    it: 'Un bracciale {strap}, montato e regolato a mano prima della spedizione.',
    es: 'Un brazalete {strap}, montado y ajustado a mano antes del envío.',
    nl: 'Een {strap} band, met de hand gemonteerd en afgesteld voordat je horloge wordt verzonden.',
    pt: 'Uma bracelete {strap}, montada e ajustada à mão antes do envio.'
  };
  /* v5.7 : texte de la bande cadran, 7 langues */
  var COPY_DIAL = {
    en: { logo: 'A {dial} dial, printed and inspected one by one.',
          custom: 'A {dial} dial, carrying your own signature, printed and inspected one by one.' },
    fr: { logo: 'Un cadran {dial}, imprimé et contrôlé un par un.',
          custom: 'Un cadran {dial}, portant votre signature, imprimé et contrôlé un par un.' },
    de: { logo: 'Ein {dial} Zifferblatt, einzeln bedruckt und geprüft.',
          custom: 'Ein {dial} Zifferblatt mit Ihrer eigenen Signatur, einzeln bedruckt und geprüft.' },
    it: { logo: 'Un quadrante {dial}, stampato e controllato uno per uno.',
          custom: 'Un quadrante {dial} con la tua firma, stampato e controllato uno per uno.' },
    es: { logo: 'Una esfera {dial}, impresa y revisada una por una.',
          custom: 'Una esfera {dial} con su propia firma, impresa y revisada una por una.' },
    nl: { logo: 'Een {dial} wijzerplaat, stuk voor stuk bedrukt en gecontroleerd.',
          custom: 'Een {dial} wijzerplaat met je eigen signatuur, stuk voor stuk bedrukt en gecontroleerd.' },
    pt: { logo: 'Um mostrador {dial}, impresso e verificado um a um.',
          custom: 'Um mostrador {dial} com a sua própria assinatura, impresso e verificado um a um.' }
  };
  var RE_BEZEL = /bezel|lunette|lünette|luenette|lunetta|bisel|inzetstuk/i;
  var RE_DIAL = /dial|cadran|zifferblatt|quadrante|esfera|wijzerplaat|mostrador/i;
  var RE_DIAL_NOT = /logo|signature|text|design|engrav|upload|size|taille|date/i;
  /* v5.11 : un libelle qui parle de COULEUR reste une couleur de cadran, meme s'il
     mentionne le logo. La Modena pose la question "Dial Color No Logo", que la regle
     ci-dessus ecartait, et sa section cadran disparaissait. */
  var RE_COULEUR = /colou?r|couleur|farbe|colore|kleur|cor\b/i;
  /* v5.10 : la question qui porte la signature du cadran, et celle qui porte le texte
     que le client y ecrit. On ecarte les gravures de boitier et de fond, qui sont d'autres
     champs de texte. */
  var RE_DIALSIGN = /dial logo|logo du cadran|zifferblatt-?logo|logo del quadrante|logo de la esfera|wijzerplaatlogo|logo do mostrador/i;
  /* « Custom Text » et ses traductions : le choix de mettre SON texte sur le cadran. */
  var RE_TEXTE_CHOISI = /custom text|texte personnalis|benutzerdefinierter text|eigener text|testo personalizzato|texto personalizado|aangepaste tekst|texto personalizado/i;
  var RE_TEXTE = /engraving text|gravurtext|texte.*grav|grav.*texte|testo.*incis|texto.*grabad|graveertekst|dial text|texte du cadran|zifferblatttext|texto de la esfera|testo del quadrante|tekst op de wijzerplaat|texto do mostrador/i;
  var RE_TEXTE_NOT = /case ?back|case ?side|fond|boden|lato|caja|kast|arc|center|centre|bogen|flanc|seite|lateral|zijkant/i;
  /* v5.17 : la couleur que le client donne au texte du cadran. Chez Kickflip la question
     s'appelle « Logo Color » (elle pilote le texte comme le logo). Sa valeur est un
     hexadecimal des qu'il choisit une couleur ; tant qu'il n'y touche pas, elle vaut
     l'intitule d'invite (« Pick a color », « Choisissez une couleur »...) et c'est Kickflip
     qui decide. Verifie sur 265 designs portant un texte : quand la valeur est un
     hexadecimal, elle est celle du texte imprime. */
  var RE_COULEUR_TEXTE = /logo colou?r|couleur du logo|logo-?farbe|colore del logo|color del logotipo|logokleur|kleur van het logo|cor do logo/i;
  var RE_HEX = /^#(?:[0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i;
  /* v6.24 : lignes techniques du recapitulatif, memes regles que snippets/line-item-drawer.liquid
     (08/09) : drapeau du configurateur (« Custom Text »), code hexadecimal, porte de section
     (« Add engraving »), adresse de fichier, utilitaire « save my design ». Et les cles de gravure,
     dont le texte sort du tableau pour aller en tete. */
  var RE_GRAV_CLE = /engrav|grav|incis|grabad|dial text|side text|arc text|texte du cadran|zifferblatttext|texto de la esfera|testo del quadrante|tekst op de wijzerplaat|texto do mostrador/i;
  /* 24/09 : le sens de la gravure du bas (« Upright (readable) ») n'est pas un texte a relire. */
  var RE_GRAV_NOT = /direction|sens de la|ausrichtung|sentido|orientamento|richting/i;
  var DRAPEAUX = ['custom text', 'custom', 'personalized', 'personalised', 'personal text', 'personal', 'texte personnalisé', 'personnalisé', 'benutzerdefinierter text', 'individueller text', 'individuell', 'individuelle gravur', 'texto personalizado', 'testo personalizzato', 'aangepaste tekst', 'custom engraving', 'gravure personnalisée', 'custom upload', 'design hochladen', 'upload design', 'télécharger un design', 'wählen sie eine farbe', 'pick a color', 'choose a color', 'choisissez une couleur', 'untitled answer', 'réponse sans titre', 'antwort ohne titel', 'risposta senza titolo', 'respuesta sin título', 'antwoord zonder titel', 'resposta sem título'];
  var PORTES = ['add engraving', 'add caseback engraving', 'add custom engraving', 'ajouter une gravure', 'gravur hinzufügen', 'aggiungi incisione', 'añadir grabado', 'gravure toevoegen', 'adicionar gravação', 'no engraving', 'aucune gravure', 'sans gravure', 'keine gravur', 'nessuna incisione', 'sin grabado', 'geen gravure', 'sem gravação', 'no branding', 'bespoke - back', 'none', 'aucun', 'aucune', 'yes', 'oui', 'ja', 'sí', 'si', '-', '\u2014'];
  function ligneTechnique(k, v) {
    var kb = String(k || '').toLowerCase(), vb = String(v || '').trim().toLowerCase();
    if (!vb) return true;
    if (RE_HEX.test(vb)) return true;
    if (/^https?:\/\//i.test(vb)) return true;
    if (/save my design|sauvegarder mon design|design für später|design voor later|diseño para más tarde|design per dopo|design para depois/.test(kb)) return true;
    if (DRAPEAUX.indexOf(vb) !== -1) return true;
    if (PORTES.indexOf(vb) !== -1 && (RE_GRAV_CLE.test(kb) || /logo|brand|caseback|case back|fond/.test(kb))) return true;
    return false;
  }

  /* "Chrono Mod" n'est pas traduit : c'est le repere le plus sur pour reconnaitre la
     signature maison parmi des reponses qui, elles, changent de langue. */
  var RE_MAISON = /chrono\s*mod/i;

  /* v6.40 (22/09/2026, demande Lino) : GARDE-FOU MARQUES DEPOSEES.
     Des clients ecrivent « Tudor Geneve », « Rolex »... sur le cadran ou en gravure. Aucune montre ne
     doit porter la marque d un tiers (mise en demeure Seiko de 2025). Seules les valeurs des champs
     TEXTE sont lues (cle qui parle de texte ou de gravure) : les reponses du configurateur, mouvement ou
     bracelet, ne sont jamais testees, sinon une reponse nommant le mouvement bloquerait toutes les
     commandes. Comparaison par mots entiers, sans accents ni ponctuation (« Day-Date » = « day date »).
     « Swiss » et « Suisse » sont bloques : indication d origine protegee, et fausse pour ces montres.
     Les logos televerses (images) ne se lisent pas : ils restent au controle avant fabrication. */
  var MARQUES = ['rolex', 'tudor', 'omega', 'seiko', 'grand seiko', 'patek', 'patek philippe', 'audemars', 'audemars piguet', 'piguet', 'cartier', 'breitling', 'tag heuer', 'heuer', 'panerai', 'hublot', 'iwc', 'longines', 'tissot', 'jaeger lecoultre', 'lecoultre', 'vacheron', 'vacheron constantin', 'blancpain', 'breguet', 'chopard', 'bvlgari', 'bulgari', 'richard mille', 'swatch', 'casio', 'g shock', 'montblanc', 'rado', 'nomos', 'glashutte', 'a lange', 'lange sohne', 'submariner', 'daytona', 'datejust', 'day date', 'daydate', 'gmt master', 'yacht master', 'yachtmaster', 'sea dweller', 'seadweller', 'oyster perpetual', 'cosmograph', 'milgauss', 'nautilus', 'aquanaut', 'royal oak', 'speedmaster', 'seamaster', 'navitimer', 'black bay', 'pelagos', 'superlative chronometer', 'swiss made', 'swiss', 'suisse'];
  var RE_CHAMP_TEXTE = /text|texte|tekst|testo|texto|gravur|grav|engrav|incis|grabad|initial/i;
  function normaliseMarque(s) {
    var t = String(s || '');
    try { t = t.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) {}
    return ' ' + t.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim() + ' ';
  }
  function marqueInterdite(options) {
    var trouve = null;
    (options || []).forEach(function (p) {
      if (trouve || !p) return;
      var k = String(p[0] || ''), v = String(p[1] || '').trim();
      if (!v || !RE_CHAMP_TEXTE.test(k)) return;
      if (RE_HEX.test(v) || /^https?:\/\//i.test(v)) return;
      if (DRAPEAUX.indexOf(v.toLowerCase()) !== -1) return;
      var n = normaliseMarque(v);
      for (var i = 0; i < MARQUES.length; i++) {
        if (n.indexOf(' ' + MARQUES[i] + ' ') !== -1) { trouve = MARQUES[i]; return; }
      }
    });
    return trouve;
  }
  function nomMarque(m) {
    return String(m).split(' ').map(function (w) { return w.length <= 3 ? w.toUpperCase() : w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
  }
  var COPY_MARQUE = {
    en: 'Your text contains a registered trademark ({m}). We cannot put another brand\u2019s name on your watch: change your text to order. If this is a mistake, write to us.',
    fr: 'Votre texte contient une marque d\u00e9pos\u00e9e ({m}). Nous ne pouvons pas mettre le nom d\u2019une autre marque sur votre montre : modifiez votre texte pour commander. Si c\u2019est une erreur, \u00e9crivez-nous.',
    de: 'Ihr Text enth\u00e4lt eine eingetragene Marke ({m}). Wir k\u00f6nnen keinen fremden Markennamen auf Ihre Uhr setzen: \u00e4ndern Sie Ihren Text, um zu bestellen. Falls das ein Irrtum ist, schreiben Sie uns.',
    it: 'Il tuo testo contiene un marchio registrato ({m}). Non possiamo mettere il nome di un altro marchio sul tuo orologio: modifica il testo per ordinare. Se \u00e8 un errore, scrivici.',
    es: 'Su texto contiene una marca registrada ({m}). No podemos poner el nombre de otra marca en su reloj: cambie el texto para hacer el pedido. Si es un error, escr\u00edbanos.',
    nl: 'Je tekst bevat een geregistreerd merk ({m}). We kunnen de naam van een ander merk niet op je horloge zetten: pas je tekst aan om te bestellen. Is dit een vergissing, stuur ons dan een bericht.',
    pt: 'O seu texto cont\u00e9m uma marca registada ({m}). N\u00e3o podemos colocar o nome de outra marca no seu rel\u00f3gio: altere o texto para encomendar. Se for um erro, escreva-nos.'
  };

  /* v5.10 : dimensions. Le diametre du boitier est choisi par le client, donc toujours juste.
     Le reste n'est renseigne que la ou la donnee est sourcee ; ailleurs, rien ne s'affiche
     plutot qu'une valeur deduite. */
  /* dial   : diametre du cadran, lu sur le dossier de calques d'ou vient l'image (factuel)
     lug    : entrecorne selon la taille de boitier choisie
     lugFixe: entrecorne des masters a taille unique   } sources wiki, a faire confirmer
     boitier: diametre des masters a taille unique     }
     Un master absent de cette table n'affiche simplement pas la ligne. */
  /* Releve des fiches produit de la boutique, qui sont la reference annoncee au client.
     dial n'apparait que la ou la fiche donne le diametre du cadran.
     Un bracelet integre (Apex, LandMaster) n'a pas d'entrecorne a annoncer. */
  /* Cotes verifiees contre les 86 fiches produit le 28/08, puis CORRIGEES par Lino la ou les
     fiches se trompent : deptmaster, gmt et horizon font 40 mm (titane compris) et non 41, et
     le cadran Horizon fait 30,5 mm. Les fiches produit annoncant 41 mm sont fausses, y compris
     quand elles sont 8 sur 9 a le dire : le nombre de fiches d'accord mesure la propagation
     d'un copier-coller, pas la verite d'une cote.
     marina-guard, searanger et oceanmaster n'affichent pas de diametre de cadran, aucune de
     leurs fiches ne l'annonce. Apex n'a pas d'entrecorne : son bracelet est reellement integre
     et sans cote annoncee. */
  var DIMENSIONS = {
    'classic-date': { boitier: '39 mm', dial: '28.5 mm', lug: { '36mm': '20 mm', '39mm': '20 mm' }, lugFixe: '20 mm' },
    'deptmaster':   { boitier: '40 mm', dial: '28.5 mm', lugFixe: '20 mm' },
    'gmt':          { boitier: '40 mm', dial: '28.5 mm', lugFixe: '20 mm' },
    'modena':       { boitier: '39.3 mm', dial: '29 mm', lugFixe: '20 mm' },
    'apex':         { boitier: '41 mm', dial: '28.5 mm' },
    'horizon':      { boitier: '40 mm', dial: '30.5 mm', lugFixe: '25 mm' },
    'odyssey':      { boitier: '42 mm', dial: '29.5 mm', lugFixe: '21 mm' },
    'lady-date':    { boitier: '31 mm', dial: '24.5 mm', lugFixe: '20 mm' },
    'landmaster':   { boitier: '39.5 mm', dial: '33.8 mm', lugFixe: '20 mm' },
    'marina-guard': { boitier: '40 mm', dial: '28.5 mm' },
    'oceanmaster':  { boitier: '41 mm', dial: '31 mm', lugFixe: '20 mm' },
    'searanger':    { boitier: '42 mm', dial: '28.5 mm', lugFixe: '22 mm' }
  };
  /* Handles dont le master ne peut pas se deduire du nom. Compares par egalite EXACTE : un
     test par prefixe ferait aussi matcher deptmaster-titanium-black-diver, qui est un vrai
     DeptMaster. Un seul cas sur les 68 fiches du catalogue (verifie le 28/08). */
  var HANDLES_A_PART = {
    /* Les deux Modena a boitier carbone. Le handle deptmaster-titanium-black qui vivait ici
       etait un vestige : le produit a ete renomme le 30/08 et ce handle ne resout plus rien.
       Cotes du 05/09/2026 (Lino) : 38.4 mm de boitier contre 39.3 mm en acier. */
    'modena-forged-carbon-chronograph': { boitier: '38.4 mm', dial: '29 mm', lugFixe: '20 mm' },
    'modena-carbon-yellow-chronograph': { boitier: '38.4 mm', dial: '29 mm', lugFixe: '20 mm' }
  };
  /* v6.4 (06/09/2026) : le bloc SPECIFICATIONS de la fenetre. Il ne repete JAMAIS le tableau
     Configuration : le cadran, les aiguilles et le type de bracelet sont des choix du client,
     ils vivent au-dessus. Ici ne vivent que les cotes et les matieres, c'est a dire ce que la
     configuration ne dit pas. Une donnee absente = pas de ligne, jamais de valeur deduite.
       ep      epaisseur du boitier
       l2l     corne a corne
       fond    'acier' ou 'saphir', rendu DANS la ligne etancheite parce que c'est sa cause
       poignet plage de reglage du bracelet
       poids   sur la configuration la plus courante */
  /* Cotes et poids mesures par Lino le 07/09/2026, atelier, pied a coulisse et balance.
     poids       : configuration a bracelet metal, celle des fiches catalogue
     poids_caout : la meme montre sur bracelet caoutchouc ou cuir. Un bracelet acier pese
                   30 a 50 g de plus, donc annoncer un seul poids pour les deux est faux.
                   Absent = le master n'a pas d'option souple, ou la valeur n'est pas mesuree. */
  var FICHE = {
    'modena':       { ep: '12.5 mm', l2l: '48 mm', fond: 'acier', poignet: '14.5 - 22 cm', poids: '150 g', poids_caout: '100 g' },
    'deptmaster':   { ep: '13.5 mm', fond: 'acier', poignet: '14.5 - 22 cm', poids: '140 g', poids_caout: '110 g' },
    'gmt':          { ep: '13.5 mm', l2l: '48 mm', fond: 'acier', poignet: '14.5 - 22 cm', poids: '140 g', poids_caout: '115 g' },
    'classic-date': { ep: '12.5 mm', l2l: '48 mm', fond: 'acier', poignet: '14.5 - 22 cm', poids: '140 g', poids_caout: '100 g' },
    'lady-date':    { ep: '12 mm', l2l: '39 mm', fond: 'acier', poids: '90 g' },
    'horizon':      { ep: '12 mm', l2l: '47.5 mm', fond: 'saphir', poids_caout: '110 g' },
    'odyssey':      { ep: '12.5 mm', l2l: '49.7 mm', fond: 'saphir', poids: '140 g' },
    'apex':         { ep: '13 mm', l2l: '52.5 mm', fond: 'saphir', poids: '145 g', poids_caout: '110 g' },
    'landmaster':   { ep: '12 mm', l2l: '47.5 mm', fond: 'saphir', poignet: '14.5 - 22 cm', poids: '140 g' },
    'marina-guard': { ep: '12 mm', l2l: '49 mm', fond: 'saphir', poids_caout: '110 g' },
    'searanger':    { ep: '14.5 mm', l2l: '46 mm', fond: 'acier', poids: '115 g', poids_caout: '110 g' },
    'oceanmaster':  { ep: '13.5 mm', l2l: '48 mm', poids: '145 g', poids_caout: '110 g' }
  };
  var FICHE_A_PART = {
    'modena-forged-carbon-chronograph': { ep: '12.46 mm', l2l: '46 mm', fond: 'acier', poids: '70 g' },
    'modena-carbon-yellow-chronograph': { ep: '12.46 mm', l2l: '46 mm', fond: 'acier', poids: '70 g' }
  };
  /* Les libelles du bloc, 7 langues. Courts : la colonne de gauche fait 44 % de la largeur. */
  var LIB_SPEC = {
    en: { mvt: 'Movement', titre: 'Specifications', boitier: 'Case', brac: 'Bracelet', diam: 'Diameter', ep: 'Thickness', l2l: 'Lug to lug', cadran: 'Dial',
          lug: 'Strap width', verre: 'Crystal', eau: 'Water resistance', poignet: 'Wrist size', poids: 'Weight' },
    fr: { mvt: 'Mouvement', titre: 'Spécifications', boitier: 'Boîtier', brac: 'Bracelet', diam: 'Diamètre', ep: 'Épaisseur', l2l: 'Corne à corne', cadran: 'Cadran',
          lug: 'Entrecorne', verre: 'Verre', eau: 'Étanchéité', poignet: 'Poignet', poids: 'Poids' },
    de: { mvt: 'Uhrwerk', titre: 'Spezifikationen', boitier: 'Gehäuse', brac: 'Armband', diam: 'Durchmesser', ep: 'Höhe', l2l: 'Bandanstoß zu Bandanstoß', cadran: 'Zifferblatt',
          lug: 'Bandbreite', verre: 'Glas', eau: 'Wasserdichtheit', poignet: 'Handgelenk', poids: 'Gewicht' },
    it: { mvt: 'Movimento', titre: 'Specifiche', boitier: 'Cassa', brac: 'Bracciale', diam: 'Diametro', ep: 'Spessore', l2l: 'Da ansa ad ansa', cadran: 'Quadrante',
          lug: 'Larghezza cinturino', verre: 'Vetro', eau: 'Impermeabilità', poignet: 'Polso', poids: 'Peso' },
    es: { mvt: 'Movimiento', titre: 'Especificaciones', boitier: 'Caja', brac: 'Brazalete', diam: 'Diámetro', ep: 'Grosor', l2l: 'De asa a asa', cadran: 'Esfera',
          lug: 'Entre asas', verre: 'Cristal', eau: 'Resistencia al agua', poignet: 'Muñeca', poids: 'Peso' },
    nl: { mvt: 'Uurwerk', titre: 'Specificaties', boitier: 'Kast', brac: 'Band', diam: 'Diameter', ep: 'Dikte', l2l: 'Lug to lug', cadran: 'Wijzerplaat',
          lug: 'Bandbreedte', verre: 'Glas', eau: 'Waterdichtheid', poignet: 'Pols', poids: 'Gewicht' },
    pt: { mvt: 'Movimento', titre: 'Especificações', boitier: 'Caixa', brac: 'Bracelete', diam: 'Diâmetro', ep: 'Espessura', l2l: 'Entre asas', cadran: 'Mostrador',
          lug: 'Largura da bracelete', verre: 'Vidro', eau: 'Resistência à água', poignet: 'Pulso', poids: 'Peso' }
  };
  /* Le fond de boitier est rendu DANS la ligne etancheite : c'est la raison du chiffre, et une
     limite expliquee se vend mieux qu'une limite subie. */
  var FOND = {
    en: { acier: 'solid steel case back, screw-down crown', saphir: 'sapphire case back, no swimming' },
    fr: { acier: 'fond acier plein, couronne vissée', saphir: 'fond saphir, pas de nage' },
    de: { acier: 'massiver Stahlboden, verschraubte Krone', saphir: 'Saphirboden, nicht zum Schwimmen' },
    it: { acier: 'fondello in acciaio pieno, corona a vite', saphir: 'fondello in zaffiro, non per nuotare' },
    es: { acier: 'fondo de acero macizo, corona a rosca', saphir: 'fondo de zafiro, no apto para nadar' },
    nl: { acier: 'massieve stalen kastbodem, schroefkroon', saphir: 'saffieren kastbodem, niet zwemmen' },
    pt: { acier: 'fundo em aço maciço, coroa aparafusada', saphir: 'fundo em safira, não nadar' }
  };
  var OUTIL = { en: 'tool included', fr: 'outil inclus', de: 'Werkzeug enthalten', it: 'attrezzo incluso',
                es: 'herramienta incluida', nl: 'gereedschap inbegrepen', pt: 'ferramenta incluída' };
  /* Le client a-t-il choisi un bracelet souple ? On lit la reponse bracelet deja isolee par
     findParts, jamais la question de COULEUR de bracelet, qui dirait « Obsidienne » sans dire
     la matiere. Les sept langues de la boutique plus les libelles Kickflip. */
  var RE_SOUPLE = /rubber|caoutchouc|silicone|gummi|kautschuk|rubberen|borracha|caucho|goma|cuir|leather|leder|pelle|cuero|couro|flex|nato|tissu|nylon|canvas|toile|lona|tela|segeltuch|croco|kroko|cocco|stitched|cousu|genäht|genaeht|cosido|cucito|gestikt/i;
  function bracSouple(options) {
    var parts = findParts(options);
    var trouve = false;
    (parts.straps || []).forEach(function (pp) {
      if (!trouve && RE_SOUPLE.test(String(pp[1] || ''))) trouve = true;
    });
    return trouve;
  }
  /* De quoi est fait le bracelet CHOISI. On lit la reponse bracelet deja isolee par findParts,
     puis on tranche dans cet ordre : titane (le libelle le dit), cuir, caoutchouc, sinon metal.
     Le nato et le nylon ne rendent rien : mieux vaut une ligne absente qu'une ligne fausse. */
  var RE_TITANE = /titan/i;
  var RE_CUIR = /cuir|leather|leder|pelle|cuero|couro|croco|kroko|cocco|stitched|cousu|genäht|genaeht|cosido|cucito|gestikt/i;
  var RE_CAOUT = /rubber|caoutchouc|silicone|gummi|kautschuk|rubberen|borracha|caucho|goma|flex/i;
  var RE_NATO = /nato|nylon|tissu|fabric|stoff|canvas|toile|lona|tela|segeltuch/i;
  function matiereBracelet(handle, l, options) {
    var parts = findParts(options), reps = [];
    (parts.straps || []).forEach(function (pp) {
      var v = String(pp[1] || '');
      if (v) reps.push(v);
    });
    if (!reps.length) return null;
    /* On lit TOUTES les reponses bracelet, pas seulement la premiere. La Modena en pose deux
       (« Strap Type » et « Bracelet ») et l'ordre des options n'est pas garanti : avec un seul
       coup d'oeil, « Strap Type: Oyster » suivi de « Bracelet: Oyster Flex » annoncait un
       bracelet acier 904L sur une montre livree en caoutchouc. Le poids, lui, scannait deja
       toute la liste, d'ou deux lignes du meme bloc qui se contredisaient.
       La matiere la plus specifique gagne : une reponse souple ou en titane l'emporte sur un
       libelle metal, parce qu'un nom de modele comme « Oyster Flex » dit la matiere et que
       « Oyster » tout seul ne dit rien de plus que la forme. */
    function une(re) {
      for (var i = 0; i < reps.length; i++) { if (re.test(reps[i])) return true; }
      return false;
    }
    if (une(RE_TITANE)) return TITANE[l];
    if (une(RE_CUIR)) return CUIR[l];
    if (une(RE_CAOUT)) return CAOUT[l];
    if (une(RE_NATO)) return null;
    var key = null;
    for (var k in BRAC_316) { if (handle === k || handle.indexOf(k + '-') === 0) { key = k; break; } }
    return key ? ACIER[l] : ACIER904[l];
  }
  /* Les questions bracelet en double. Le configurateur Modena en pose quatre pour une seule
     piece : « Strap Type: Rubber », « Rubber Strap: Rubber », « Rubber Strap Color: Obsidian »
     et « Bracelet: Oyster Flex ». Trois disent la meme chose, une seule apprend quelque chose.
     En acier c'est pire : « Strap Type: Oyster » puis « Bracelet: Oyster », mot pour mot, et
     c'est ce doublon que Lino voit dans le recap. On garde la reponse la plus specifique, la
     derniere a egalite, et on jette les echos. Le tri se fait ICI et pas dans Kickflip :
     toucher aux questions du configurateur, c'est toucher aux regles, et on connait le prix
     (juillet 2026, 128 regles retirees). Les onze autres masters ne posent qu'une question
     bracelet, verifie sur les commandes reelles du 05 au 08/09 : ce filtre ne les touche pas. */
  var RE_BRAC_GEN = /^(rubber|caoutchouc|silicone|kautschuk|gummi|borracha|caucho|goma|leather|cuir|leder|pelle|cuero|couro|metal|steel|acier|stahl|acciaio|acero)$/i;
  function optionsUniques(options) {
    var list = options || [], idx = [];
    list.forEach(function (pp, i) {
      var k = pp[0] || '', kc = canon(k);
      if ((RE_STRAP.test(k) || /bracelet|strap/.test(kc)) &&
          !RE_STRAP_NOT.test(k) && !RE_STRAP_NOT.test(kc)) idx.push(i);
    });
    if (idx.length < 2) return list;
    var best = idx[0];
    idx.forEach(function (i) {
      var v = String(list[i][1] || '').trim(), b = String(list[best][1] || '').trim();
      var vg = RE_BRAC_GEN.test(v), bg = RE_BRAC_GEN.test(b);
      if (bg && !vg) best = i;
      else if (bg === vg && v.length >= b.length) best = i;
    });
    return list.filter(function (pp, i) { return i === best || idx.indexOf(i) === -1; });
  }
  /* Retourne la liste [libelle, valeur] du bloc, ou null si le master n'a rien de sourcé. */
  function ficheSpecs(handle, l, options) {
    var d = dimsFor(handle) || {};
    var key = null;
    for (var k in FICHE) { if (handle === k || handle.indexOf(k + '-') === 0) { key = k; break; } }
    var f = FICHE_A_PART[String(handle || '')] || (key ? FICHE[key] : null);
    if (!f) f = {};
    /* la finition choisie peut changer les cotes : meme table de regles que la carte d'identite */
    var choix = key ? varianteMaster(key, options) : null;
    /* la taille de boitier CHOISIE prime sur celle de la table : sans ce test, une Classic Date
       configuree en 36 mm affichait les 39 mm du modele par defaut, sur l ecran ou le client paie.
       tailleBoitier rend la reponse brute (« 36mm ») : on lui rend son espace pour l affichage. */
    var taille = tailleBoitier(options);
    var cle = taille ? String(taille).replace(/\s+/g, '').toLowerCase() : null;
    var diam = (choix && choix.boitier) ||
               (taille ? String(taille).replace(/\s*mm/i, ' mm').replace(/^\s+/, '') : null) ||
               d.boitier;
    var ep = (choix && choix.ep) || f.ep;
    /* le poids suit le BRACELET CHOISI. Un Oyster acier pese 30 a 50 g de plus qu'un caoutchouc :
       annoncer un seul chiffre, c'est mentir a la moitie des clients. La variante (titane, carbone)
       prime, parce qu'elle change la matiere du boitier lui-meme. */
    var poids = (choix && choix.poids) ||
                (f.poids_caout && bracSouple(options) ? f.poids_caout : f.poids);
    var fond = (choix && choix.fond) || f.fond;
    /* une cote que la variante met a null DISPARAIT : le carbone Modena n a jamais eu sa corne a
       corne mesuree, il ne doit pas heriter des 48 mm de l acier. */
    var l2l = (choix && Object.prototype.hasOwnProperty.call(choix, 'l2l')) ? choix.l2l : f.l2l;
    var entre = (d.lug && cle && d.lug[cle]) || d.lugFixe;
    var L = LIB_SPEC[l] || LIB_SPEC.en;
    var eau = null, sp = specsFor(handle, l, options);
    if (sp && sp[2]) eau = sp[2].replace(SAPHIR[l] + ', ', '');
    if (eau && fond && FOND[l]) eau += ' · ' + FOND[l][fond];
    var out = [];
    /* la matiere du boitier OUVRE le bloc : elle change avec la configuration (acier, titane,
       carbone forge) et la carte d'identite, seule a la porter jusqu'ici, tient en une ligne
       grise que le client ne relit pas. */
    /* v6.25 (13/09, Lino) : le mouvement ouvre la fiche, avec son calibre quand il est certain.
       C est la premiere question qu on nous pose, et la premiere cause de retour (Modena). */
    if (sp && sp[0] && L.mvt) out.push([L.mvt, sp[0]]);
    if (sp && sp[1]) out.push([L.boitier, sp[1]]);
    if (diam) out.push([L.diam, diam]);
    if (ep) out.push([L.ep, ep]);
    if (l2l) out.push([L.l2l, l2l]);
    if (d.dial) out.push([L.cadran, d.dial]);
    var mb = matiereBracelet(handle, l, options);
    if (mb) out.push([L.brac, mb]);
    if (entre) out.push([L.lug, entre]);
    if (SAPHIR[l]) out.push([L.verre, SAPHIR[l]]);
    if (eau) out.push([L.eau, eau]);
    if (f.poignet) out.push([L.poignet, f.poignet + ' (' + (OUTIL[l] || OUTIL.en) + ')']);
    if (poids) out.push([L.poids, poids]);
    return out.length ? out : null;
  }
  function dimsFor(handle) {
    var exact = HANDLES_A_PART[String(handle || '')];
    if (exact) return exact;
    var bouts = String(handle || '').split('-');
    for (var i = bouts.length; i > 0; i--) {
      var k = bouts.slice(0, i).join('-');
      if (DIMENSIONS[k]) return DIMENSIONS[k];
    }
    return null;
  }
  function tailleBoitier(options) {
    var v = null;
    (options || []).forEach(function (p) {
      if (v) return;
      var kc = canon(p[0]);
      if (/case size/.test(kc) || /taille|size|gr[o0]sse|dimensioni|tama|grootte/i.test(p[0])) {
        if (/^\s*\d{2}(\.\d)?\s*mm/i.test(p[1] || '')) v = p[1];
      }
    });
    return v;
  }
  var RE_LOGO_URL = /^https?:\/\/\S+\.(png|jpe?g|webp|svg)(\?|$)/i;
  var RE_STRAP = /bracelet|strap|armband|cinturino|correa|bracciale|pulseira/i;
  var RE_STRAP_NOT = /hardware|color|colour|couleur|farbe|colore|kleur|cor$/i;
  var RE_CASE = /case|boîtier|boitier|gehäuse|gehaeuse|cassa|caja|kast|behuizing|caixa/i;
  var RE_CASE_NOT = /size|taille|größe|groesse|grootte|misura|tamaño|back|fond|logo|tamanho/i;

  /* Seuil unique du rendu FENETRE. Il vit ici et il est consomme a deux endroits, la chaine
     CSS ci-dessous et le matchMedia de render() : recopier la chaine ailleurs, c est se
     preparer un jour ou le JS et le CSS ne sont plus du meme cote de la frontiere.
     1100 et pas 901 : sous 1100 la carte occupe plus de 95 % de la fenetre, ce qui redonne la
     page pleine avec un lisere, et la bande composant compacte n a plus que 163 px de texte a
     cote de sa vignette de 210 px.
     min-height:640px : une fenetre ecrasee (outils de developpement ancres en bas) n a pas la
     place d une carte bornee, on repasse au plein ecran, qui lui fonctionne.
     pointer:fine : sans lui, un iPad en paysage (1180, 1194, 1366 px) recevrait la carte, dont
     le seul ascenseur est la colonne de droite ; le glissement du doigt sur l image de la
     montre, geste naturel sur tablette, ne ferait plus rien.
     Le meme texte est recopie dans le <style> de snippets/cm-favoris.liquid : les deux doivent
     bouger ensemble, un seul des deux donne un voile qui ne defile plus autour d un contenu qui
     n est pas borne. */
  var MQ_FENETRE = '(min-width:1000px) and (min-height:560px) and (pointer:fine)';
  /* un seul objet, evalue par le navigateur et non par une comparaison sur innerWidth : poser
     html{overflow:hidden} a l ouverture supprime l ascenseur classique et elargit la zone
     d affichage de 15 a 17 px sur Windows, donc une mesure JS et une media query peuvent se
     retrouver de deux cotes differents du seuil au moment meme de l ouverture. */
  var mqFenetre = window.matchMedia ? window.matchMedia(MQ_FENETRE) : null;

  var CSS = ".cm-mm{position:relative;min-height:100%;background:#fff;color:#1c1c1c;font-family:'Instrument Sans',system-ui,sans-serif;padding-bottom:88px}" +
    /* 44 px : minimum tactile, et une seule cible pour les deux ecrans. 16/16 la sort de
       l arrondi de 18 px, que l overflow de la carte raboterait. */
    '.cm-mm__close{position:absolute;top:16px;right:16px;width:44px;height:44px;border-radius:50%;border:1px solid #e3e3e3;background:#fff;color:#444;font-size:20px;line-height:1;cursor:pointer;z-index:5;box-shadow:0 2px 10px rgba(0,0,0,.08)}' +
    '.cm-mm__title{text-transform:uppercase;letter-spacing:.01em}' +
    '.cm-mm__close--libelle{position:absolute;top:14px;left:14px;right:auto;width:auto;height:38px;padding:0 14px 0 10px;border-radius:999px;display:inline-flex;align-items:center;gap:6px;font-size:13px;font-weight:600;color:#1c1c1c;white-space:nowrap;z-index:5}' +
    '.cm-mm__close-ch{font-size:22px;line-height:1;margin-top:-2px}' +
    '@media (max-width:900px){.cm-mm__close--libelle{left:10px;top:10px;height:34px;font-size:12.5px;padding:0 12px 0 9px}}' +
    /* v6.30 (14/09, Lino : « met une croix en haut a gauche bien affichee bien alignee pour quitter la
       fenetre ») : la croix de la fiche d un favori vit DANS la scene, en haut a gauche, en miroir
       exact des commandes de droite (.cm-mm__ctrl : loupe et partage) : meme retrait de 14 px (10 px
       sur telephone), meme rond de 38 px (34 px), meme bord, meme fond, meme ombre, meme trait
       d icone. Deux classes dans le selecteur : la regle doit battre .cm-mm__close, declaree plus
       haut avec la meme specificite, qui la poserait a droite en 44 px. */
    '.cm-mm__close.cm-mm__close--scene{top:14px;left:14px;right:auto;width:38px;height:38px;padding:0;display:flex;align-items:center;justify-content:center;border:1px solid #e3e3e3;border-radius:50%;background:rgba(255,255,255,.94);color:#1c1c1c;box-shadow:0 2px 8px rgba(0,0,0,.07);z-index:4;transition:border-color .15s ease,transform .15s ease}' +
    '.cm-mm__close.cm-mm__close--scene:hover{border-color:#bdbdbd;transform:translateY(-1px)}' +
    '.cm-mm__close.cm-mm__close--scene svg{width:20px;height:20px;display:block;pointer-events:none}' +
    '@media (max-width:900px){.cm-mm__close.cm-mm__close--scene{top:10px;left:10px;width:34px;height:34px}.cm-mm__close.cm-mm__close--scene svg{width:18px;height:18px}}' +
    '.cm-mm__buy-prixbloc{display:flex;flex-direction:column;gap:1px;min-width:0}' +
    '.cm-mm__buy-3x{display:inline-flex;align-items:center;gap:8px;font-size:12.5px;color:#666;white-space:nowrap;line-height:1}' +
    '.cm-mm__buy-3x strong{color:#1c1c1c;font-weight:600}' +
    '.cm-mm__sticky .cm-mm__buy-3x{flex:1 0 100%;justify-content:center;font-size:11px;margin:-4px 0 -2px}' +
    '.cm-mm__sticky .cm-mm__klarna{height:15px}' +
    '.cm-mm__klarna-wrap{display:inline-flex;align-items:center}' +
    '.cm-mm__klarna{height:18px;width:auto;display:block}' +
    '.cm-mm__gravure{margin:14px 0 4px;padding:12px 14px;border:1px solid #e6e6e6;border-radius:10px;background:#fafafa;max-width:660px}' +
    '.cm-mm__gravure .cm-mm__h2{margin-bottom:4px}' +
    '.cm-mm__gravure-item{display:flex;flex-direction:column;gap:1px;padding:4px 0}' +
    '.cm-mm__gravure-k{font-size:11px;color:#888}' +
    '.cm-mm__gravure-txt{font-size:15px;font-weight:600;color:#1c1c1c;white-space:pre-wrap;line-height:1.3}' +
    '.cm-mm__gravure-note{margin-top:6px;font-size:11.5px;color:#777}' +
    '.cm-mm__engagements{list-style:none;margin:12px 0 0;padding:10px 0 0;border-top:1px solid #f0f0f0;max-width:660px}' +
    '.cm-mm__engagements li{position:relative;font-size:13px;color:#333;padding:4px 0 4px 20px;line-height:1.35}' +
    '.cm-mm__opts.cm-mm__opts--conf{display:grid;grid-template-columns:1fr 1fr;gap:0 18px;columns:auto}' +
    '.cm-mm__opts.cm-mm__opts--conf li{display:flex;flex-direction:column;gap:2px;padding:8px 0;border-bottom:1px solid #eee;min-width:0}' +
    '.cm-mm__opts.cm-mm__opts--conf li span:first-child{font-size:10.5px;letter-spacing:.06em;text-transform:uppercase;color:#888;font-weight:500}' +
    '.cm-mm__opts.cm-mm__opts--conf li span:last-child{font-size:14px;font-weight:600;color:#1c1c1c;text-align:left;overflow-wrap:anywhere}' +
    '.cm-mm__engagements li:before{content:"\u2713";position:absolute;left:0;top:3px;font-weight:700;color:#1c1c1c}' +
    '.cm-mm__trust.cm-mm__trust--haut,.cm-mm__trust.cm-mm__trust--hero{display:flex;flex-wrap:wrap;gap:6px;border:0;padding:0;margin:12px 0 4px;font-size:11.5px}' +
    '.cm-mm__trust.cm-mm__trust--haut .cm-mm__trust-item,.cm-mm__trust.cm-mm__trust--hero .cm-mm__trust-item{display:inline-flex;align-items:center;gap:5px;padding:4px 9px 4px 7px;border:1px solid #e6e6e6;border-radius:999px;background:#fff;color:#333;line-height:1.2;white-space:nowrap}' +
    '@media (max-width:749px){.cm-mm__trust.cm-mm__trust--haut{gap:5px;margin:10px 0 2px}.cm-mm__trust.cm-mm__trust--haut .cm-mm__trust-item{font-size:11px;padding:4px 8px 4px 6px}}' +
    '.cm-mm__trust.cm-mm__trust--haut .cm-mm__trust-item:before,.cm-mm__trust.cm-mm__trust--hero .cm-mm__trust-item:before{content:"\u2713";color:#1a7a3c;font-weight:700;font-size:11px}' +
    '.cm-mm__trust.cm-mm__trust--hero{display:none;justify-content:center;padding:0 24px 14px;margin:0;flex:0 0 auto}' +
    '.cm-mm__inner{display:flex;align-items:stretch;max-width:none;margin:0;padding:0;text-align:left;min-height:100%}' +
    /* Le hero n est plus une boite de centrage mais une pile : la scene prend la place qui
       reste, le bloc d achat est colle dessous. C est le vide de 70 % que Lino designait,
       consomme par la seule chose qui merite d y etre. */
    '.cm-mm__hero{flex:0 0 auto;min-width:0;background:#fafafa;display:flex;flex-direction:column;padding:0;margin:0}' +
    '.cm-mm__stage{position:relative;flex:1 1 auto;min-height:0;display:flex;align-items:center;justify-content:center;padding:24px}' +
    /* v6.18 : les commandes de la scene, calquees sur celles du configurateur Kickflip que le
       client vient de quitter (meme icone, meme coin). La loupe sert la gravure : c'est le seul
       detail que la vignette de 420 px ne montre pas, et c'est celui qu'on relit trois fois. */
    '.cm-mm__ctrl{position:absolute;top:14px;right:14px;display:flex;gap:8px;z-index:4}' +
    '.cm-mm__ctrl button{width:38px;height:38px;padding:0;display:flex;align-items:center;justify-content:center;border:1px solid #e3e3e3;border-radius:50%;background:rgba(255,255,255,.94);color:#1c1c1c;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,.07);transition:border-color .15s ease,transform .15s ease}' +
    '.cm-mm__ctrl button:hover{border-color:#bdbdbd;transform:translateY(-1px)}' +
    '.cm-mm__ctrl svg{width:20px;height:20px;display:block;pointer-events:none}' +
    '@media (max-width:900px){.cm-mm__ctrl{top:10px;right:10px;gap:6px}.cm-mm__ctrl button{width:34px;height:34px}.cm-mm__ctrl svg{width:18px;height:18px}}' +
    /* la loupe passe AU-DESSUS de la couche favoris (500) et de sa demande de confirmation
       (10001) : elle s'ouvre depuis cette fenetre et doit la recouvrir entierement. */
    /* v6.19 : le zoom se fait DANS la scene, plus dans une couche plein ecran. La montre
       grossit sur place et le client la promene au doigt ou a la souris. */
    '.cm-mm__pile{transform-origin:50% 50%}' +
    '.cm-mm__stage--zoom{overflow:hidden;cursor:grab;touch-action:none}' +
    '.cm-mm__stage--zoom.est-tire{cursor:grabbing}' +
    /* la petite fenetre de partage, calquee sur celle du configurateur : un apercu, puis
       copier le lien, puis enregistrer l image. */
    '.cm-mm__pop{position:absolute;top:60px;right:14px;width:min(262px,78%);padding:10px;border-radius:12px;background:#fff;border:1px solid #ececec;box-shadow:0 12px 30px rgba(0,0,0,.14);z-index:6}' +
    '.cm-mm__pop-img{display:block;width:100%;max-width:none;height:auto;border-radius:8px;background:#fafafa;margin-bottom:4px}' +
    '.cm-mm__pop-act{display:flex;align-items:center;justify-content:space-between;gap:12px;width:100%;padding:9px 6px;border:0;background:none;color:#1c1c1c;font:500 14px/1.2 inherit;text-align:left;cursor:pointer;border-radius:8px}' +
    '.cm-mm__pop-act:hover{background:#f5f5f5}' +
    '.cm-mm__pop-ico svg{width:20px;height:20px;display:block}' +
    '.cm-mm__pop-url{display:block;width:100%;margin-top:6px;padding:7px 8px;border:1px solid #e3e3e3;border-radius:8px;font:400 12px/1.3 inherit;color:#444;background:#fafafa}' +
    '@media (max-width:900px){.cm-mm__pop{top:52px;right:10px}}' +
    /* align-items:center et le plafond de 520 px sur les enfants : mesure a l ecran en
       1440x900, sans eux le bloc fait 705 px de large et le bouton noir devient une BANDE de
       705 x 51, pas un bouton. Sur un 1920 il ferait 1045. Le plafond tient le prix, le coeur
       et le bouton dans une meme colonne centree sous la montre, ce qui les lit comme un seul
       objet au lieu de trois bords perdus. */
    '.cm-mm__buy{display:none;flex-direction:column;align-items:center;flex:0 0 auto;background:#fff;border-top:1px solid #ececec;padding:20px 40px 24px}' +
    '.cm-mm__buy .cm-mm__buy-top{width:100%;max-width:520px}' +
    /* Specificite 0,2,0 : a 0,1,0 la regle perdait contre .cm-mm-btn{width:100%}, declaree plus
       bas dans la meme feuille, et le coeur s etalait sur toute la largeur.
       Les deux classes sur le MEME element, et non un selecteur descendant partant de
       .cm-mm__buy : ce coeur vit dans DEUX conteneurs, le bloc sous la montre sur PC et la
       barre du bas sur telephone. Ancre a .cm-mm__buy, la regle ne s appliquait pas dans la
       barre, ou le coeur repassait a 100 % : mesure a 375 px, il partait de x=67 sur 98 px de
       large et passait SOUS le bouton noir qui commence a x=120 (retour Lino du 04/09). */
    '.cm-mm__buy-fav.cm-mm-btn{width:auto;flex:0 0 auto}' +
    '.cm-mm__buy .cm-mm__buy-btn{max-width:520px}' +
    '.cm-mm__buy-top{display:flex;align-items:center;gap:14px;margin:0 0 12px}' +
    '.cm-mm__buy-price{font-size:28px;font-weight:700;line-height:1;white-space:nowrap;letter-spacing:-.01em}' +
    '.cm-mm__buy-prixbloc{margin-right:auto}' +
    '.cm-mm__buy-fav{width:auto;flex:0 0 auto;padding:13px 16px;white-space:nowrap}' +
    '.cm-mm__buy-fav[data-on="1"]{color:#1a7a3c;border-color:#1a7a3c}' +
    '.cm-mm__buy-btn{width:100%;padding:16px 22px;font-size:15px}' +
    /* ctx.lienSecondaire : sous le bouton noir, centre, et plafonne au meme 520 px que le
       reste du bloc d achat, sinon il se centrerait sur toute la largeur de la carte et ne
       se lirait plus comme appartenant au bouton. */
    '.cm-mm__buy-lien{display:block;width:100%;max-width:520px;margin:10px auto 0;text-align:center}' +
    /* scrollbar-gutter : l ascenseur de Windows cessait de courir dans l arrondi de la carte. */
    '.cm-mm__col{flex:1 1 auto;min-width:0;padding:48px 44px 104px;overflow-y:auto;max-height:100vh;scrollbar-gutter:stable}' +
    '.cm-mm__col > *{max-width:660px;margin-left:0;margin-right:auto}' +
    '.cm-mm__comp-img--logo{container-type:inline-size}' +
    '.cm-mm__comp-dim{margin-top:8px;font-size:12.5px;color:#8a8a8a;letter-spacing:.02em}' +
    /* la croix occupe la bande 16-60 px du bord : sans cette reserve un titre long passe dessous. */
    '.cm-mm__head{margin:0 0 10px;padding-right:72px}' +
    '.cm-mm__comp{margin-left:0}' +
    '.cm-mm__comp-img--sig{position:relative;container-type:inline-size}' +
    '.cm-mm__dialsig{position:absolute;transform:translate(-50%,-50%);white-space:nowrap;font-family:"Vollkorn SC",Georgia,"Times New Roman",serif;font-weight:400;letter-spacing:normal;line-height:1;pointer-events:none;opacity:0;transition:opacity .18s ease}' +
    '.cm-mm__dialsig--vu{opacity:1}' +
    '.cm-mm__pastille{display:inline-block;width:11px;height:11px;border-radius:50%;border:1px solid rgba(0,0,0,.18);margin-right:7px;vertical-align:-1px}' +
    '.cm-mm__signature{margin-top:10px;padding:8px 12px;background:#fafafa;border:1px solid #f0f0f0;border-radius:8px;display:inline-flex;align-items:center;max-width:100%}' +
    '.cm-mm__signature-img{max-height:44px;max-width:170px;width:auto;height:auto;object-fit:contain;display:block}' +
    '.cm-mm__eyebrow{font-size:12px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#999;margin-bottom:8px}' +
    '.cm-mm__title{font-size:clamp(24px,3.4vw,34px);font-weight:700;margin:0 0 2px}' +
    /* ctx.meta : sous le titre, discret. Pas le sur-titre, dont les capitales espacees
       faisaient d une date de sauvegarde un titre de deux lignes au-dessus du nom du modele. */
    '.cm-mm__meta{font-size:12.5px;color:#8a8a8a;margin:4px 0 0;line-height:1.4}' +
    '.cm-mm__id{display:flex;flex-wrap:wrap;justify-content:flex-start;gap:4px 16px;margin:8px 0 0;max-width:640px;font-size:14px;color:#555}' +
    '.cm-mm__id span{position:relative}' +
    '.cm-mm__id span+span:before{content:"";display:inline-block;width:3px;height:3px;border-radius:50%;background:#ccc;vertical-align:middle;margin:0 12px 2px -12px}' +
    /* 420 et non 300 : c est la vraie reponse a « agrandis ». Le rendu source fait 250 px de
       cote, on est a 168 % : si la montre parait molle, c est un rendu 2x a demander a
       Kickflip, pas une regle CSS a pousser plus haut. */
    '.cm-mm__stage img{width:auto;max-width:min(86%,420px);max-height:100%;object-fit:contain}' +
    '.cm-mm__pile{position:relative;width:min(86%,420px);max-height:100%;aspect-ratio:1/1;flex:0 0 auto}' +
    '.cm-mm__pile img{position:absolute;inset:0;width:100%;height:100%;max-width:none;object-fit:contain}' +
    '.cm-mm__stage .cm-mm__pile img,.cm-mm--fenetre .cm-mm__stage .cm-mm__pile img{width:100%;height:100%;max-width:none;max-height:none}' +
    '.cm-mm__grav{position:absolute;inset:0;width:100%;height:100%;pointer-events:none}' +
    '.cm-mm__vues{display:flex;flex-wrap:wrap;justify-content:center;gap:10px;padding:0 24px 14px;flex:0 0 auto}' +
    '.cm-mm__vue{flex:0 0 auto;width:54px;height:54px;padding:4px;border:1px solid rgba(0,0,0,.1);border-radius:9px;background:#fff;cursor:pointer;transition:border-color .18s,transform .18s}' +
    '.cm-mm__vue:hover{border-color:rgba(0,0,0,.32);transform:translateY(-1px)}' +
    '.cm-mm__vue.est-actif{border-color:#111;border-width:1.5px}' +
    '.cm-mm__vue .cm-mm__pile{width:100%;aspect-ratio:1/1}' +
    '@media (max-width:900px){.cm-mm__vues{padding:0 18px 10px;gap:8px}.cm-mm__vue{width:46px;height:46px}}' +
    '.cm-mm__actions{max-width:420px;margin:44px 0 14px;padding-top:28px;border-top:1px solid #f0f0f0;display:flex;flex-direction:column;gap:10px}' +
    '.cm-mm-btn{display:inline-flex;align-items:center;justify-content:center;gap:9px;width:100%;padding:13px 22px;border-radius:12px;font-weight:700;font-size:15px;letter-spacing:.02em;cursor:pointer;border:0;font-family:inherit;text-decoration:none}' +
    '.cm-mm-btn--primary{background:#1c1c1c;color:#fff}' +
    '.cm-mm-btn--primary:hover{opacity:.9}' +
    '.cm-mm-btn--primary[disabled]{opacity:.55;cursor:wait}' +
    /* le disabled du moteur veut dire « ajout en cours », d ou cursor:wait. Avec ctx.cta il
       peut aussi vouloir dire « c est fait » : un etat stable ne doit pas promettre une
       attente. Seul le curseur change, le bouton reste le meme objet noir. */
    '.cm-mm-btn--primary[disabled][data-fait="1"]{cursor:default}' +
    '.cm-mm-btn--ghost{background:#fff;color:#1c1c1c;border:1px solid #d5d5d5}' +
    '.cm-mm-btn--ghost:hover{border-color:#1c1c1c}' +
    '.cm-mm__trust{display:flex;flex-wrap:wrap;justify-content:flex-start;gap:6px 22px;padding:10px 0;border-top:1px solid #f0f0f0;margin:0;font-size:11.5px;color:#666}' +
    '.cm-mm__h2{font-size:11.5px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:#999;margin:0 0 8px}' +
    '.cm-mm__specs{max-width:660px;margin:14px 0 0;border-top:1px solid #f0f0f0}' +
    '.cm-mm__specs>summary{list-style:none;cursor:pointer;padding:11px 0;font-size:12px;letter-spacing:.08em;text-transform:uppercase;color:#777;display:flex;align-items:center;justify-content:space-between}' +
    '.cm-mm__specs>summary::-webkit-details-marker{display:none}' +
    '.cm-mm__specs>summary:after{content:"+";font-size:15px;color:#aaa;line-height:1}' +
    '.cm-mm__specs[open]>summary:after{content:"\u2013"}' +
    '.cm-mm__specs .cm-mm__opts{padding-bottom:8px}' +
    '.cm-mm__opts{list-style:none;margin:0;padding:0;max-width:660px;text-align:left;columns:1}' +
    '.cm-mm__opts li{display:grid;grid-template-columns:minmax(0,44%) minmax(0,1fr);gap:14px;font-size:13px;padding:5px 0;border-bottom:1px solid #f4f4f4;break-inside:avoid}' +
    '.cm-mm__opts li span:first-child{color:#777}' +
    '.cm-mm__opts li span:last-child{font-weight:600;text-align:left}' +
    '.cm-mm__comp{display:flex;align-items:center;gap:30px;text-align:left;max-width:760px;margin:38px 0 0}' +
    '.cm-mm__comp-img{flex:0 0 44%;max-width:330px}' +
    '.cm-mm__comp-img img{width:100%;height:auto;display:block}' +
    '.cm-mm__comp-body{flex:1 1 auto}' +
    '.cm-mm__comp-eyebrow{font-size:12px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#999;margin:0 0 6px}' +
    '.cm-mm__comp-name{font-size:23px;font-weight:700;margin:0 0 10px;line-height:1.2}' +
    '.cm-mm__comp-text{margin:0;font-size:14.5px;line-height:1.65;color:#555}' +
    '.cm-mm__comp--compact{margin:26px 0 0;gap:34px;max-width:760px;align-items:center}' +
    '.cm-mm__comp--compact .cm-mm__comp-img{flex:0 0 210px;max-width:210px}' +
    '.cm-mm__comp--compact .cm-mm__comp-name{font-size:24px;margin-bottom:10px}' +
    '.cm-mm__comp--compact .cm-mm__comp-text{font-size:15px;line-height:1.6;max-width:520px}' +
    '.cm-mm__again{max-width:420px;margin:34px 0 0}' +
    /* flex-wrap : la barre porte au plus le prix, le coeur et le bouton, qui tiennent sur une
       rangee. Elle doit pouvoir en ouvrir une SECONDE pour ctx.lienSecondaire et pour le
       message d echec d ajout, tous deux declares en flex-basis 100 %. Sans lienSecondaire
       rien ne passe a la ligne et la barre est identique a ce qu elle etait. */
    '.cm-mm__sticky{position:fixed;left:0;right:0;bottom:0;display:flex;align-items:center;flex-wrap:wrap;gap:10px;padding:10px 14px calc(10px + env(safe-area-inset-bottom));background:rgba(255,255,255,.96);border-top:1px solid #ececec;backdrop-filter:blur(6px);z-index:500}' +
    /* meme etage que la couche, et pour la meme raison : sur /pages/my-watch la barre est
       posee directement sur la page, sans couche autour, donc son z-index compte pour de
       vrai. A 2147483647 elle passait par-dessus le menu deroulant du site. */
    '.cm-mm__sticky .cm-mm__buy-top{flex:0 0 auto;margin:0;gap:10px}' +
    '.cm-mm__sticky .cm-mm__buy-price{font-size:16px}' +
    '.cm-mm__sticky .cm-mm__buy-btn{flex:1;width:auto;padding:13px 20px;font-size:14.5px}' +
    '.cm-mm__sticky .cm-mm__buy-lien{flex:1 0 100%;width:auto;max-width:none;margin:0}' +
    '@media (max-width:430px){.cm-mm__buy-fav span{display:none}.cm-mm__buy-fav{padding:13px 13px}.cm-mm__sticky{gap:8px}}' +
    '@media (max-width:900px){.cm-mm__inner{flex-direction:column}.cm-mm__hero{flex:0 0 auto;max-width:none;width:100%}.cm-mm__stage{padding:18px}.cm-mm__stage img{max-width:88%;max-height:34vh}.cm-mm__pile{width:min(88%,34vh)}.cm-mm__col{max-height:none;overflow:visible;padding:26px 18px 40px}}' +
    '@media (max-width:749px){.cm-mm__opts{columns:1}.cm-mm__inner{padding:22px 16px 30px}' +
      '.cm-mm__comp{flex-direction:column;text-align:center;gap:16px;margin-top:30px}.cm-mm__comp-img{flex:none;max-width:260px;margin:0 auto}' +
      '.cm-mm__comp--compact{flex-direction:row;text-align:left;gap:16px}.cm-mm__comp--compact .cm-mm__comp-img{flex:0 0 130px;max-width:130px;margin:0}}' +
    '.cm-mm__kept{display:flex;align-items:center;justify-content:center;gap:8px;font-size:18px;font-weight:700;margin:0 0 4px;color:#1a7a3c}' +
    '.cm-mm__wait{font-size:17px;font-weight:700;margin:0 0 4px}' +
    '.cm-mm__mail{display:flex;gap:8px;flex-wrap:wrap}' +
    '.cm-mm__mail input{flex:1 1 170px;padding:12px 14px;border:1px solid #d5d5d5;border-radius:10px;font-size:14px;font-family:inherit}' +
    '.cm-mm__mail button{padding:12px 18px;border-radius:10px;background:#1c1c1c;color:#fff;border:0;font-weight:700;font-size:13.5px;cursor:pointer;font-family:inherit}' +
    '.cm-mm__hint{font-size:12px;color:#8a8a8a;margin:0;line-height:1.45}' +
    '.cm-mm__why{font-size:14px;color:#1c1c1c;margin:0 0 10px;line-height:1.45}' +
    '.cm-mm__consent{display:flex;align-items:flex-start;gap:9px;margin:12px 0 0;font-size:13px;color:#444;cursor:pointer;line-height:1.4}' +
    '.cm-mm__consent input{margin:1px 0 0;flex:0 0 auto;width:17px;height:17px;accent-color:#1c1c1c;cursor:pointer}' +
    '.cm-mm__sent{font-weight:700;color:#1a7a3c;font-size:13.5px}' +
    '.cm-mm__links{display:flex;gap:18px;justify-content:center;flex-wrap:wrap}' +
    '.cm-mm-link{background:none;border:0;padding:0;color:#666;font-size:13px;text-decoration:underline;cursor:pointer;font-family:inherit}' +
    '.cm-mm-link:hover{color:#1c1c1c}' +
    '@media ' + MQ_FENETRE + '{' +
      /* 94vw et non une largeur fixe : c est la largeur fixe qui fait revenir la plainte, une
         carte de 1280 est genereuse sur un 1440 et mesquine sur un 2100. Plafond a 1720, au-dela
         la largeur en plus n est que du gris. height:100% : le plafond de 760 abandonnait 92 px
         de voile sur B et ne servait a rien sur A, deja borne par le haut de page. */
      '.cm-mm--fenetre{display:flex;flex-direction:column;width:100%;width:min(94vw,1720px);min-width:0;max-height:100%;height:100%;min-height:0;margin:auto;overflow:hidden;padding-bottom:0;border-radius:18px;box-shadow:0 24px 60px rgba(0,0,0,.28)}' +
      '.cm-mm--fenetre .cm-mm__inner{flex:1 1 auto;min-height:0;overflow:hidden}' +
      /* le hero prend tout le pixel gagne, la colonne texte est une MESURE et non un
         pourcentage : a 1720 px un 58 % donnerait une colonne de 998 px illisible, payee pour
         du blanc puisque ses enfants sont deja plafonnes a 660. */
      '.cm-mm--fenetre .cm-mm__hero{flex:1 1 auto;min-height:0;overflow:hidden}' +
      '.cm-mm--fenetre .cm-mm__col{flex:0 0 clamp(560px,42%,680px);max-height:none;min-height:0;padding-bottom:40px;overscroll-behavior:contain}' +
      /* un seul conteneur d achat visible a la fois : c est ce qui rend le prix, le coeur et le
         bouton noir en double structurellement impossibles. */
      '.cm-mm--fenetre .cm-mm__buy{display:flex}' +
      /* v6.24 : l objet etait petit, pas le cadre (Marc, 04/09 et 13/09) : 560 px au lieu de 420 dans
         une colonne de 1 040. Et le 3x a droite du prix, meme ligne, zero pixel de hauteur. */
      '.cm-mm--fenetre .cm-mm__stage img{max-width:min(86%,560px)}' +
      '.cm-mm--fenetre .cm-mm__pile{width:min(86%,560px)}' +
      '.cm-mm--fenetre .cm-mm__buy-prixbloc{flex-direction:column;align-items:flex-start;gap:6px}' +
      '.cm-mm--fenetre .cm-mm__sticky{display:none}' +
    '}' +
    /* v6.24 : la ligne de confiance passe sous le bouton d achat quand la fenetre a la hauteur,
       et reste dans la colonne (sous la carte d identite) sur un portable. */
    '@media ' + MQ_FENETRE + ' and (min-height:1000px){' +
      '.cm-mm--fenetre .cm-mm__trust.cm-mm__trust--hero{display:flex}' +
      '.cm-mm--fenetre .cm-mm__trust.cm-mm__trust--haut{display:none}' +
    '}';
  var HEART_SVG = '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21.2l7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>';
  var HEART_FILL_SVG = '<svg viewBox="0 0 24 24" width="19" height="19" fill="#1a7a3c" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21.2l7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>';
  /* v6.24 : le libelle du theme cart.klarna.installment_suffix se termine par « avec », le logo suit. */
  var KLARNA_SVG = '<svg class="cm-mm__klarna" viewBox="0 0 1448 609" fill="none" role="img" aria-label="Klarna"><path d="M0 304.493C0 180.585 0 118.631 30.3995 74.5079C42.2947 57.2427 57.2427 42.2947 74.5079 30.3995C118.631 0 180.585 0 304.493 0H1142.75C1266.65 0 1328.61 0 1372.73 30.3995C1390 42.2947 1404.95 57.2427 1416.84 74.5079C1447.24 118.631 1447.24 180.585 1447.24 304.493C1447.24 428.402 1447.24 490.356 1416.84 534.479C1404.95 551.744 1390 566.692 1372.73 578.587C1328.61 608.987 1266.65 608.987 1142.75 608.987H304.494C180.585 608.987 118.631 608.987 74.5079 578.587C57.2427 566.692 42.2947 551.744 30.3995 534.479C0 490.356 0 428.402 0 304.493Z" fill="#FFA8CD"/><path d="M1166.17 389.005C1140.92 389.005 1121.24 368.125 1121.24 342.771C1121.24 317.416 1140.92 296.536 1166.17 296.536C1191.42 296.536 1211.1 317.416 1211.1 342.771C1211.1 368.125 1191.42 389.005 1166.17 389.005ZM1153.54 437.85C1175.08 437.85 1202.56 429.647 1217.79 397.581L1219.27 398.327C1212.59 415.851 1212.59 426.292 1212.59 428.902V433.003H1266.8V252.538H1212.59V256.64C1212.59 259.25 1212.59 269.69 1219.27 287.214L1217.79 287.96C1202.56 255.894 1175.08 247.691 1153.54 247.691C1101.93 247.691 1065.54 288.706 1065.54 342.771C1065.54 396.835 1101.93 437.85 1153.54 437.85ZM971.216 247.691C946.707 247.691 927.397 256.267 911.801 287.96L910.316 287.214C917 269.69 917 259.25 917 256.64V252.538H862.784V433.003H918.485V337.923C918.485 312.942 932.968 297.281 956.362 297.281C979.757 297.281 991.268 310.704 991.268 337.55V433.003H1046.97V318.162C1046.97 277.147 1015.03 247.691 971.216 247.691ZM782.203 287.96L780.717 287.214C787.401 269.69 787.401 259.25 787.401 256.64V252.538H733.186V433.003H788.887L789.258 346.126C789.258 320.772 802.626 305.484 824.536 305.484C830.477 305.484 835.305 306.23 840.875 307.722V252.538C816.366 247.318 794.457 256.64 782.203 287.96ZM605.073 389.005C579.821 389.005 560.14 368.125 560.14 342.771C560.14 317.416 579.821 296.536 605.073 296.536C630.324 296.536 650.005 317.416 650.005 342.771C650.005 368.125 630.324 389.005 605.073 389.005ZM592.447 437.85C613.985 437.85 641.464 429.647 656.689 397.581L658.174 398.327C651.49 415.851 651.49 426.292 651.49 428.902V433.003H705.706V252.538H651.49V256.64C651.49 259.25 651.49 269.69 658.174 287.214L656.689 287.96C641.464 255.894 613.985 247.691 592.447 247.691C540.83 247.691 504.439 288.706 504.439 342.771C504.439 396.835 540.83 437.85 592.447 437.85ZM426.828 433.003H482.53V172H426.828V433.003ZM385.981 172H329.165C329.165 218.608 300.572 260.368 257.125 290.197L240.043 302.129V172H181V433.003H240.043V303.62L337.706 433.003H409.747L315.797 309.213C358.501 278.266 386.352 230.166 385.981 172Z" fill="#0B051D"/></svg>';

  function ensureCss() {
    if (document.getElementById('cm-mm-css')) return;
    var st = document.createElement('style');
    st.id = 'cm-mm-css';
    st.textContent = CSS;
    (document.head || document.documentElement).appendChild(st);
  }
  /* v5.7.4 : nettoyage des textes AFFICHES, et d'eux seuls.
     - decodage des entites : le Liquid nous livre "&amp;" et textContent l'afficherait tel quel
       (jusqu'a trois passes, le double echappement s'observe reellement) ;
     - tiret cadratin proscrit sur la boutique : les valeurs du configurateur en portent
       ("Yellow Gold — Two-tone"), on le remplace par une espace.
     Les cles de la table de composants ne passent jamais par ici : elles gardent le cadratin. */
  var RE_ENT = /&(amp|lt|gt|quot|apos|nbsp|#\d{1,6}|#[xX][0-9a-fA-F]{1,5});/g;
  var ENT = { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", nbsp: ' ' };
  function decode(s) {
    for (var i = 0; i < 3 && s.indexOf('&') !== -1; i++) {
      var avant = s;
      s = s.replace(RE_ENT, function (t, n) {
        if (ENT[n]) return ENT[n];
        if (n.charAt(0) !== '#') return t;
        var c = n.charAt(1) === 'x' || n.charAt(1) === 'X'
          ? parseInt(n.slice(2), 16) : parseInt(n.slice(1), 10);
        return (c > 0 && c <= 0x10ffff) ? String.fromCharCode(c) : t;
      });
      if (s === avant) break;
    }
    return s;
  }
  /* v5.7.5 : "A Obsidian dial" -> "An Obsidian dial". Anglais seulement, et pas devant U,
     dont la prononciation anglaise appelle souvent "a". */
  function article(s) {
    if (lang() !== 'en') return s;
    return s.replace(/\bA (?=[AEIOaeio])/g, 'An ');
  }
  function texteClair(s) {
    if (typeof s !== 'string' || !s) return s;
    return decode(s).replace(/\s*—\s*/g, ' ').replace(/\s{2,}/g, ' ');
  }
  /* v5.8 : recherche en table insensible a la langue et a la ponctuation.
     - normalise() ramene un libelle a une forme comparable (sans accent ni tiret, minuscules) ;
     - canon() y ajoute le glossaire cm-i18n.js, qui ramene une valeur traduite a l'anglais ;
     - INDEX est la table de composants reindexee sur cette forme, construite une seule fois.
     Les cles composites gardent leurs separateurs : chaque segment est normalise a part. */
  var ACCENTS = /[\u0300-\u036f]/g;
  var PONCT = /[^a-z0-9]+/g;
  var NON_ASCII = /[^\x00-\x7F]/g;
  var TIRETS = /[\u2010-\u2015\u2212-]+/g;
  function normalise(s) {
    if (s === undefined || s === null) return '';
    s = String(s);
    try { s = s.normalize('NFD').replace(ACCENTS, ''); } catch (e) {}
    /* le glossaire est fabrique cote Python, ou l'encodage ASCII SUPPRIME ce qu'il ne sait
       pas transcrire (le "ss" allemand, par exemple). On fait pareil ici, sinon les deux
       formes ne se rencontrent jamais. */
    s = s.replace(NON_ASCII, '');
    return s.replace(TIRETS, ' ').toLowerCase().replace(PONCT, ' ').replace(/^ +| +$/g, '');
  }
  function canon(s) {
    var n = normalise(s);
    /* faux ami : si la table connait deja ce libelle tel quel, il est dans la bonne forme et
       le glossaire n'a rien a en faire. */
    if (segmentsConnus()[n]) return n;
    var g = window.cmI18n;
    return (g && g[n]) ? g[n] : n;
  }
  var INDEX = null, INDEX_SRC = null, SEGS = null, SEGS_SRC = null;
  /* tous les morceaux de cle que la table emploie, sous leur forme normalisee */
  function segmentsConnus() {
    var src = window.cmComponents || {};
    if (SEGS && SEGS_SRC === src) return SEGS;
    var out = {};
    for (var k in src) {
      if (!src.hasOwnProperty(k)) continue;
      var bouts = String(k).split(' @ ');
      var gauche = bouts[0].split('|');
      /* on retient le libelle d'origine, et non un booleen : c'est lui qui redonne sa casse
         a une valeur revenue du glossaire sous forme normalisee. */
      for (var i = 0; i < gauche.length; i++) out[normalise(gauche[i])] = gauche[i];
      if (bouts.length > 1) out[normalise(bouts[1])] = bouts[1];
    }
    SEGS = out; SEGS_SRC = src;
    return out;
  }
  /* v5.17 : libelle rendu dans la langue de la page. On ne traduit que vers l'anglais :
     le glossaire ramene toutes les langues a l'anglais, mais ne sait pas en repartir. Une
     page francaise garde donc l'affichage d'origine, comme avant. */
  /* libelles issus d'une traduction automatique de la boutique, absents du glossaire Kickflip
     (qui ne couvre que l'editeur de traductions). Formes normalisees, cote gauche = ce qui a ete
     enregistre, cote droit = l'anglais d'origine. « mains » est un contresens sur « hands ». */
  var COMPLEMENT = {
    'mains': 'hour minute hands',
    'aiguille des secondes': 'seconds hand',
    'aiguilles des heures et des minutes': 'hour minute hands',
    'sucette argent': 'lollipop silver',
    'lollipop argent': 'lollipop silver',
    'saphir cyclope': 'sapphire cyclops',
    'verre saphir': 'sapphire crystal'
  };
  var SIGLES = { gmt: 'GMT', pvd: 'PVD', nh35: 'NH35', ii: 'II', iii: 'III', iv: 'IV', sc: 'SC' };
  function casse(n) {
    return String(n).split(' ').map(function (m) {
      if (SIGLES[m]) return SIGLES[m];
      return m ? m.charAt(0).toUpperCase() + m.slice(1) : m;
    }).join(' ');
  }
  /* forme anglaise normalisee -> libelle dans la langue de la page */
  function versLangue(en) {
    try {
      var r = window.cmI18nRetour && window.cmI18nRetour[lang()];
      if (r && r[en]) return texteClair(r[en]);
    } catch (e) {}
    return null;
  }
  function libelle(s) {
    if (typeof s !== 'string' || !s) return s;
    var brut = texteClair(s);
    /* page dans une autre langue : on ramene d'abord a l'anglais, puis on repart vers la
       langue du client. Sans glossaire retour disponible, on garde le libelle d'origine. */
    if (lang() !== 'en') {
      var n0 = normalise(brut);
      var g0 = window.cmI18n;
      var en0 = (g0 && g0[n0]) ? g0[n0] : (COMPLEMENT[n0] || (segmentsConnus()[n0] ? n0 : null));
      if (!en0) return brut;
      return versLangue(en0) || brut;
    }
    var n = normalise(brut);
    /* deja anglais : la table le connait tel quel, rien a faire. */
    var segs = segmentsConnus();
    /* texteClair sur toute valeur reprise dans la table : ses cles portent le tiret cadratin. */
    if (segs[n]) return typeof segs[n] === 'string' ? texteClair(segs[n]) : brut;
    var g = window.cmI18n;
    var en = (g && g[n]) ? g[n] : (COMPLEMENT[n] || null);
    if (!en) return brut;
    if (segs[en] && typeof segs[en] === 'string') return texteClair(segs[en]);
    return casse(en);
  }

  function normCle(cle) {
    var bouts = String(cle).split(' @ ');
    var gauche = bouts[0].split('|').map(normalise).join('|');
    return bouts.length > 1 ? gauche + ' @ ' + normalise(bouts[1]) : gauche;
  }
  function index() {
    var src = window.cmComponents || {};
    if (INDEX && INDEX_SRC === src) return INDEX;
    var out = {};
    for (var k in src) {
      if (!src.hasOwnProperty(k)) continue;
      var nk = normCle(k);
      if (!(nk in out)) out[nk] = src[k];
    }
    INDEX = out; INDEX_SRC = src;
    return out;
  }
  /* cherche(segments..., finition) : les segments forment la partie gauche de la cle, la
     finition ce qui suit ' @ '. Chaque morceau est canonise avant la recherche. */
  function cherche(segments, finition) {
    var idx = index();
    var g = [];
    for (var i = 0; i < segments.length; i++) {
      if (segments[i] === undefined || segments[i] === null || segments[i] === '') return null;
      g.push(canon(segments[i]));
    }
    var cle = g.join('|');
    if (finition) cle += ' @ ' + canon(finition);
    return idx[cle] || null;
  }

  /* v5.15.1 : recadre une image sur sa partie non transparente et renvoie une URL de donnees.
     Les logos televerses sont carres et souvent tres entoures de vide : sans cela, la vignette
     montre surtout du blanc. Renvoie null si le recadrage n'est pas possible. */
  function recadreSurContenu(url) {
    return new Promise(function (ok) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onerror = function () { ok(null); };
      img.onload = function () {
        try {
          var T = 160;
          var c = document.createElement('canvas');
          c.width = c.height = T;
          var x = c.getContext('2d', { willReadFrequently: true });
          x.drawImage(img, 0, 0, T, T);
          var d = x.getImageData(0, 0, T, T).data;
          var x0 = T, y0 = T, x1 = -1, y1 = -1;
          for (var i = 0; i < d.length; i += 4) {
            if (d[i + 3] > 25) {
              var p = i / 4, px = p % T, py = (p / T) | 0;
              if (px < x0) x0 = px;
              if (px > x1) x1 = px;
              if (py < y0) y0 = py;
              if (py > y1) y1 = py;
            }
          }
          if (x1 < 0 || (x1 - x0) < 4 || (y1 - y0) < 4) { ok(null); return; }
          /* deja bien cadre : rien a gagner */
          if ((x1 - x0) > T * 0.94 && (y1 - y0) > T * 0.94) { ok(null); return; }
          var marge = 0.04;
          var sx = img.naturalWidth / T, sy = img.naturalHeight / T;
          var mx = (x1 - x0) * marge, my = (y1 - y0) * marge;
          var cx0 = Math.max(0, (x0 - mx)) * sx, cy0 = Math.max(0, (y0 - my)) * sy;
          var cw = Math.min(T, (x1 - x0) + 2 * mx) * sx, ch = Math.min(T, (y1 - y0) + 2 * my) * sy;
          var out = document.createElement('canvas');
          out.width = Math.max(1, Math.round(cw));
          out.height = Math.max(1, Math.round(ch));
          out.getContext('2d').drawImage(img, cx0, cy0, cw, ch, 0, 0, out.width, out.height);
          ok(out.toDataURL('image/png'));
        } catch (e) { ok(null); }
      };
      img.src = url;
    });
  }

  /* v5.16 : emplacement de la signature sur chaque cadran, en pourcentage de l'image :
     [centre x, centre y, largeur, hauteur]. Mesure hors ligne par difference entre la version
     signee et la version vierge de la meme image (composants-cadrans/scripts/positions_signature.py),
     donc rien n'est estime ici. Repere par le nom de fichier de l'image vierge, qui est stable.
     Volontairement porte par le moteur et non par la table : celle-ci porte aussi le glossaire
     multilingue, et n'a pas a etre reecrite pour cela. */
  var SIG_POS = {"cm-dial-classicdate-anonyme-cognac-brown-warm-dial-nologo.jpg":[50.05,29.05,21.78,9.86],"cm-dial-classicdate-anonyme-deep-navy-lacquered-nologo.jpg":[49.9,29.69,21.29,9.57],"cm-dial-classicdate-anonyme-obsidian-nologo.jpg":[49.76,28.61,22.56,9.96],"cm-dial-classicdate-anonyme-polar-white-lacquered-nologo.jpg":[50.1,28.56,22.27,10.06],"cm-dial-classicdate-arabic-perpetual-arctic-white-nologo.jpg":[49.12,32.32,24.02,10.74],"cm-dial-classicdate-arabic-perpetual-horizon-blue-nologo.jpg":[49.07,32.08,24.12,11.43],"cm-dial-classicdate-arabic-perpetual-khaki-nologo.jpg":[49.51,32.57,24.8,12.01],"cm-dial-classicdate-arabic-perpetual-midnight-navy-nologo.jpg":[49.46,32.52,23.73,10.55],"cm-dial-classicdate-arabic-perpetual-obsidian-nologo.jpg":[48.88,32.37,23.93,10.64],"cm-dial-classicdate-arabic-perpetual-onyx-gold-nologo.jpg":[48.88,32.37,23.93,10.64],"cm-dial-classicdate-arabic-professional-arctic-white-nologo.jpg":[49.37,32.13,24.9,11.33],"cm-dial-classicdate-arabic-professional-emerald-nologo.jpg":[49.46,32.42,23.73,10.55],"cm-dial-classicdate-arabic-professional-horizon-blue-nologo.jpg":[49.56,31.98,24.51,10.84],"cm-dial-classicdate-arabic-professional-obsidian-nologo.jpg":[49.41,32.42,23.83,10.55],"cm-dial-classicdate-arabic-professional-royal-navy-nologo.jpg":[49.41,32.42,23.83,10.55],"cm-dial-classicdate-arabic-slim-arctic-white-nologo.jpg":[49.66,31.98,24.61,11.43],"cm-dial-classicdate-arabic-slim-blush-rose-nologo.jpg":[49.66,31.98,24.61,11.43],"cm-dial-classicdate-arabic-slim-crimson-nologo.jpg":[49.66,31.98,24.61,11.43],"cm-dial-classicdate-arabic-slim-emerald-nologo.jpg":[49.66,31.98,24.61,11.43],"cm-dial-classicdate-arabic-slim-horizon-blue-nologo.jpg":[49.66,31.98,24.61,11.43],"cm-dial-classicdate-arabic-slim-obsidian-nologo.jpg":[49.66,31.98,24.61,11.43],"cm-dial-classicdate-arabic-slim-royal-navy-nologo.jpg":[49.66,31.98,24.61,11.43],"cm-dial-classicdate-day-date-roman-arctic-white-nologo.jpg":[49.61,32.13,24.22,10.74],"cm-dial-classicdate-day-date-roman-autumn-rose-warm-dial-nologo.jpg":[49.32,32.37,24.22,11.04],"cm-dial-classicdate-day-date-roman-emerald-gold-rich-nologo.jpg":[49.61,33.3,24.22,12.89],"cm-dial-classicdate-day-date-roman-emerald-nologo.jpg":[49.56,32.32,24.32,10.94],"cm-dial-classicdate-day-date-roman-heritage-rose-nologo.jpg":[49.51,32.42,24.22,10.74],"cm-dial-classicdate-day-date-roman-horizon-blue-nologo.jpg":[49.61,32.13,24.22,10.74],"cm-dial-classicdate-day-date-roman-khaki-nologo.jpg":[49.37,32.37,24.32,10.84],"cm-dial-classicdate-day-date-roman-lacquer-blue-classic-nologo.jpg":[49.37,32.37,24.32,10.84],"cm-dial-classicdate-day-date-roman-navy-gradient-sunburst-nologo.jpg":[49.56,32.28,24.32,10.84],"cm-dial-classicdate-day-date-roman-obsidian-gold-nologo.jpg":[49.27,32.37,24.32,10.84],"cm-dial-classicdate-day-date-roman-obsidian-nologo.jpg":[49.37,32.37,24.32,10.84],"cm-dial-classicdate-day-date-roman-obsidian-rose-smoked-nologo.jpg":[49.27,32.37,24.32,10.84],"cm-dial-classicdate-day-date-roman-slate-nologo.jpg":[49.37,32.42,24.32,10.94],"cm-dial-classicdate-day-date-roman-white-gold-luminous-nologo.jpg":[49.66,31.98,24.61,11.43],"cm-dial-classicdate-day-date-roman-white-rose-gold-nologo.jpg":[49.66,31.98,24.61,11.43],"cm-dial-classicdate-day-date-sunray-onyx-nologo.jpg":[49.32,32.03,24.22,10.74],"cm-dial-classicdate-day-date-sunray-polar-white-lacquered-nologo.jpg":[49.46,32.28,24.32,10.84],"cm-dial-classicdate-day-date-sunray-sky-blue-eclat-nologo.jpg":[49.12,32.08,24.22,10.84],"cm-dial-classicdate-day-date-sunray-sky-blue-transparent-tint-nologo.jpg":[49.66,32.71,24.12,10.94],"cm-dial-classicdate-day-date-sunray-sterling-silver-lustrous-nologo.jpg":[49.61,32.81,24.22,11.13],"cm-dial-classicdate-day-date-sunray-tobacco-brown-rose-gold-nologo.jpg":[49.56,31.98,24.51,11.23],"cm-dial-classicdate-explorer-anthracite-nologo.jpg":[49.76,30.81,24.51,11.43],"cm-dial-classicdate-explorer-arctic-white-nologo.jpg":[49.66,31.98,24.61,11.43],"cm-dial-classicdate-explorer-horizon-blue-nologo.jpg":[49.56,31.3,25.1,11.62],"cm-dial-classicdate-explorer-khaki-nologo.jpg":[49.61,30.47,24.8,10.94],"cm-dial-classicdate-explorer-obsidian-nologo.jpg":[49.95,30.71,24.32,10.84],"cm-dial-classicdate-forged-carbon-essence-carbon-stealth-dark-matter-nologo.jpg":[48.88,33.2,24.9,12.7],"cm-dial-classicdate-forged-carbon-essence-midnight-ocean-nologo.jpg":[49.56,33.94,24.12,12.99],"cm-dial-classicdate-forged-carbon-essence-onyx-gold-nologo.jpg":[48.93,32.42,24.61,12.3],"cm-dial-classicdate-forged-carbon-obsidian-black-gold-pvd-contrast-nologo.jpg":[48.24,33.5,25.59,12.89],"cm-dial-classicdate-forged-carbon-obsidian-midnight-ocean-nologo.jpg":[49.61,33.15,27.34,12.99],"cm-dial-classicdate-forged-carbon-obsidian-onyx-nologo.jpg":[48.97,32.18,25.49,13.77],"cm-dial-classicdate-oyster-gem-anthracite-nologo.jpg":[49.22,32.67,23.83,10.64],"cm-dial-classicdate-oyster-gem-arctic-white-nologo.jpg":[49.32,32.57,23.83,10.64],"cm-dial-classicdate-oyster-gem-champagne-nologo.jpg":[49.17,32.86,23.73,10.64],"cm-dial-classicdate-oyster-gem-heritage-brown-tobacco-nologo.jpg":[49.32,32.52,23.83,10.74],"cm-dial-classicdate-oyster-gem-horizon-blue-nologo.jpg":[49.66,31.98,24.61,11.43],"cm-dial-classicdate-oyster-gem-obsidian-nologo.jpg":[49.22,32.62,24.02,10.74],"cm-dial-classicdate-oyster-gem-royal-navy-nologo.jpg":[49.12,32.71,24.02,10.74],"cm-dial-classicdate-roman-anthracite-nologo.jpg":[49.07,31.98,24.32,10.84],"cm-dial-classicdate-roman-arctic-gold-nologo.jpg":[48.88,32.86,23.54,10.64],"cm-dial-classicdate-roman-arctic-rose-gold-nologo.jpg":[48.88,32.86,23.54,10.64],"cm-dial-classicdate-roman-arctic-white-nologo.jpg":[48.88,32.86,23.54,10.64],"cm-dial-classicdate-roman-emerald-nologo.jpg":[49.07,31.98,24.32,10.84],"cm-dial-classicdate-roman-horizon-blue-nologo.jpg":[49.22,31.98,24.22,10.84],"cm-dial-classicdate-roman-obsidian-gold-nologo.jpg":[49.17,31.98,24.32,10.84],"cm-dial-classicdate-roman-obsidian-nologo.jpg":[49.17,31.98,24.32,10.84],"cm-dial-classicdate-roman-obsidian-rose-gold-nologo.jpg":[49.17,31.98,24.32,10.84],"cm-dial-classicdate-sky-dweller-black-rose-gold-contrast-nologo.jpg":[49.66,31.98,24.61,11.43],"cm-dial-classicdate-sky-dweller-deep-navy-lacquered-nologo.jpg":[49.12,19.34,25.0,14.06],"cm-dial-classicdate-sky-dweller-field-khaki-military-nologo.jpg":[49.46,18.55,25.88,13.09],"cm-dial-classicdate-sky-dweller-obsidian-nologo.jpg":[49.41,18.75,25.78,12.3],"cm-dial-classicdate-sky-dweller-polar-white-lacquered-nologo.jpg":[49.9,17.97,24.61,10.94],"cm-dial-classicdate-sky-dweller-white-yellow-gold-soft-nologo.jpg":[49.9,17.97,24.61,10.94],"cm-dial-classicdate-sunray-anthracite-nologo.jpg":[49.85,32.71,25.1,11.72],"cm-dial-classicdate-sunray-champagne-nologo.jpg":[49.41,32.18,24.22,10.84],"cm-dial-classicdate-sunray-heritage-brown-nologo.jpg":[49.56,32.28,24.51,10.84],"cm-dial-classicdate-sunray-horizon-blue-nologo.jpg":[49.22,32.08,25.0,11.62],"cm-dial-classicdate-sunray-khaki-nologo.jpg":[49.76,32.47,24.9,11.23],"cm-dial-classicdate-sunray-obsidian-nologo.jpg":[49.61,32.32,24.61,10.94],"cm-dial-classicdate-sunray-polar-white-nologo.jpg":[49.41,32.18,24.22,10.84],"cm-dial-classicdate-sunray-royal-navy-nologo.jpg":[49.56,32.28,24.51,10.84],"cm-dial-deptmaster-anthracite-gray-nologo.jpg":[49.02,32.47,23.24,10.45],"cm-dial-deptmaster-arctic-white-nologo.jpg":[49.56,32.67,23.54,10.45],"cm-dial-deptmaster-emerald-green-nologo.jpg":[49.61,33.3,23.63,10.55],"cm-dial-deptmaster-obsidian-black-nologo.jpg":[49.12,32.52,23.24,10.35],"cm-dial-deptmaster-royal-navy-nologo.jpg":[49.02,32.47,23.24,10.45],"cm-dial-deptmaster-royal-purple-nologo.jpg":[49.02,32.47,23.24,10.45],"cm-dial-deptmaster-sky-turquoise-nologo.jpg":[49.27,32.47,23.73,10.45],"cm-dial-deptmaster-vintage-comex-nologo.jpg":[49.66,33.74,24.32,10.84],"cm-dial-gmt-black-nologo.jpg":[50.0,32.28,24.02,10.64],"cm-dial-gmt-cognac-nologo.jpg":[50.0,32.32,24.02,10.94],"cm-dial-gmt-crimson-nologo.jpg":[50.0,32.28,24.02,10.64],"cm-dial-gmt-emerald-nologo.jpg":[50.0,32.28,24.02,10.64],"cm-dial-gmt-gold-nologo.jpg":[50.0,32.32,24.02,10.94],"cm-dial-gmt-navy-nologo.jpg":[50.0,32.28,24.02,10.64],"cm-dial-gmt-purple-nologo.jpg":[50.0,32.28,24.02,10.64],"cm-dial-gmt-silver-nologo.jpg":[50.0,33.15,23.83,12.21],"cm-dial-modena-anthracite-arabic-script-nologo.jpg":[50.34,29.69,31.15,13.09],"cm-dial-modena-carbon-forged-gold-indices-nologo.jpg":[50.2,29.0,32.23,13.48],"cm-dial-modena-carbon-forged-red-accent-nologo.jpg":[49.85,29.3,31.35,13.09],"cm-dial-modena-carbon-forged-solar-orange-nologo.jpg":[49.8,29.05,31.84,13.38],"cm-dial-modena-carbon-forged-stealth-nologo.jpg":[49.85,28.61,32.52,13.67],"cm-dial-modena-carbon-forged-yellow-racing-nologo.jpg":[49.66,31.98,24.61,11.43],"cm-dial-modena-champagne-gold-counters-nologo.jpg":[49.76,29.05,31.93,13.38],"cm-dial-modena-champagne-sunburst-nologo.jpg":[50.39,28.61,32.03,13.48],"cm-dial-modena-citron-yellow-nologo.jpg":[50.24,28.71,32.13,13.48],"cm-dial-modena-cognac-nologo.jpg":[49.8,29.1,31.84,13.28],"cm-dial-modena-emerald-nologo.jpg":[49.8,29.05,31.84,13.38],"cm-dial-modena-emerald-racing-nologo.jpg":[50.0,28.42,32.23,13.48],"cm-dial-modena-forged-carbon-nologo.jpg":[50.2,29.0,32.23,13.48],"cm-dial-modena-ice-blue-nologo.jpg":[49.8,29.05,31.84,13.38],"cm-dial-modena-ice-brown-nologo.jpg":[50.0,28.91,32.62,13.67],"cm-dial-modena-midnight-navy-arabic-script-nologo.jpg":[49.76,29.69,31.15,13.09],"cm-dial-modena-midnight-navy-nologo.jpg":[49.8,29.05,31.84,13.38],"cm-dial-modena-obsidian-arabic-script-nologo.jpg":[49.8,29.05,31.84,13.38],"cm-dial-modena-obsidian-gold-counters-nologo.jpg":[50.0,28.76,32.42,13.57],"cm-dial-modena-obsidian-rainbow-nologo.jpg":[49.85,29.05,31.93,13.38],"cm-dial-modena-obsidian-rose-gold-counters-nologo.jpg":[49.9,29.2,31.25,13.09],"cm-dial-modena-obsidian-silver-counters-nologo.jpg":[50.0,29.1,31.64,13.28],"cm-dial-modena-obsidian-yellow-gold-counters-nologo.jpg":[50.24,28.71,31.74,13.28],"cm-dial-modena-petal-pink-nologo.jpg":[49.66,31.98,24.61,11.43],"cm-dial-modena-polar-white-arabic-script-nologo.jpg":[49.85,29.25,31.35,13.18],"cm-dial-modena-polar-white-gold-nologo.jpg":[49.85,29.05,32.13,13.38],"cm-dial-modena-polar-white-nologo.jpg":[49.8,29.05,31.84,13.38],"cm-dial-modena-polar-white-silver-counters-nologo.jpg":[49.8,29.1,31.84,13.48],"cm-dial-modena-sterling-silver-nologo.jpg":[49.56,28.86,32.52,13.57]};

  function sigDe(url) {
    if (!url) return null;
    var nom = String(url).split('/').pop().split('?')[0];
    var v = SIG_POS[nom];
    return v ? { cx: v[0], cy: v[1], w: v[2], h: v[3] } : null;
  }

  /* v5.16 : luminance moyenne de la zone ou se pose la signature. Elle decide de la couleur
     du texte : clair sur cadran sombre, sombre sur cadran clair. On mesure plutot que de
     deduire du nom, qui ment (« Onyx & Gold » est sombre, « Black Rose Gold » aussi). */
  function luminanceZone(url, sig) {
    return new Promise(function (ok) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onerror = function () { ok(null); };
      img.onload = function () {
        try {
          var T = 120;
          var c = document.createElement('canvas');
          c.width = c.height = T;
          var x = c.getContext('2d', { willReadFrequently: true });
          x.drawImage(img, 0, 0, T, T);
          var x0 = Math.max(0, Math.round((sig.cx - sig.w / 2) / 100 * T));
          var y0 = Math.max(0, Math.round((sig.cy - sig.h / 2) / 100 * T));
          var w = Math.min(Math.max(1, Math.round(sig.w / 100 * T)), T - x0);
          var h = Math.min(Math.max(1, Math.round(sig.h / 100 * T)), T - y0);
          var d = x.getImageData(x0, y0, w, h).data;
          var s = 0, n = 0;
          for (var i = 0; i < d.length; i += 4) {
            if (d[i + 3] < 20) continue;
            s += 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2];
            n++;
          }
          ok(n ? s / n : null);
        } catch (e) { ok(null); }
      };
      img.src = url;
    });
  }

  /* noms de cadrans clairs : repli si la mesure de luminance echoue (image bloquee par CORS). */
  var RE_CADRAN_CLAIR = /white|arctic|polar|silver|champagne|blush|ivory|pearl|blanc|weiss|argent/i;

  /* v5.16 : le texte du client, pose a l'emplacement exact de la signature du cadran.
     sig vient de la table : il est mesure par difference entre la version signee et la version
     vierge de CE cadran, donc il ne doit rien a une estimation. */
  function poseSignature(comp, texte, sig, urlCadran, nomCadran, couleur) {
    var wrap = comp.querySelector('.cm-mm__comp-img');
    if (!wrap || !sig || !texte) return;
    wrap.classList.add('cm-mm__comp-img--sig');
    var s = el('span', 'cm-mm__dialsig', texte);
    s.style.left = sig.cx + '%';
    s.style.top = sig.cy + '%';
    /* Taille pleine relevee dans les designs clients : 318,8 sur un cote de 3593, soit 8,87 %
       de l'image (donc 8,87 cqw, l'image etant carree). Kickflip la garde telle quelle jusqu'a
       ce que le texte atteigne la largeur de sa ligne, puis la reduit. */
    var taille = 8.87;
    s.style.fontSize = taille + 'cqw';
    /* v5.17 : le client peut donner n'importe quelle couleur a son texte dans le
       configurateur. Quand il en a choisi une, elle fait foi : on la pose telle quelle, meme
       si elle contraste mal, parce que le rendu Kickflip juste a cote l'imprime ainsi. La
       mesure de luminance ne sert plus alors qu'a l'ombre de separation. */
    if (couleur) s.style.color = couleur;
    wrap.appendChild(s);
    luminanceZone(urlCadran, sig).then(function (l) {
      if (l === null) l = RE_CADRAN_CLAIR.test(nomCadran || '') ? 210 : 40;
      var clair = l <= 128;
      /* sans choix du client, on decide comme Kickflip par defaut : clair sur cadran sombre. */
      if (!couleur) s.style.color = clair ? '#f5f5f5' : '#141414';
      s.style.textShadow = clair ? '0 1px 2px rgba(0,0,0,.45)' : '0 1px 2px rgba(255,255,255,.5)';
      s.className += ' cm-mm__dialsig--vu';
    });
    /* un texte long chevaucherait les index : on le reduit jusqu'a tenir dans 42 % du cadran.
       ATTENTION : tant que l'image n'est pas chargee, la vignette a une largeur de 0 et il n'y a
       rien a mesurer. On rejoue donc l'ajustement au chargement, sinon les textes longs sortent
       a taille pleine (mesure : 62 % du cadran au lieu de 42). */
    function ajuste() {
      var cible = wrap.clientWidth * 0.35;  /* largeur de la ligne de texte chez Kickflip */
      if (!cible) return false;
      var t2 = 8.87;
      s.style.fontSize = t2 + 'cqw';
      /* Reduction CALCULEE, en une passe. Une boucle par pas de 10 % plafonnee a 10 essais
         ne descend qu'a 35 % de la taille : mesure au crash test, 119 caracteres sortaient a
         245 % de la largeur du cadran. La largeur n'etant pas tout a fait proportionnelle a la
         taille (chasses, approches), une seconde passe rattrape l'ecart residuel.
         Plancher a 1,6 cqw : en dessous le texte devient un trait, autant qu'il deborde un peu. */
      if (s.scrollWidth > cible) {
        t2 = Math.max(1.6, t2 * (cible / s.scrollWidth));
        s.style.fontSize = t2 + 'cqw';
        if (s.scrollWidth > cible) {
          t2 = Math.max(1.6, t2 * (cible / s.scrollWidth));
          s.style.fontSize = t2 + 'cqw';
        }
      }
      return true;
    }
    requestAnimationFrame(ajuste);
    var imgCadran = wrap.querySelector('img');
    if (imgCadran) {
      if (imgCadran.complete && imgCadran.naturalWidth) requestAnimationFrame(ajuste);
      else imgCadran.addEventListener('load', function () { requestAnimationFrame(ajuste); });
    }
    setTimeout(ajuste, 400);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { ajuste(); });
  }

  /* Vollkorn SC est la police d'impression de Kickflip ; sans elle on retombe silencieusement
     sur Georgia, qui n'a ni les petites capitales ni les memes chasses. */
  /* glossaire retour (anglais -> langue de la page). Inutile aux anglophones : on ne le
     telecharge que dans les autres langues. */
  function chargeGlossaireRetour() {
    try {
      if (lang() === 'en' || window.cmI18nRetour) return;
      if (document.getElementById('cm-mm-i18n-retour')) return;
      var lien = document.querySelector('script[src*="cm-mamontre"]');
      if (!lien) return;
      var s = document.createElement('script');
      s.id = 'cm-mm-i18n-retour';
      s.defer = true;
      /* on retire le ?v= : il est celui de cm-mamontre.js, pas du glossaire, et il
         empechait de voir une mise a jour du glossaire seul. */
      s.src = lien.getAttribute('src').split('?')[0].replace(/cm-mamontre\.js/, 'cm-i18n-retour.js')
              + '?v=' + (window.cmMaMontreVersion || '5180');
      document.head.appendChild(s);
    } catch (e) {}
  }

  function chargePolice() {
    if (document.getElementById('cm-mm-police')) return;
    var l = document.createElement('link');
    l.id = 'cm-mm-police';
    l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Vollkorn+SC:wght@400;600&display=swap';
    document.head.appendChild(l);
  }
  chargePolice();
  chargeGlossaireRetour();

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text !== undefined && text !== null) e.textContent = texteClair(String(text));
    return e;
  }
  /* v5.16.1 : libelles de secours. Le moteur les utilise mais l'appelant ne les fournit pas
     toujours : sans cela le bouton sort VIDE, donc invisible, et le client croit devoir donner
     son e-mail pour garder sa montre. */
  /* Libelles de l'ecran dans les 7 langues de la boutique. Le dictionnaire du theme
     n'en couvre que 4 (en, fr, de, it) : en es, nl et pt il retombe sur l'anglais, et
     les boutons s'affichaient « Add to cart » sur une page espagnole. */
  var SECOURS = {
    en: { close: 'Close', zoom: 'Enlarge the watch', share: 'Share my watch', copyLink: 'Copy link', dezoom: 'Reduce the watch', shareCopie: 'Link copied', favShort: 'Save', favSaved: 'Saved ✓', skipKeep: 'Skip, keep it on this device only', aboutTitle: 'The model', addCart: 'Add to cart', confTitle: 'Configuration', cont: 'Continue shopping', eyebrow: 'Your creation', favBtn: 'Save to My Watches', heart: 'My Watches', hint: 'One email with your watch and its link. The box is optional, unsubscribe in one click.', mailWhy: 'Get the link, so you can pick your watch up on your phone.', consent: 'Keep me posted on Chrono Mod news and offers', keep: 'Save for later', kept: 'Saved to My Watches', order: 'Checkout', ready: 'Your watch is ready', seeAll: 'See my watches', send: 'Send', sendWhere: 'Where should we send it?', sentShort: 'Sent. Check your inbox.', sub: 'It is ready. What would you like to do with it?', toast: 'Saved to My Watches', undo: 'Undo', view: 'View', waiting: 'Your watch is waiting', modify: 'Edit my watch', gravTitle: 'Your engraving', gravNote: 'Hand-engraved and final: please proofread it.', made: 'Made for you, after your order.', photo: 'You receive a photo of your finished watch before it ships.', warranty: '2-year warranty, worldwide.', troisX: 'or 3 \u00d7 {x} interest-free', taxes: 'Duties & taxes included' },
    fr: { close: 'Fermer', zoom: 'Agrandir la montre', share: 'Partager ma montre', copyLink: 'Copier le lien', dezoom: 'Réduire la montre', shareCopie: 'Lien copié', favShort: 'Favoris', favSaved: 'Enregistrée ✓', skipKeep: 'Passer, la garder sur cet appareil seulement', aboutTitle: 'Le modèle', addCart: 'Ajouter au panier', confTitle: 'Configuration', cont: 'Continuer mes achats', eyebrow: 'Votre création', favBtn: 'Mettre en favoris', heart: 'Mes montres', hint: 'Un seul email avec votre montre et son lien. La case est facultative, désabonnement en un clic.', mailWhy: 'Recevez le lien, pour la reprendre sur votre téléphone.', consent: 'Tenez-moi au courant des nouveautés et des offres Chrono Mod', keep: 'Garder pour plus tard', kept: 'Sauvegardée dans Mes montres', order: 'Commander', ready: 'Votre montre est prête', seeAll: 'Voir mes montres', send: 'Envoyer', sendWhere: 'Où vous l’envoyer ?', sentShort: 'Envoyé. Vérifiez votre boîte mail.', sub: 'Elle est prête. Que souhaitez-vous en faire ?', toast: 'Sauvegardée dans Mes montres', undo: 'Annuler', view: 'Voir', waiting: 'Votre montre vous attend', modify: 'Modifier ma montre', gravTitle: 'Votre gravure', gravNote: 'Gravée à la main, définitive : relisez-la.', made: 'Fabriquée pour vous, après votre commande.', photo: 'Vous recevez la photo de votre montre terminée avant son expédition.', warranty: 'Garantie 2 ans, dans le monde entier.', troisX: 'ou 3 \u00d7 {x} sans frais', taxes: 'Droits et taxes inclus' },
    de: { close: 'Schließen', zoom: 'Uhr vergrößern', share: 'Meine Uhr teilen', copyLink: 'Link kopieren', dezoom: 'Uhr verkleinern', shareCopie: 'Link kopiert', favShort: 'Merken', favSaved: 'Gespeichert ✓', skipKeep: 'Überspringen, nur auf diesem Gerät behalten', aboutTitle: 'Das Modell', addCart: 'In den Warenkorb', confTitle: 'Konfiguration', cont: 'Weiter einkaufen', eyebrow: 'Ihre Kreation', favBtn: 'Zu Meine Uhren', heart: 'Meine Uhren', hint: 'Eine einzige E-Mail mit Ihrer Uhr und dem Link. Das Kästchen ist freiwillig, Abmeldung mit einem Klick.', mailWhy: 'Erhalten Sie den Link, um Ihre Uhr auf dem Handy fortzusetzen.', consent: 'Haltet mich über Neuheiten und Angebote von Chrono Mod auf dem Laufenden', keep: 'Für später speichern', kept: 'In Meine Uhren gespeichert', order: 'Zur Kasse', ready: 'Ihre Uhr ist bereit', seeAll: 'Meine Uhren ansehen', send: 'Senden', sendWhere: 'Wohin sollen wir sie senden?', sentShort: 'Gesendet. Prüfen Sie Ihr Postfach.', sub: 'Sie ist bereit. Was möchten Sie damit tun?', toast: 'In Meine Uhren gespeichert', undo: 'Rückgängig', view: 'Ansehen', waiting: 'Ihre Uhr wartet auf Sie', modify: 'Meine Uhr ändern', gravTitle: 'Ihre Gravur', gravNote: 'Von Hand graviert, endgültig: bitte prüfen Sie den Text.', made: 'Für Sie gefertigt, nach Ihrer Bestellung.', photo: 'Sie erhalten ein Foto Ihrer fertigen Uhr vor dem Versand.', warranty: '2 Jahre Garantie, weltweit.', troisX: 'oder 3 \u00d7 {x} zinsfrei', taxes: 'Zölle und Steuern inklusive' },
    it: { close: 'Chiudi', zoom: 'Ingrandisci l’orologio', share: 'Condividi il mio orologio', copyLink: 'Copia il link', dezoom: 'Riduci l’orologio', shareCopie: 'Link copiato', favShort: 'Preferiti', favSaved: 'Salvato ✓', skipKeep: 'Salta, tienila solo su questo dispositivo', aboutTitle: 'Il modello', addCart: 'Aggiungi al carrello', confTitle: 'Configurazione', cont: 'Continua gli acquisti', eyebrow: 'La tua creazione', favBtn: 'Aggiungi ai preferiti', heart: 'I miei orologi', hint: 'Una sola email con il tuo orologio e il suo link. La casella è facoltativa, disiscrizione in un clic.', mailWhy: 'Ricevi il link, per riprendere il tuo orologio dal telefono.', consent: 'Tenetemi aggiornato su novità e offerte Chrono Mod', keep: 'Salva per dopo', kept: 'Salvato in I miei orologi', order: 'Ordina', ready: 'Il tuo orologio è pronto', seeAll: 'Vedi i miei orologi', send: 'Invia', sendWhere: 'Dove la inviamo?', sentShort: 'Inviata. Controlla la tua casella.', sub: 'È pronto. Cosa vuoi farne?', toast: 'Salvato in I miei orologi', undo: 'Annulla', view: 'Vedi', waiting: 'Il tuo orologio ti aspetta', modify: 'Modifica il mio orologio', gravTitle: 'La tua incisione', gravNote: 'Incisa a mano, definitiva: rileggila.', made: 'Realizzato per te, dopo il tuo ordine.', photo: 'Ricevi la foto del tuo orologio finito prima della spedizione.', warranty: 'Garanzia di 2 anni, in tutto il mondo.', troisX: 'o 3 \u00d7 {x} senza interessi', taxes: 'Dazi e tasse inclusi' },
    es: { close: 'Cerrar', zoom: 'Ampliar el reloj', share: 'Compartir mi reloj', copyLink: 'Copiar el enlace', dezoom: 'Reducir el reloj', shareCopie: 'Enlace copiado', favShort: 'Guardar', favSaved: 'Guardado ✓', skipKeep: 'Omitir, guardarla solo en este dispositivo', aboutTitle: 'El modelo', addCart: 'Añadir al carrito', confTitle: 'Configuración', cont: 'Seguir comprando', eyebrow: 'Su creación', favBtn: 'Guardar en Mis relojes', heart: 'Mis relojes', hint: 'Un solo email con su reloj y su enlace. La casilla es opcional, puede darse de baja en un clic.', mailWhy: 'Reciba el enlace, para retomar su reloj en el teléfono.', consent: 'Manténganme informado de las novedades y ofertas de Chrono Mod', keep: 'Guardar para después', kept: 'Guardado en Mis relojes', order: 'Finalizar compra', ready: 'Su reloj está listo', seeAll: 'Ver mis relojes', send: 'Enviar', sendWhere: '¿Adónde se lo enviamos?', sentShort: 'Enviado. Revise su bandeja de entrada.', sub: 'Está listo. ¿Qué desea hacer con él?', toast: 'Guardado en Mis relojes', undo: 'Deshacer', view: 'Ver', waiting: 'Su reloj le espera', modify: 'Modificar mi reloj', gravTitle: 'Su grabado', gravNote: 'Grabado a mano, definitivo: revíselo.', made: 'Fabricado para usted, después de su pedido.', photo: 'Recibe la foto de su reloj terminado antes del envío.', warranty: 'Garantía de 2 años, en todo el mundo.', troisX: 'o 3 \u00d7 {x} sin intereses', taxes: 'Aranceles e impuestos incluidos' },
    nl: { close: 'Sluiten', zoom: 'Horloge vergroten', share: 'Mijn horloge delen', copyLink: 'Link kopiëren', dezoom: 'Horloge verkleinen', shareCopie: 'Link gekopieerd', favShort: 'Bewaren', favSaved: 'Bewaard ✓', skipKeep: 'Overslaan, alleen op dit apparaat bewaren', aboutTitle: 'Het model', addCart: 'In winkelwagen', confTitle: 'Configuratie', cont: 'Verder winkelen', eyebrow: 'Uw creatie', favBtn: 'Opslaan in Mijn horloges', heart: 'Mijn horloges', hint: 'Eén e-mail met uw horloge en de link. Het vakje is optioneel, uitschrijven met één klik.', mailWhy: 'Ontvang de link, om uw horloge op uw telefoon verder te zetten.', consent: 'Houd mij op de hoogte van nieuws en aanbiedingen van Chrono Mod', keep: 'Bewaren voor later', kept: 'Opgeslagen in Mijn horloges', order: 'Afrekenen', ready: 'Uw horloge is klaar', seeAll: 'Mijn horloges bekijken', send: 'Versturen', sendWhere: 'Waar sturen we het naartoe?', sentShort: 'Verzonden. Kijk in uw inbox.', sub: 'Hij is klaar. Wat wilt u ermee doen?', toast: 'Opgeslagen in Mijn horloges', undo: 'Ongedaan maken', view: 'Bekijken', waiting: 'Uw horloge wacht op u', modify: 'Mijn horloge aanpassen', gravTitle: 'Uw gravure', gravNote: 'Met de hand gegraveerd, definitief: lees het na.', made: 'Voor u gemaakt, na uw bestelling.', photo: 'U ontvangt een foto van uw afgewerkte horloge voor verzending.', warranty: '2 jaar garantie, wereldwijd.', troisX: 'of 3 \u00d7 {x} renteloos', taxes: 'Invoerrechten en btw inbegrepen' },
    pt: { close: 'Fechar', zoom: 'Ampliar o relógio', share: 'Partilhar o meu relógio', copyLink: 'Copiar o link', dezoom: 'Reduzir o relógio', shareCopie: 'Link copiado', favShort: 'Guardar', favSaved: 'Guardado ✓', skipKeep: 'Ignorar, manter só neste dispositivo', aboutTitle: 'O modelo', addCart: 'Adicionar ao carrinho', confTitle: 'Configuração', cont: 'Continuar a comprar', eyebrow: 'A sua criação', favBtn: 'Guardar nos Meus relógios', heart: 'Meus relógios', hint: 'Um único email com o seu relógio e o seu link. A caixa é facultativa, cancelamento num clique.', mailWhy: 'Receba o link, para retomar o seu relógio no telemóvel.', consent: 'Mantenham-me informado sobre novidades e ofertas Chrono Mod', keep: 'Guardar para mais tarde', kept: 'Guardado nos Meus relógios', order: 'Finalizar compra', ready: 'O seu relógio está pronto', seeAll: 'Ver os meus relógios', send: 'Enviar', sendWhere: 'Para onde o enviamos?', sentShort: 'Enviado. Verifique a sua caixa de entrada.', sub: 'Está pronto. O que deseja fazer com ele?', toast: 'Guardado nos Meus relógios', undo: 'Anular', view: 'Ver', waiting: 'O seu relógio está à sua espera', modify: 'Alterar o meu relógio', gravTitle: 'A sua gravação', gravNote: 'Gravada à mão, definitiva: releia-a.', made: 'Fabricado para si, depois da sua encomenda.', photo: 'Recebe a foto do seu relógio terminado antes do envio.', warranty: 'Garantia de 2 anos, em todo o mundo.', troisX: 'ou 3 \u00d7 {x} sem juros', taxes: 'Direitos e impostos incluídos' }
  };
  /* v6.24 : le tiers du prix, avec ses centimes. fmtPrice du theme arrondit a l unite, ce qui
     ferait « 3 x 126 » pour 379 : faux de un euro. */
  function montant3x(prix, devise) {
    var m = Math.round(prix / 3 * 100) / 100;
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: devise || 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(m); }
    catch (e) { return m.toFixed(2) + ' ' + (devise || 'EUR'); }
  }
  function completeLibelles(T) {
    var l = lang();
    var s = SECOURS[l] || SECOURS.en;
    var en = SECOURS.en;
    for (var k in s) {
      if (!s.hasOwnProperty(k)) continue;
      /* absent : on remplit. Present mais identique a l'anglais alors que la page ne l'est
         pas : c'est la signature d'un theme retombe sur sa langue par defaut, on corrige. */
      if (!T[k] || (l !== 'en' && en[k] && T[k] === en[k])) T[k] = s[k];
    }
    return T;
  }

  function lang() {
    var l = (document.documentElement.getAttribute('lang') || 'en').slice(0, 2).toLowerCase();
    return COPY[l] ? l : 'en';
  }
  /* trouve les options lunette (toutes) et l'option boitier parmi les options du client */
  function findParts(options) {
    var out = { bezels: [], straps: [], dials: [], logo: null, signature: null, texte: null, cas: null, couleurTexte: null };
    (options || []).forEach(function (p) {
      var k = p[0] || '', v = p[1] || '';
      /* v5.7 : l'URL du logo televerse par le client est deja dans les options */
      if (!out.logo && RE_LOGO_URL.test(v)) out.logo = v;
      /* v5.10 : quelle signature le client a-t-il demandee, et quel texte a-t-il ecrit */
      if (!out.signature && (RE_DIALSIGN.test(k) || /dial logo/.test(canon(k)))) out.signature = v;
      if (!out.texte && RE_TEXTE.test(k) && !RE_TEXTE_NOT.test(k) && v && !RE_LOGO_URL.test(v)) out.texte = v;
      /* on ne retient que les hexadecimaux : l'invite non touchee n'est pas une couleur. */
      if (!out.couleurTexte && RE_COULEUR_TEXTE.test(k) && RE_HEX.test(String(v).trim())) out.couleurTexte = String(v).trim();
      /* v5.8.2 : chaque famille est reconnue soit par ses mots (liste ci-dessus, qui couvre
         les libelles absents du glossaire), soit par le sens du libelle une fois canonise.
         Sans cela "Brazalete", "Rand" ou "Bandtype" passaient au travers. */
      var kc = canon(k);
      var couleur = RE_COULEUR.test(k) || RE_COULEUR.test(kc);
      if ((RE_DIAL.test(k) || /dial/.test(kc)) &&
          (couleur || (!RE_DIAL_NOT.test(k) && !RE_DIAL_NOT.test(kc)))) out.dials.push(p);
      if (RE_BEZEL.test(k) || /bezel/.test(kc)) out.bezels.push(p);
      /* v5.6 : on ecarte les questions de couleur de bracelet (Strap Color, Strap Hardware
         Color...), qui ne portent pas le type de bracelet. */
      if ((RE_STRAP.test(k) || /bracelet|strap/.test(kc)) && !RE_STRAP_NOT.test(k) && !RE_STRAP_NOT.test(kc)) out.straps.push(p);
      if (!out.cas && (RE_CASE.test(k) || /case/.test(kc)) && !RE_CASE_NOT.test(k) && !RE_CASE_NOT.test(kc)) out.cas = p;
    });
    return out;
  }

  /* ---------------------------------------------------------------------------------------
     LES TROIS VUES (v6.7)

     Le relais rend { vues: [ [url, ...], ... ] }, une liste de couches par vue, deja triees
     dans l'ordre d'empilement. On les superpose telles quelles.

     Pourquoi un relais et pas une table embarquee : pour savoir quelle couche empiler il faut
     l'IDENTIFIANT de la reponse choisie. La fenetre ne recoit que des libelles, et la question
     « Bracelet » a six reponses toutes nommees « Oyster » : resoudre par le nom donnait le
     mauvais bracelet et la mauvaise couleur de boucle, verifie sur 25 designs reels sur 25.
     Seule l'API porte les identifiants, et sa cle ne peut pas vivre chez le client. */
  var RELAIS = 'https://cm-relais-vues.chrono-mod.workers.dev/vues';
  var CDN_KF = 'https://cdnv2.mycustomizer.com/chronowatch/';
  var RE_DESIGN = /^[0-9a-f]{24}$/;
  var vuesCache = {};

  /* Le designId voyage sous plusieurs noms selon la surface qui ouvre la fenetre. On le prend
     ou il est, et on le VALIDE : sans ce test, une valeur inattendue partirait dans une URL. */
  function designDeCtx(ctx) {
    var cands = [ctx && ctx.designId, ctx && ctx.interceptKey,
                 ctx && ctx.data && ctx.data.id, ctx && ctx.data && ctx.data.designId];
    for (var i = 0; i < cands.length; i++) {
      var v = String(cands[i] || '').trim();
      if (RE_DESIGN.test(v)) return v;
    }
    return null;
  }

  function demandeVues(id, cb) {
    if (vuesCache[id]) { cb(vuesCache[id]); return; }
    var fini = false;
    /* garde-fou de temps : la fenetre ne doit jamais attendre le reseau. Passe ce delai on
       reste sur la vignette, ce qui est l'etat d'avant et non une regression. */
    var minuteur = setTimeout(function () { if (!fini) { fini = true; cb(null); } }, 6000);
    try {
      fetch(RELAIS + '?all=1&design=' + encodeURIComponent(id), { credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          /* 28/09/2026 : calculee et mise en cache AVANT le test du delai. Une reponse arrivee
             apres 6 s etait jetee, et chaque reouverture refaisait toute l'attente. */
          /* On recopie CHAMP PAR CHAMP, et il faut donc penser a chaque nouveau champ : les
             teintes de materiau et la pile ordonnee ont ete ajoutees au relais sans etre
             reprises ici, et se perdaient en silence. Le logo n'apparaissait pas et les
             bracelets restaient blancs alors que les deux fonctionnaient dans les bancs. */
          var v = j && j.vues && j.vues.length
                  ? { vues: j.vues, source: j.source, gravures: j.gravures,
                      teintes: j.teintes, pile: j.pile, designId: j.designId, viewIndices: j.viewIndices, viewCount: j.viewCount } : null;
          if (v) vuesCache[id] = v;
          if (fini) return;
          fini = true; clearTimeout(minuteur);
          cb(v);
        })
        .catch(function () { if (!fini) { fini = true; clearTimeout(minuteur); cb(null); } });
    } catch (e) { if (!fini) { fini = true; clearTimeout(minuteur); cb(null); } }
  }
  /* v5.2 : construction de la bande composant, partagee entre la fiche plein ecran et la
     fiche detail de la page Mes montres (sections/cm-favoris-page.liquid). Retourne null
     si aucune piece configuree n'a d'image en table. compact = version etroite pour la modale. */
  function buildBand(options, handle, compact) {
    ensureCss();
    var compMap = window.cmComponents || {};
    handle = handle || '';
    var parts = findParts(options);
    /* v5.3 : sur Classic Date et Lady Date la lunette est solidaire du boitier, sa couleur suit
       donc la finition choisie. On essaie d'abord la cle combinee "Option|Valeur @ Finition",
       puis on retombe sur les cles simples pour les masters ou la lunette est independante. */
    var caseVal = parts.cas ? parts.cas[1] : '';
    function lookup(p) {
      if (!p) return null;
      return (caseVal ? cherche([p[0], p[1]], caseVal) : null) ||
             cherche([handle, p[0], p[1]]) ||
             cherche([p[0], p[1]]) ||
             cherche([p[1]]) || null;
    }
    var shown = null, media = null;
    /* on retient la PREMIERE option lunette qui a effectivement une image en table : sur
       SeaRanger la 1re option lunette est le style (Mariner Edge / Deptmaster), sans image,
       et c'est la question de couleur qui suit qui en porte une. */
    for (var bi = 0; bi < parts.bezels.length && !media; bi++) {
      var cand = lookup(parts.bezels[bi]);
      if (cand && cand.img) { shown = parts.bezels[bi]; media = cand; }
    }
    if (!media) {
      var mcase = lookup(parts.cas);
      if (mcase && mcase.img) { shown = parts.cas; media = mcase; }
    }
    if (!media || !media.img || !shown) return null;
    var copy = COPY[lang()];
    var isBezel = RE_BEZEL.test(shown[0]);
    var bezelName = isBezel ? shown[1] : (parts.bezels[0] ? parts.bezels[0][1] : '');
    var body = article((parts.cas && bezelName ? copy.both : copy.one)
      .replace('{bezel}', libelle(bezelName || shown[1]))
      .replace('{case}', parts.cas ? libelle(parts.cas[1]) : ''));
    var comp = bande(shown, media, body, compact, false);
    /* le diametre est deja la ligne Case Size du tableau : c etait sa troisieme occurrence. */
    return comp;
  }

  /* v5.6 : fabrique commune des deux bandes. rev = miroir (texte a gauche, image a droite). */
  /* v5.10 : la dimension de la piece, affichee dans sa propre section.
     'bezel' prend le diametre du boitier, choisi par le client donc toujours juste ;
     'dial' et 'strap' ne sortent que si le modele a une donnee sourcee. */
  function dimBande(quoi, options, handle) {
    var d = dimsFor(handle);
    if (quoi === 'bezel') {
      var t = tailleBoitier(options);
      /* sur les masters a taille unique, le configurateur ne pose pas la question : on prend
         alors le diametre du modele. */
      if (!t && d && d.boitier) t = d.boitier;
      return t ? ('\u00d8 ' + String(t).replace(/\s*mm/i, ' mm')) : null;
    }
    if (!d) return null;
    if (quoi === 'dial') return d.dial || null;
    if (quoi === 'strap') {
      var t2 = tailleBoitier(options);
      if (d.lug) {
        var cle = t2 ? String(t2).replace(/\s+/g, '').toLowerCase() : '';
        if (d.lug[cle]) return d.lug[cle];
      }
      return d.lugFixe || null;
    }
    return null;
  }
  function ajouteDim(comp, valeur) {
    if (!comp || !valeur) return;
    var corps = comp.querySelector('.cm-mm__comp-body');
    if (corps) corps.appendChild(el('div', 'cm-mm__comp-dim', valeur));
  }

  function bande(shown, media, texte, compact, rev) {
    var comp = el('div', 'cm-mm__comp' + (compact ? ' cm-mm__comp--compact' : '') +
                         (rev ? ' cm-mm__comp--rev' : ''));
    var imgWrap = el('div', 'cm-mm__comp-img');
    var cim = el('img');
    cim.loading = 'lazy';
    cim.src = media.img;
    cim.alt = shown[0] + ' ' + shown[1];
    imgWrap.appendChild(cim);
    comp.appendChild(imgWrap);
    var txt = el('div', 'cm-mm__comp-body');
    /* le surtitre etait le libelle de l option et le gros titre sa valeur : exactement la
       ligne du tableau situee 200 px plus haut, trois fois. La bande garde l image, qui
       montre ce que le tableau ne peut pas dire. */
    txt.appendChild(el('p', 'cm-mm__comp-text', media.text || texte));
    comp.appendChild(txt);
    return comp;
  }

  /* v5.7 : bande CADRAN. Si le client a televerse un logo, on prend la version SANS signature
     (imgNoLogo dans la table) et on pose son logo a l'emplacement de la signature. */
  function buildDialBand(options, handle, compact, rev, logoUrl) {
    ensureCss();
    var compMap = window.cmComponents || {};
    handle = handle || '';
    var parts = findParts(options);
    /* les fiches derivees ont leur propre handle (gmt-dual-time-batman, deptmaster-black-diver...)
       alors que la table est rangee par master : on essaie le handle puis ses prefixes. */
    var bouts = handle.split('-'), handles = [];
    for (var hb = bouts.length; hb > 0; hb--) handles.push(bouts.slice(0, hb).join('-'));
    /* v5.7.3 : le motif du cadran change tout. Sur Classic Date, "Obsidian" en Roman et
       "Obsidian" en Explorer sont deux cadrans differents : on cherche donc d'abord la cle
       combinee "Couleur @ Design", puis on retombe sur la couleur seule. */
    var design = null;
    (options || []).forEach(function (q) {
      /* v5.8.1 : on interroge le sens de la question, pas ses mots : "Conception du
         cadran", "Progettazione del quadrante" et "Wijzerplaatontwerp" disent tous
         "dial design", et le glossaire le sait. */
      if (!design && (/design/.test(canon(q[0])) || /design|motif|dessin/i.test(q[0]))) design = q[1];
    });
    var shown = null, media = null;
    for (var di = 0; di < parts.dials.length && !media; di++) {
      var p = parts.dials[di], cand = null;
      for (var hi = 0; hi < handles.length && !cand; hi++) {
        if (design) cand = cherche([handles[hi], p[0], p[1]], design);
        cand = cand || cherche([handles[hi], p[0], p[1]]);
      }
      cand = cand || cherche([p[0], p[1]]) || cherche([p[1]]);
      if (cand && cand.img) { shown = p; media = cand; }
    }
    if (!media || !media.img || !shown) return null;
    /* l'URL du logo arrive normalement par data.logo (le snippet l'extrait a part) ;
       parts.logo reste un repli si elle figure malgre tout dans les options. */
    var logo = logoUrl || parts.logo;
    /* v5.10 : on ne garde la signature Chrono Mod que si le client l'a demandee. Des qu'il
       choisit autre chose (son image, son texte, ou rien), le cadran vierge s'impose : lui
       montrer notre signature alors qu'il a ecrit la sienne serait faux. */
    var maison = !parts.signature || RE_MAISON.test(parts.signature);
    var perso = media.imgNoLogo && !maison;
    var src = perso ? media.imgNoLogo : media.img;
    var c = COPY_DIAL[lang()] || COPY_DIAL.en;
    var texte = article(((perso && (logo || parts.texte)) ? c.custom : c.logo).replace('{dial}', libelle(shown[1])));
    /* v5.16 : deux cas, et ils ne se traitent pas pareil.
       - Signature TEXTE : on connait la chaine exacte, et l'emplacement est mesure sur ce
         cadran meme (champ sig, difference entre la version signee et la version vierge). On
         la pose donc sur le cadran. Mesure faite sur 1000 designs : 8 % des clients seulement
         deplacent ce texte dans le configurateur.
       - Signature IMAGE : la position depend de ce que le client en a fait, et 43 % la
         deplacent. La deviner reviendrait a la placer au hasard, donc le logo est montre a
         cote du cadran (bloc plus bas), jamais dessus.
       Dans les deux cas, le rendu complet, a gauche de la fiche, reste la reference. */
    var comp = bande(shown, { img: src, text: media.text }, texte, compact, rev);
    ajouteDim(comp, dimBande('dial', options, handle));
    if (perso && !logo) {
      /* le client a demande un texte : s'il n'a rien saisi, Kickflip imprime son propre temoin
         « YOUR TEXT » sur le rendu. La vignette doit montrer la meme chose, sinon le cadran
         parait vide alors que le rendu, juste a cote, porte un texte. */
      var aTexte = RE_TEXTE_CHOISI.test(parts.signature || '');
      var texteSig = parts.texte || (aTexte ? 'YOUR TEXT' : '');
      if (texteSig) poseSignature(comp, texteSig, sigDe(src) || media.sig, src, shown[1], parts.couleurTexte);
    }
    /* v5.15 : le logo du client est montre a cote du cadran, pas dessus. Sa position sur le
       cadran depend de ce qu'il en a fait dans le configurateur et ne nous est pas transmise :
       la deviner reviendrait a la placer au hasard. Ici il est simplement visible. */
    if (perso && logo) {
      var corps = comp.querySelector('.cm-mm__comp-body');
      if (corps) {
        var bloc = el('div', 'cm-mm__signature');
        var vign = el('img', 'cm-mm__signature-img');
        vign.loading = 'lazy';
        vign.src = logo;
        vign.alt = '';
        /* le fichier televerse est carre et souvent tres entoure de vide : on le recadre sur
           son dessin pour que la vignette le montre vraiment. */
        recadreSurContenu(logo).then(function (recadre) {
          if (recadre && vign.parentNode) vign.src = recadre;
        });
        bloc.appendChild(vign);
        corps.appendChild(bloc);
      }
    }
    return comp;
  }

  /* v5.6 : bande BRACELET, en miroir sous celle de la lunette. Meme mecanique de cle que
     pour la lunette : la couleur du bracelet suit la finition du boitier, donc on essaie
     d'abord "Option|Valeur @ Finition". */
  function buildStrapBand(options, handle, compact) {
    ensureCss();
    var compMap = window.cmComponents || {};
    handle = handle || '';
    var parts = findParts(options);
    var caseVal = parts.cas ? parts.cas[1] : '';
    var shown = null, media = null;
    for (var si = 0; si < parts.straps.length && !media; si++) {
      var p = parts.straps[si];
      var cand = (caseVal ? cherche([p[0], p[1]], caseVal) : null) ||
                 cherche([handle, p[0], p[1]]) ||
                 cherche([p[0], p[1]]) ||
                 cherche([p[1]]) || null;
      if (cand && cand.img) { shown = p; media = cand; }
    }
    if (!media || !media.img || !shown) return null;
    var texte = article((COPY_STRAP[lang()] || COPY_STRAP.en).replace('{strap}', libelle(shown[1])));
    var comp = bande(shown, media, texte, compact, true);
    ajouteDim(comp, dimBande('strap', options, handle));
    return comp;
  }

  /* v5.16.2 : sur les pages configurateur, le snippet ne charge que ce moteur, pas la table
     des composants. Sans table, aucune bande ne se construit et la fiche parait vide de ses
     images. On va donc la chercher a cote de nous, une seule fois. */
  var tableEnCours = null;
  function assureTable(cb) {
    if (window.cmComponents) { cb(); return; }
    if (tableEnCours) { tableEnCours.push(cb); return; }
    var moi = null;
    var scripts = document.querySelectorAll('script[src*="cm-mamontre"]');
    if (scripts.length) moi = scripts[scripts.length - 1].src;
    if (!moi) { cb(); return; }
    tableEnCours = [cb];
    var s = document.createElement('script');
    /* on GARDE le ?v= : sans parametre de version, Shopify renvoie une version perimee de
       l'asset (mesure : 1 508 octets au lieu de 148 919). */
    s.src = moi.replace('cm-mamontre.js', 'cm-components.js');
    function fini() {
      var f = tableEnCours; tableEnCours = null;
      f.forEach(function (g) { try { g(); } catch (e) {} });
    }
    s.onload = fini;
    s.onerror = fini;
    (document.head || document.documentElement).appendChild(s);
  }

  var LIB_VUES = {
    en: ['Front', 'Profile', 'Case back'], fr: ['Face', 'Profil', 'Fond'],
    de: ['Vorderseite', 'Profil', 'Boden'], it: ['Fronte', 'Profilo', 'Fondello'],
    es: ['Frente', 'Perfil', 'Fondo'], nl: ['Voorkant', 'Profiel', 'Kastbodem'],
    pt: ['Frente', 'Perfil', 'Fundo']
  };
  /* Une vue = des couches superposees. Chaque couche porte le 500 et le 1200 dans un srcset :
     le navigateur prend le 500 sur un ecran ordinaire, le 1200 sur un retina. Le CDN de
     Kickflip ne sert que ces deux tailles, toutes les autres repondent 403. */
  /* La COULEUR d'une couche, reprise de leur fonction de teinte au pixel.

     Deux temps chez eux : chaque pixel est multiplie par la couleur du materiau, puis les
     pixels dont la luminance depasse un seuil sont ramenes vers le blanc, proportionnellement
     au depassement et selon une intensite. Sans ce second temps, un bracelet noir perdrait
     tous ses reflets et deviendrait une silhouette plate.

     Eux travaillent au pixel sur un canvas. Nous ne pouvons pas : les images viennent du CDN
     de Kickflip et le canvas serait souille par l'origine croisee. Le meme calcul s'ecrit
     exactement en filtre SVG, applique en CSS sur le <img>, sans jamais lire un pixel.

     Constate en mesurant nos vues de face contre leurs vignettes officielles : sans teinte,
     la SeaRanger et la Deptmaster affichaient un bracelet BLANC la ou Kickflip en montre un
     noir, ecart moyen 22,6 et 18,5 sur 255 quand les huit autres masters sont a 2 ou 3. */
  var teintesPosees = {}, defsTeintes = null, nTeinte = 0;
  function filtreTeinte(t) {
    if (!t || !t.couleur) return null;
    var ec = t.eclairage;
    var cle = t.couleur + '|' + (ec ? ec.seuil + '|' + ec.intensite : '-');
    if (teintesPosees[cle] !== undefined) return teintesPosees[cle];
    var m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(String(t.couleur).trim());
    if (!m) { teintesPosees[cle] = null; return null; }
    var cr = parseInt(m[1], 16) / 255, cv = parseInt(m[2], 16) / 255, cb = parseInt(m[3], 16) / 255;
    var ns = 'http://www.w3.org/2000/svg';
    if (!defsTeintes) {
      var hote = document.createElementNS(ns, 'svg');
      hote.setAttribute('aria-hidden', 'true');
      hote.style.cssText = 'position:absolute;left:-9999px;top:0;width:0;height:0;overflow:hidden';
      defsTeintes = document.createElementNS(ns, 'defs');
      hote.appendChild(defsTeintes);
      document.body.appendChild(hote);
    }
    var id = 'cm-teinte-' + (++nTeinte);
    var f = document.createElementNS(ns, 'filter');
    f.setAttribute('id', id);
    f.setAttribute('color-interpolation-filters', 'sRGB');
    var etapes = ['<feColorMatrix type="matrix" in="SourceGraphic" result="teint" values="'
      + cr + ' 0 0 0 0  0 ' + cv + ' 0 0 0  0 0 ' + cb + ' 0 0  0 0 0 1 0"/>'];
    if (ec && ec.intensite > 0 && ec.seuil < 255) {
      var sn = ec.seuil / 255;
      var pente = ec.intensite / (1 - sn);
      etapes.push(
        /* luminance Rec.709 versee dans le canal alpha */
        '<feColorMatrix type="matrix" in="SourceGraphic" result="lum"'
          + ' values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0.2126 0.7152 0.0722 0 0"/>',
        /* la rampe au-dessus du seuil, negatif en dessous donc ramene a zero */
        '<feComponentTransfer in="lum" result="voile"><feFuncA type="linear" slope="'
          + pente + '" intercept="' + (-sn * pente) + '"/></feComponentTransfer>',
        '<feComposite in="voile" in2="SourceGraphic" operator="in" result="voileClip"/>',
        '<feFlood flood-color="#ffffff" result="blanc"/>',
        '<feComposite in="blanc" in2="voileClip" operator="in" result="reflet"/>',
        '<feComposite in="reflet" in2="teint" operator="over" result="mele"/>',
        /* on rend au resultat l'alpha de la source, que le « over » avait gonfle sur les
           bords semi transparents */
        '<feComposite in="mele" in2="SourceGraphic" operator="in"/>'
      );
    }
    f.innerHTML = etapes.join('');
    defsTeintes.appendChild(f);
    teintesPosees[cle] = 'url(#' + id + ')';
    return teintesPosees[cle];
  }
  /* Le noir et blanc d'un logo, avec LEURS coefficients. Ce n'est pas le `grayscale(1)` du
     CSS, qui utilise la luminance Rec.709 (0,2126 / 0,7152 / 0,0722) : leur fonction emploie
     0,34 / 0,50 / 0,16, ce qui rend les rouges plus clairs et les verts plus sombres. Sur un
     logo bicolore l'ecart se voit. */
  var filtreNBpose = null;
  function filtreNB() {
    if (filtreNBpose) return filtreNBpose;
    var ns = 'http://www.w3.org/2000/svg';
    if (!defsTeintes) filtreTeinte({ couleur: '#ffffff' });   /* cree le porte-filtres */
    var f = document.createElementNS(ns, 'filter');
    f.setAttribute('id', 'cm-logo-nb');
    f.setAttribute('color-interpolation-filters', 'sRGB');
    f.innerHTML = '<feColorMatrix type="matrix" values="'
      + '0.34 0.5 0.16 0 0  0.34 0.5 0.16 0 0  0.34 0.5 0.16 0 0  0 0 0 1 0"/>';
    defsTeintes.appendChild(f);
    filtreNBpose = 'url(#cm-logo-nb)';
    return filtreNBpose;
  }

  /* Un logo televerse par le client.

     La boite arrive DEJA resolue par Kickflip : le relais la lit dans `prints`, la mise en
     page qu'ils ont eux-memes calculee, et non dans la position par defaut du produit. Ca
     compte, parce que les pieces logo autorisent le deplacement et le redimensionnement :
     avec la position par defaut, trois designs sur quatre etaient nettement empires par le
     dessin du logo. Il n'y a donc plus rien a ajuster ici, on pose aux dimensions donnees. */
  function poseLogo(pile, l) {
    var i = el('img');
    i.alt = '';
    i.decoding = 'async';
    i.style.position = 'absolute';
    i.style.left = ((l.x - l.largeur / 2) / 12) + '%';
    i.style.top = ((l.y - l.hauteur / 2) / 12) + '%';
    i.style.width = (l.largeur / 12) + '%';
    i.style.height = (l.hauteur / 12) + '%';
    if (l.rotation) i.style.transform = 'rotate(' + l.rotation + 'deg)';
    if (l.nb) i.style.filter = filtreNB();
    if (l.fondu === 'multiply') i.style.mixBlendMode = 'multiply';
    i.addEventListener('error', function () { i.remove(); }, { once: true });
    i.src = l.url;
    pile.appendChild(i);
  }

  /* La pile d'une vue DANS L'ORDRE de Kickflip. Images, textes et logos sont intercales chez
     eux, ce ne sont pas trois couches separees : sur la GMT le logo et le texte du cadran
     sont aux rangs 6 et 7, les aiguilles aux rangs 12 et 13, le verre au rang 15. En posant
     tous les textes en dernier, nos aiguilles passaient SOUS la gravure du cadran. */
  function pileDeSpec(spec, titre) {
    var pile = el('div', 'cm-mm__pile');
    spec.forEach(function (e) {
      if (!e) return;
      if (e.t === 'i') {
        poseCouche(pile, e.url, e.teinte);
      } else if (e.t === 'x') {
        var g = svgGravures([e.g]);
        if (g) pile.appendChild(g);
      } else if (e.t === 'l') {
        poseLogo(pile, e.l);
      }
    });
    pile.setAttribute('role', 'img');
    if (titre) pile.setAttribute('aria-label', titre);
    return pile;
  }

  /* une couche d'image, avec sa teinte de materiau s'il y en a une */
  /* 28/09/2026 : taille d'affichage des couches. Les vignettes de vues (54 px) reprenaient
     « 88vw » : sur un telephone a ecran x3, chaque couche de chaque vignette tirait le fichier
     de 1200 px, des dizaines de gros fichiers en concurrence avec la vue principale. poseVues
     la passe a 60px le temps de construire une vignette. */
  var TAILLE_COUCHE = null;
  function poseCouche(pile, url, teinte) {
    var f = String(url).split('/').pop();
    var i = el('img');
    var fl = filtreTeinte(teinte);
    if (fl) i.style.filter = fl;
    i.src = CDN_KF + '500x500/' + f;
    i.srcset = CDN_KF + '500x500/' + f + ' 500w, ' + CDN_KF + f + ' 1200w';
    i.sizes = TAILLE_COUCHE || '(max-width:900px) 88vw, 420px';
    i.alt = '';
    i.decoding = 'async';
    pile.appendChild(i);
  }

  function pileVue(urls, titre, source, teintes) {
    var pile = el('div', 'cm-mm__pile');
    urls.forEach(function (u, rang) {
      var f = String(u).split('/').pop();
      var i = el('img');
      var fl = filtreTeinte(teintes && teintes[rang]);
      if (fl) i.style.filter = fl;
      i.src = CDN_KF + '500x500/' + f;
      /* le 500 et le 1200 dans un srcset, le navigateur tranche selon la densite de l'ecran.
         Le CDN ne sert que ces deux tailles, toutes les autres repondent 403. */
      i.srcset = CDN_KF + '500x500/' + f + ' 500w, ' + CDN_KF + f + ' 1200w';
      i.sizes = TAILLE_COUCHE || '(max-width:900px) 88vw, 420px';
      i.alt = '';
      i.decoding = 'async';
      pile.appendChild(i);
    });
    pile.setAttribute('role', 'img');
    if (titre) pile.setAttribute('aria-label', titre);
    return pile;
  }
  function pileAvecGravures(urls, gravures, titre, teintes) {
    var pile = pileVue(urls, titre, null, teintes);
    var g = svgGravures(gravures);
    if (g) pile.appendChild(g);
    return pile;
  }
  /* Les polices sont des Google Fonts, declarees par le produit. On ne charge chaque famille
     qu'une fois par page : sans ca, une fiche a quatre gravures poserait quatre feuilles. */
  var policesPosees = {};
  function assurePolice(nom) {
    if (!nom || policesPosees[nom]) return;
    policesPosees[nom] = true;
    /* La MEME URL que Kickflip appelle, l'API v1 et non v2. Pour Vollkorn SC les deux
       servent un fichier identique a l'octet, mais v2 est plus stricte sur les noms de
       familles : le jour ou une autre police est choisie dans le configurateur, v2 pourrait
       repondre 404 la ou v1 resout, et on retomberait en serif sans rien signaler. On copie
       leur appel, la resolution de la police devient la leur par construction. */
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css?family=' +
             encodeURIComponent(nom) + '&display=swap';
    (document.head || document.documentElement).appendChild(l);
  }
  /* Vrai quand la police est REELLEMENT disponible pour mesurer. Tant qu'elle ne l'est pas,
     un canvas retombe sur le serif du systeme, dont les chasses sont tout autres : mesure
     faite, dix-huit lettres font 601 unites en Vollkorn SC et 432 en serif, soit 28 % d'ecart.
     Poser les lettres avec ces chasses-la les serre ou les etale le long de la courbe. */
  function policePrete(nom, taille) {
    try { return document.fonts.check(taille + 'px "' + nom + '"'); } catch (e) { return true; }
  }
  function quandPolicePrete(nom, taille, suite) {
    if (policePrete(nom, taille)) { suite(); return; }
    var fini = false;
    var fait = function () { if (!fini) { fini = true; suite(); } };
    try {
      document.fonts.load(taille + 'px "' + nom + '"').then(fait, fait);
    } catch (e) { fait(); return; }
    /* garde-fou : si la police n'arrive jamais, on dessine quand meme */
    setTimeout(fait, 3000);
  }
  var idGravure = 0;
  /* ---- Le texte courbe de Kickflip, repris de LEUR source -------------------------------
     Leur configurateur est du Konva, mais le texte courbe n'y passe pas par Konva.TextPath :
     ils construisent un vrai <textPath> SVG, le rasterisent, puis posent l'image. Les avances
     et le crenage sont donc ceux du navigateur, jamais d'un placement maison. On fait pareil,
     et l'affichage devient le leur par construction.

     Surtout : quand le texte est trop long pour le chemin, ils ne le laissent pas deborder
     (SVG escamote silencieusement les derniers glyphes), ils REDUISENT la police jusqu'a ce
     qu'il rentre. C'est ce que j'avais pris pour un defaut de <textPath> et "repare" en posant
     les lettres une par une : la vraie regle etait chez eux, dans setFontSizeToFitOnPath. */
  /* Kickflip construit son texte dans un SVG isole qu'il rasterise ensuite : il n'herite de
     RIEN. Le notre vit dans la page, donc il herite du theme. Une seule regle de graisse, de
     casse ou d'interlettrage posee sur un conteneur de Prestige suffirait a decaler tout un
     texte courbe, et on chercherait longtemps. On remet donc a plat, explicitement, toutes
     les proprietes de texte heritables, exactement les valeurs par defaut de leur rendu. */
  var NEUTRE = 'font-weight:normal;font-style:normal;font-variant:normal;font-stretch:normal;'
    + 'letter-spacing:normal;word-spacing:normal;text-transform:none;text-decoration:none;'
    + 'text-indent:0;font-feature-settings:normal;font-kerning:auto;text-rendering:auto;'
    + 'direction:ltr;';

  var ANCRE_KF = { left: 'start', right: 'end' };    /* defaut : middle */
  var DEPART_KF = { left: '0%', right: '100%' };     /* defaut : 50%    */
  /* "M x0,y0 C x1,y1 x2,y2 x3,y3 " : leur conversion du tableau de bezier, a l'identique */
  function cheminBezier(b) {
    var d = 'M ';
    for (var i = 0; i <= b.length - 2; i += 2) {
      d += b[i] + ',' + b[i + 1] + ' ';
      if (i === 0) d += 'C ';
    }
    return d;
  }
  /* banc de mesure cache : getComputedTextLength et getTotalLength ne repondent que sur des
     elements reellement presents dans le document */
  var banc = null;
  function bancMesure() {
    if (banc) return banc;
    var ns = 'http://www.w3.org/2000/svg';
    var s = document.createElementNS(ns, 'svg');
    s.setAttribute('aria-hidden', 'true');
    s.style.cssText = 'position:absolute;left:-9999px;top:0;width:1px;height:1px;overflow:hidden';
    var courbe = document.createElementNS(ns, 'path');
    courbe.setAttribute('id', 'cm-mesure-courbe');
    var droit = document.createElementNS(ns, 'path');
    droit.setAttribute('id', 'cm-mesure-droit');
    var txt = document.createElementNS(ns, 'text');
    /* le banc doit mesurer dans EXACTEMENT les conditions du trace, sinon la decision de
       retrecir se prend sur des chasses qui ne sont pas celles dessinees */
    txt.style.cssText = NEUTRE;
    var tp = document.createElementNS(ns, 'textPath');
    tp.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#cm-mesure-droit');
    tp.setAttribute('href', '#cm-mesure-droit');
    tp.setAttribute('text-anchor', 'middle');
    tp.setAttribute('startOffset', '50%');
    txt.appendChild(tp);
    s.appendChild(courbe); s.appendChild(droit); s.appendChild(txt);
    document.body.appendChild(s);
    banc = { courbe: courbe, droit: droit, texte: txt, tp: tp };
    return banc;
  }
  /* Leur cy() : mesurer le texte sur un chemin DROIT assez long pour ne jamais le tronquer,
     puis descendre la taille par pas de taille/100 tant qu'il depasse la longueur du vrai
     chemin. Retourne la taille retenue, leur `adjustedFontSize`. */
  function tailleSurChemin(texte, police, taille, b) {
    var m, lg;
    try {
      m = bancMesure();
      m.courbe.setAttribute('d', cheminBezier(b));
      lg = m.courbe.getTotalLength();
    } catch (e) { return taille; }
    if (!lg) return taille;
    m.droit.setAttribute('d', 'M 0 0 L 0 ' + Math.max(2000, taille * (String(texte).length + 1)));
    m.texte.setAttribute('font-family', '"' + police + '", serif');
    m.tp.setAttribute('font-size', taille + 'px');
    m.tp.textContent = texte;
    var pas = Math.max(taille / 100, 0.1);
    var t = taille, garde = 0;
    try {
      while (m.tp.getComputedTextLength() > lg && t > 1 && garde++ < 5000) {
        t = Math.max(t - pas, 1);
        m.tp.setAttribute('font-size', t + 'px');
      }
    } catch (e) { return taille; }
    return t;
  }
  /* Mesure d'un bloc de texte HTML avec les regles de coulage de Kickflip, hors du document
     visible. Sans largeur imposee, `max-content` rend la largeur naturelle ; avec une largeur,
     on obtient la hauteur apres retours a la ligne. */
  var bancBloc = null;
  function mesureBloc(texte, police, taille, largeur) {
    if (!bancBloc) {
      bancBloc = document.createElement('div');
      bancBloc.setAttribute('aria-hidden', 'true');
      document.body.appendChild(bancBloc);
    }
    bancBloc.style.cssText = NEUTRE + 'position:absolute;left:-9999px;top:0;visibility:hidden;'
      + 'display:inline-block;white-space:pre-wrap;overflow-wrap:anywhere;line-height:1;'
      + 'margin:0;padding:0;border:0;'
      + (largeur ? 'width:' + largeur + 'px;' : 'width:max-content;')
      + 'font-family:"' + police + '", serif;font-size:' + taille + 'px;';
    bancBloc.textContent = texte;
    var r = bancBloc.getBoundingClientRect();
    return { w: r.width || taille, h: r.height || taille };
  }

  /* Le creux d'une gravure, tel que Kickflip le fabrique reellement : un filtre SVG a trois
     couches, pilote par les trois nombres que le produit declare. Repris de leur source
     (leur fonction Zv), y compris les constantes 12, 8, 0.7 et 0.4.

       decalage = direction de lumiere x profondeur x 12   (y inverse : l'axe SVG descend)
       flou     = (1 - nettete) x 8

     Les trois couches empilees, dans cet ordre :
       1. le texte dans sa couleur, a 40 % : le fond du sillon ;
       2. le noir a l'opacite `profondeur`, moins sa copie floue decalee vers la lumiere :
          il ne reste qu'un croissant sombre du cote oppose, c'est l'ombre portee du creux ;
       3. un liseré blanc a 70 % sur l'arete.

     J'avais d'abord approche ce relief avec deux passes de texte et une opacite reglee a
     l'oeil, ce que Lino a eu raison de refuser : c'etait une invention, pas leur reglage.
     Il n'y a plus rien a estimer ici, ni a recalibrer finition par finition. */
  function filtreCreux(defs, svgns, cr) {
    cr = cr || {};
    var prof = Number(cr.profondeur == null ? 1 : cr.profondeur);
    var net = Number(cr.nettete == null ? 1 : cr.nettete);
    var lum = cr.lumiere || { x: 0, y: 0 };
    var dx = Number(lum.x || 0) * prof * 12;
    var dy = -1 * Number(lum.y || 0) * prof * 12;
    var flou = (1 - net) * 8;
    var id = 'cm-creux-' + (++idGravure);
    var f = document.createElementNS(svgns, 'filter');
    f.setAttribute('id', id);
    f.setAttribute('x', '-20%');
    f.setAttribute('y', '-20%');
    f.setAttribute('width', '140%');
    f.setAttribute('height', '140%');
    f.setAttribute('color-interpolation-filters', 'sRGB');
    f.innerHTML =
      '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 ' + prof + ' 0"'
        + ' in="SourceGraphic" result="creux4"/>'
      + '<feGaussianBlur stdDeviation="' + flou + ' ' + flou + '" in="creux4" edgeMode="none" result="creuxFlou"/>'
      + '<feOffset dx="' + dx + '" dy="' + dy + '" in="creuxFlou" result="creuxDecale"/>'
      + '<feComposite in="creux4" in2="creuxDecale" operator="out" result="creuxOmbre"/>'
      + '<feColorMatrix type="matrix" values="1 0 0 1 0 0 1 0 1 0 0 0 1 1 0 0 0 0 0.7 0"'
        + ' in="SourceAlpha" result="creux5"/>'
      + '<feGaussianBlur stdDeviation="0 0" in="creux5" edgeMode="none" result="creuxFlou2"/>'
      + '<feComposite in="creuxFlou2" in2="SourceAlpha" operator="out" result="creuxArete"/>'
      + '<feColorMatrix type="matrix" values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0.4 0"'
        + ' in="SourceGraphic" result="creuxFond"/>'
      + '<feMerge result="creuxTout">'
        + '<feMergeNode in="creuxFond"/><feMergeNode in="creuxOmbre"/><feMergeNode in="creuxArete"/>'
      + '</feMerge>';
    defs.appendChild(f);
    return 'url(#' + id + ')';
  }
  /* Rend le SVG des gravures d'une vue, ou null s'il n'y en a pas.
     viewBox 1200 : c'est l'espace dans lequel le relais exprime toutes les coordonnees. */
  function svgGravures(liste) {
    if (!liste || !liste.length) return null;
    var svgns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgns, 'svg');
    svg.setAttribute('viewBox', '0 0 1200 1200');
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    svg.setAttribute('class', 'cm-mm__grav');
    svg.setAttribute('aria-hidden', 'true');
    var defs = document.createElementNS(svgns, 'defs');
    svg.appendChild(defs);
    var multiplie = false;
    liste.forEach(function (g) {
      if (!g || !g.texte) return;
      assurePolice(g.police);
      /* Une gravure n'a pas de couleur : elle a un CREUX. Deux tentatives m'ont precede ici,
         et toutes deux etaient des approximations a l'oeil : un noir a 55 % calibre sur une
         GMT en acier, qui faisait disparaitre la gravure sur un boitier PVD noir, puis deux
         passes reflet/ombre dont j'avais choisi l'opacite moi-meme.

         Le vrai relief est un filtre SVG que Kickflip construit a partir de trois nombres du
         produit. Il est desormais repris tel quel dans filtreCreux : plus rien a estimer. */
      /* La taille reellement dessinee n'est pas toujours celle demandee : sur un chemin trop
         court Kickflip retrecit la police pour que la gravure tienne entiere. Le relief se
         calcule sur la taille retenue, sinon il grossirait pendant que le texte maigrit. */
      g._taille = (g.bezier && g.bezier.length >= 8)
        ? tailleSurChemin(g.texte, g.police, g.taille || 32, g.bezier)
        : (g.taille || 32);
      /* Le fondu multiply et la gravure sont DEUX operations distinctes chez eux, sur la
         meme piece : une gravure peut aussi etre en multiply. On ne les oppose plus. */
      if (g.fondu === 'multiply') multiplie = true;
      poseUnTexte(svg, defs, svgns, g, {
        fill: g.couleur || '#000000',
        filtre: g.grave ? filtreCreux(defs, svgns, g.creux) : null
      });
    });
    function poseUnTexte(svg, defs, svgns, g, pa) {
      var b = g.bezier;
      /* Deux moteurs distincts chez eux, donc deux ici : le texte COURBE est un <textPath>
         SVG, le texte DROIT est du HTML dans une boite. Rien de commun a factoriser. */
      if (b && b.length >= 8) {
        var taille = g._taille || g.taille || 32;
        var t = document.createElementNS(svgns, 'text');
        t.setAttribute('font-family', '"' + g.police + '", serif');
        t.setAttribute('font-size', String(taille));
        t.setAttribute('fill', pa.fill);
        t.style.cssText = NEUTRE;
        /* un seul trace : le relief du creux est entierement dans le filtre */
        if (pa.filtre) t.setAttribute('filter', pa.filtre);
        if (g.contour && g.contour.largeur) {
          t.setAttribute('stroke', g.contour.couleur || '#000');
          t.setAttribute('stroke-width', String(g.contour.largeur));
          t.setAttribute('paint-order', 'stroke');
        }
        /* Un <textPath> sur le chemin qu'ils donnent, avec LEUR table d'alignement :
           text-anchor start/middle/end et startOffset 0%/50%/100%. La taille a deja ete
           ajustee plus haut pour que rien ne soit escamote. Aucun dominant-baseline : leur
           <text> n'en pose pas, la ligne de base alphabetique se pose donc sur la courbe. */
        var idc = 'cm-grav-' + (++idGravure);
        var chemin = document.createElementNS(svgns, 'path');
        chemin.setAttribute('id', idc);
        chemin.setAttribute('d', cheminBezier(b));
        chemin.setAttribute('fill', 'transparent');
        defs.appendChild(chemin);
        var tp = document.createElementNS(svgns, 'textPath');
        tp.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + idc);
        tp.setAttribute('href', '#' + idc);
        tp.setAttribute('text-anchor', ANCRE_KF[g.align] || 'middle');
        tp.setAttribute('startOffset', DEPART_KF[g.align] || '50%');
        tp.setAttribute('font-size', taille + 'px');
        tp.textContent = g.texte;
        t.appendChild(tp);
        svg.appendChild(t);
        return;
      }
      /* Texte DROIT : une boite, pas un point. Voir poseTexteDroit. */
      poseTexteDroit(svg, svgns, g, pa);
    }

    /* ---- Le texte droit de Kickflip -----------------------------------------------------
       Leur texte droit n'est pas du SVG : c'est un <div> HTML dans un <foreignObject>, dans
       une boite de maxWidth x maxHeight. Le texte y passe a la ligne (`overflow-wrap:
       anywhere`, `white-space: pre-wrap`, `line-height: 1`) et il est cale par flexbox.

       Ca compte pour de vrai. La boite du flanc de la Classic Date fait 841 x 107 a 70 px de
       police, et sa question de gravure n'a AUCUNE limite de caracteres : passe environ 24
       signes, Kickflip renvoie a la ligne et coupe ce qui depasse, alors qu'un <text> SVG
       continuait tout droit hors du boitier. C'est le dernier endroit ou l'on divergeait.

       Le placement vient de leur `ry.render` :
         x = centre HORIZONTAL de la boite (offsetX = width/2), quel que soit l'alignement ;
         y = centre vertical, sauf debordement « visible » ;
         padding = 0 si « clip », sinon la taille de police ;
         rotation autour de (x, y). */
    function poseTexteDroit(svg, svgns, g, pa) {
      var XHTML = 'http://www.w3.org/1999/xhtml';
      var taille = g._taille || g.taille || 32;
      var deb = g.debordement || 'clip';
      var lb = Number(g.maxWidth || 0), hb = Number(g.maxHeight || 0);
      var x = Number(g.x || 600), y = Number(g.y || 600);
      /* leur $v : plusieurs sauts de ligne d'affilee deviennent des lignes non vides, sinon
         `pre-wrap` les avale et la hauteur du bloc change */
      var contenu = String(g.texte).replace(/\n{2,}/g, function (m) {
        return new Array(m.length).join(' \n') + '\n';
      });

      /* Les dimensions de la BOITE DE CONTENU, et c'est elle qui se centre sur (x, y).
         Deux pieges franchis ici, tous deux constates sur des produits reels :

         1. La boite n'est pas toujours declaree. Sur la Modena, le texte de cadran ET la
            gravure de flanc arrivent avec maxWidth et maxHeight a zero. Kickflip passe alors
            en `max-content` / `auto` et dimensionne sur le texte mesure. Sans ca, un
            <foreignObject> sans largeur ni hauteur ne dessine rien du tout.

         2. Leur `padding` ne deplace RIEN. Ils agrandissent le SVG de deux paddings, posent
            le foreignObject a (padding, padding), puis centrent le tout sur (x, y) : le
            contenu retombe donc exactement au centre. Je l'avais ajoute a la taille de la
            boite sans decaler le contenu, qui se retrouvait colle en haut a gauche, decale
            d'une taille de police. Visible sur le cadran de la LandMaster : 32 unites de
            trop vers la gauche et 39 vers le haut. Le padding ne sert que de marge au
            filtre, et notre <g> a deja `overflow: visible`. On ne le pose donc plus.

         3. En debordement « visible », la hauteur n'est pas maxHeight mais celle du texte
            mesure : c'est ce que fait leur `setDimensions`. */
      var hauteurLibre = !hb || deb === 'visible';
      var L = lb, H = hb;
      if (!lb || hauteurLibre) {
        var m = mesureBloc(contenu, g.police, taille, lb);
        if (!lb) L = m.w;
        if (hauteurLibre) H = m.h;
      }

      var fo = document.createElementNS(svgns, 'foreignObject');
      fo.setAttribute('x', String(x - L / 2));
      fo.setAttribute('y', String(y - H / 2));
      fo.setAttribute('width', String(L));
      fo.setAttribute('height', String(H));
      fo.setAttribute('overflow', 'visible');

      var boite = document.createElementNS(XHTML, 'div');
      boite.style.cssText = 'box-sizing:border-box;margin:0;padding:0;border:0;'
        + 'width:' + (lb ? lb + 'px' : 'max-content')
        + ';height:' + (hauteurLibre ? 'auto' : hb + 'px')
        + ';overflow:' + (deb === 'clip' ? 'hidden' : 'visible') + ';';

      var justif = g.align === 'left' ? 'flex-start' : g.align === 'right' ? 'flex-end' : 'center';
      var cale = g.alignV === 'top' ? 'flex-start' : g.alignV === 'bottom' ? 'flex-end' : 'center';
      var txt = document.createElementNS(XHTML, 'div');
      txt.style.cssText = NEUTRE + 'display:flex;width:100%;height:100%;white-space:pre-wrap;'
        + 'overflow-wrap:anywhere;line-height:1;margin:0;padding:0;border:0;'
        + 'justify-content:' + justif + ';align-items:' + cale + ';'
        + 'text-align:' + (g.align || 'center') + ';'
        + 'font-family:"' + g.police + '", serif;font-size:' + taille + 'px;'
        + 'color:' + pa.fill + ';';
      txt.textContent = contenu;
      if (g.contour && g.contour.largeur) {
        txt.style.webkitTextStroke = g.contour.largeur + 'px ' + (g.contour.couleur || '#000');
      }
      boite.appendChild(txt);
      fo.appendChild(boite);

      /* Le filtre va sur un <g> ENVELOPPANT, pas sur le foreignObject. Pose directement sur
         lui, le navigateur n'affiche plus rien : mesure faite, texte present dans le DOM,
         bien place, invisible a l'ecran. Kickflip pose le sien sur le foreignObject parce que
         leur SVG est ensuite rasterise, ce qui suit un autre chemin de rendu ; nous
         l'affichons en direct. Le <g> est d'ailleurs leur propre motif du cote courbe. */
      var enveloppe = document.createElementNS(svgns, 'g');
      if (pa.filtre) enveloppe.setAttribute('filter', pa.filtre);
      if (g.rotation) enveloppe.setAttribute('transform', 'rotate(' + g.rotation + ' ' + x + ' ' + y + ')');
      enveloppe.appendChild(fo);
      svg.appendChild(enveloppe);

      /* debordement « resize » : ils descendent la police par pas de 0,1 px tant que le
         contenu depasse la hauteur de la boite. Mesurable seulement une fois dans le
         document, donc apres insertion. */
      if (deb === 'resize' && hb && !hauteurLibre) {
        var r = taille, garde = 0;
        while (boite.scrollHeight > boite.clientHeight && r > 0.2 && garde++ < 2000) {
          r -= 0.1;
          txt.style.fontSize = r + 'px';
        }
      }
    }

    /* un texte droit est un <foreignObject>, pas un <text> : ne chercher que des <text>
       renvoyait null et faisait disparaitre toute gravure droite. */
    if (!svg.querySelector('text, foreignObject')) return null;
    /* Premier passage : on dessine tout de suite, avec ce qu'on a, pour ne jamais laisser la
       montre nue. Des que la police est la, on refait le trace : c'est le seul moment ou les
       chasses sont justes, et sur un texte courbe une chasse fausse decale toutes les lettres. */
    /* Vaut pour les deux formes : sur un arc une chasse fausse decale toutes les lettres,
       et dans une boite elle change l'endroit ou le texte passe a la ligne. */
    var aRefaire = liste.filter(function (g) {
      return g && g.texte && !policePrete(g.police, g.taille || 32);
    });
    if (aRefaire.length) {
      quandPolicePrete(aRefaire[0].police, aRefaire[0].taille || 32, function () {
        if (!svg.isConnected) return;
        var neuf = svgGravures(liste);
        if (neuf) svg.replaceWith(neuf);
      });
    }
    /* le fondu multiply reproduit le creux grave de Kickflip : le texte assombrit le cadran
       au lieu de se poser dessus comme une etiquette. */
    if (multiplie) svg.style.mixBlendMode = 'multiply';
    return svg;
  }

  /* --- commandes de la scene (v6.19) -------------------------------------------------- */
  /* Les icones sont celles du configurateur Kickflip, reprises trait pour trait : le client
     vient de les voir, en dessiner d'autres ferait passer cet ecran pour un autre site. */
  var TRAIT = 'fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"';
  var CERCLE_LOUPE = '<path d="M18.875 9.811A9.063 9.063 0 1 1 9.813.749a9.063 9.063 0 0 1 9.062 9.062"/>' +
    '<line x1="5.25" x2="14.25" y1="9.749" y2="9.749"/>' +
    '<line x1="16.221" x2="23.25" y1="16.219" y2="23.249"/>';
  var SVG_LOUPE = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ' + TRAIT + ' aria-hidden="true">' +
    CERCLE_LOUPE + '<line x1="9.75" x2="9.75" y1="14.249" y2="5.249"/></svg>';
  /* v6.30 : la croix de la fiche d un favori, meme trait que la loupe pour lire les trois ronds
     de la scene comme une seule famille */
  var SVG_CROIX = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ' + TRAIT + ' aria-hidden="true">' +
    '<line x1="5.5" y1="5.5" x2="18.5" y2="18.5"/><line x1="18.5" y1="5.5" x2="5.5" y2="18.5"/></svg>';
  /* le dezoom, c'est la meme loupe sans la barre verticale du plus */
  var SVG_DEZOOM = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ' + TRAIT + ' aria-hidden="true">' +
    CERCLE_LOUPE + '</svg>';
  var SVG_PARTAGE = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
    '<path d="M11.999 1a.77.77 0 0 0-.542.224L7.15 5.534a.766.766 0 0 0 1.083 1.082l3.001-3v9.64a.766.766 0 0 0 1.532 0v-9.64l3.001 3a.766.766 0 1 0 1.083-1.083l-4.308-4.309A.77.77 0 0 0 11.999 1m10.47 15.064a.766.766 0 1 1 1.531 0v2.042c0 1.222-.354 2.426-1.026 3.342-.674.92-1.648 1.51-2.736 1.51H3.762c-1.088 0-2.062-.59-2.736-1.51C.354 20.532 0 19.328 0 18.106v-2.042a.766.766 0 0 1 1.532 0v2.042c0 .944.277 1.82.73 2.436.449.613.999.883 1.5.883h16.476c.501 0 1.051-.27 1.5-.883.453-.617.73-1.492.73-2.436z"/></svg>';
  var SVG_LIEN = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ' + TRAIT + ' aria-hidden="true">' +
    '<path d="m9.364 18.5-.932.932a4.5 4.5 0 0 1-6.364-6.364l4.773-4.774a4.5 4.5 0 0 1 6.825 5.825"/>' +
    '<path d="m14.818 5.567.75-.75a4.5 4.5 0 0 1 6.364 6.364l-4.773 4.773a4.5 4.5 0 0 1-6.824-5.826"/></svg>';

  /* 28/09/2026 : sans pile (relais lent ou en echec), la loupe grossit la vignette au lieu de
     ne rien faire en changeant d'icone. */
  function pileDe(stage) { return stage.querySelector('.cm-mm__pile') || stage.querySelector('.cm-mm__base'); }

  /* La pile sert des images de 500 px, assez pour une scene de 420. Grossie, la gravure
     devient une bouillie : on repasse chaque couche sur la source 1200 que le srcset porte
     deja, donc sans nouvel appel au relais. On NE bascule PAS tout de suite : la couche
     affichee est deja en cache, la remplacer par une source a charger ferait apparaitre la
     montre couche par couche, boitier blanc compris. On charge a cote, on echange quand
     c'est pret, l'oeil ne voit que la nettete monter. */
  function passeEnGrand(noeud) {
    var imgs = noeud.tagName === 'IMG' ? [noeud] : noeud.querySelectorAll('img');
    Array.prototype.forEach.call(imgs, function (i) {
      var ss = i.getAttribute('srcset') || '';
      var grand = null;
      ss.split(',').forEach(function (part) {
        var bouts = String(part).trim().split(' ').filter(Boolean);
        var u = bouts[0], d = bouts[1] || '';
        if (!u || d.charAt(d.length - 1) !== 'w') return;
        var large = parseInt(d, 10);
        if (large && (!grand || large > grand.l)) grand = { u: u, l: large };
      });
      i.removeAttribute('srcset');
      i.removeAttribute('sizes');
      if (!grand || grand.u === i.getAttribute('src')) return;
      var pre = new Image();
      pre.onload = function () { i.setAttribute('src', grand.u); };
      pre.src = grand.u;
    });
  }

  /* --- zoom DANS la scene, avec deplacement -------------------------------------------- */
  var ZMIN = 1, ZMAX = 5, ZDEPART = 2.2;

  function etatZoom(stage) {
    if (!stage.__zoom) stage.__zoom = { k: 1, x: 0, y: 0, actif: false, grand: false };
    return stage.__zoom;
  }

  /* On empeche la montre de sortir du cadre : au-dela, le client tire dans le vide et croit
     l'avoir perdue. Quand l'image grossie tient encore dans la scene, elle reste centree. */
  function borne(stage) {
    var z = etatZoom(stage), p = pileDe(stage);
    if (!p) return;
    var r = stage.getBoundingClientRect();
    var mx = Math.max(0, (p.offsetWidth * z.k - r.width) / 2);
    var my = Math.max(0, (p.offsetHeight * z.k - r.height) / 2);
    if (z.x > mx) z.x = mx;
    if (z.x < -mx) z.x = -mx;
    if (z.y > my) z.y = my;
    if (z.y < -my) z.y = -my;
  }

  function appliqueZoom(stage) {
    var z = etatZoom(stage), p = pileDe(stage);
    if (!p) return;
    borne(stage);
    p.style.transform = z.k > 1 ? 'translate(' + z.x + 'px,' + z.y + 'px) scale(' + z.k + ')' : '';
  }

  function majLoupe(stage) {
    var b = stage.querySelector('.cm-mm__loupe');
    if (!b) return;
    var z = etatZoom(stage), T = stage.__T || {};
    b.innerHTML = z.actif ? SVG_DEZOOM : SVG_LOUPE;
    var lib = z.actif ? (T.dezoom || 'Reduce the watch') : (T.zoom || 'Enlarge the watch');
    b.setAttribute('aria-label', lib);
    b.title = lib;
  }

  function reinitZoom(stage) {
    var z = etatZoom(stage);
    z.k = 1; z.x = 0; z.y = 0; z.actif = false;
    stage.classList.remove('cm-mm__stage--zoom');
    stage.classList.remove('est-tire');
    var p = pileDe(stage);
    if (p) p.style.transform = '';
    majLoupe(stage);
  }

  function zoomeVers(stage, k) {
    var z = etatZoom(stage);
    if (k < ZMIN) k = ZMIN;
    if (k > ZMAX) k = ZMAX;
    if (k <= 1.02) { reinitZoom(stage); return; }
    z.k = k;
    if (!z.actif) {
      z.actif = true;
      stage.classList.add('cm-mm__stage--zoom');
      /* la haute definition n'est demandee qu'au premier zoom : tant que le client regarde
         la montre en 420 px, les images de 1200 seraient du reseau depense pour rien. */
      if (!z.grand) { var p = stage.querySelector('.cm-mm__pile'); if (p) { z.grand = true; passeEnGrand(p); } }
      majLoupe(stage);
    }
    appliqueZoom(stage);
  }

  function basculeZoom(stage) {
    if (etatZoom(stage).actif) reinitZoom(stage); else zoomeVers(stage, ZDEPART);
  }

  function ecart(a, b) { var dx = a.x - b.x, dy = a.y - b.y; return Math.sqrt(dx * dx + dy * dy); }

  /* Un seul jeu d'ecouteurs pour la souris et le doigt : les evenements pointeur couvrent les
     deux. Un doigt deplace, deux doigts ecartent. */
  function poseNavigation(stage) {
    if (stage.__nav) return;
    stage.__nav = true;
    var pts = {}, dep = null;
    function liste() { var a = []; for (var k in pts) if (pts.hasOwnProperty(k)) a.push(pts[k]); return a; }
    function repere(e) {
      var z = etatZoom(stage), l = liste();
      dep = { x: z.x, y: z.y, k: z.k,
              px: e ? e.clientX : (l[0] && l[0].x) || 0,
              py: e ? e.clientY : (l[0] && l[0].y) || 0,
              d: l.length > 1 ? ecart(l[0], l[1]) : 0 };
    }
    stage.addEventListener('pointerdown', function (e) {
      /* 28/09/2026 : les boutons poses sur la scene (loupe, partage, croix, « Modifier ma
         montre ») restent cliquables en zoom. La capture du pointeur envoyait leur clic a la
         scene : sur telephone, plus moyen de dezoomer ni de sortir. */
      if (e.target && e.target.closest && e.target.closest('button, a, input, .cm-mm__pop')) return;
      if (!etatZoom(stage).actif) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      try { stage.setPointerCapture(e.pointerId); } catch (x) {}
      repere(e);
      stage.classList.add('est-tire');
      e.preventDefault();
    });
    stage.addEventListener('pointermove', function (e) {
      var z = etatZoom(stage);
      if (!z.actif || !dep || !pts[e.pointerId]) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var l = liste();
      if (l.length > 1 && dep.d > 0) {
        zoomeVers(stage, dep.k * (ecart(l[0], l[1]) / dep.d));
      } else {
        z.x = dep.x + (e.clientX - dep.px);
        z.y = dep.y + (e.clientY - dep.py);
        appliqueZoom(stage);
      }
      e.preventDefault();
    });
    function fin(e) {
      delete pts[e.pointerId];
      if (!liste().length) { dep = null; stage.classList.remove('est-tire'); }
      else repere(null);
    }
    stage.addEventListener('pointerup', fin);
    stage.addEventListener('pointercancel', fin);
    /* Zoome, la molette grossit au lieu de faire defiler la colonne de droite : le client a
       le nez sur la montre, c'est elle qu'il veut bouger. On arrete la remontee, sinon le
       relais de molette pose sur le hero ferait defiler la fiche en meme temps. */
    stage.addEventListener('wheel', function (e) {
      var z = etatZoom(stage);
      if (!z.actif) return;
      zoomeVers(stage, z.k * (e.deltaY < 0 ? 1.12 : 1 / 1.12));
      e.preventDefault();
      e.stopPropagation();
    }, { passive: false });
  }

  /* --- partage -------------------------------------------------------------------------- */
  /* Le lien porte l'identifiant du design : Kickflip le lit dans l'adresse et rouvre la montre
     EXACTE, pas seulement le modele. Sans jeton de protection : la route du configurateur
     repond sans lui, et un jeton dans un lien qui circule est une cle qu'on laisse trainer. */
  function lienDesign(ctx, stage) {
    var h = (ctx && ctx.data && ctx.data.handle) || '';
    var racine = '';
    try {
      if (window.Shopify && Shopify.routes && Shopify.routes.root) racine = String(Shopify.routes.root);
    } catch (e) {}
    if (racine.charAt(racine.length - 1) === '/') racine = racine.slice(0, -1);
    var base = location.origin + racine + (h ? '/products/' + h : '/');
    /* le numero court quand le relais a repondu, l identifiant long sinon : le
       configurateur accepte les deux (verifie, un identifiant inconnu est redirige),
       mais le court est celui que le client voit dans les liens de Kickflip. */
    var id = (stage && stage.__designNum) || designDeCtx(ctx);
    return id ? base + '?designId=' + encodeURIComponent(id) : base;
  }

  /* v6.22 : « Enregistrer l'image » est retire. Kickflip ne genere ses rendus 1080 px que
     quand on les lui demande, et un favori est par definition une montre pas encore
     commandee : le bouton rendait donc le plus souvent la vignette de 250 px. Refaire
     l'image a partir de nos calques n'est pas une option non plus, le texte grave droit est
     un <foreignObject> que les navigateurs refusent de dessiner dans un canvas, et la montre
     sortirait sans sa gravure. Un bouton qui ment vaut moins que pas de bouton. */

  /* Le vieux chemin, pour quand navigator.clipboard manque ou refuse : vieux Safari, WebView
     Android, permission refusee. Sans ce filet le clic ne faisait RIEN et le client n'avait
     aucun moyen de le savoir. */
  function vieilleCopie(txt) {
    try {
      var z = document.createElement('textarea');
      z.value = txt;
      z.setAttribute('readonly', '');
      z.style.position = 'fixed';
      z.style.top = '-1000px';
      z.style.opacity = '0';
      document.body.appendChild(z);
      z.select();
      try { z.setSelectionRange(0, txt.length); } catch (e) {}
      var fait = document.execCommand('copy');
      z.remove();
      return !!fait;
    } catch (e) { return false; }
  }

  function copieTexte(txt, fini) {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(txt)
          .then(function () { fini(true); })
          ['catch'](function () { fini(vieilleCopie(txt)); });
        return;
      }
    } catch (e) {}
    fini(vieilleCopie(txt));
  }

  /* Dernier recours : on MONTRE le lien, selectionne. Un bouton qui ne fait rien est pire
     qu'un champ a copier a la main. */
  function montreLien(pop, url) {
    var deja = pop.querySelector('.cm-mm__pop-url');
    if (deja) { try { deja.focus(); deja.select(); } catch (e) {} return; }
    var i = el('input', 'cm-mm__pop-url');
    i.type = 'text';
    i.value = url;
    i.readOnly = true;
    pop.appendChild(i);
    try { i.focus(); i.select(); } catch (e) {}
  }

  function fermePop(stage) {
    var p = stage.querySelector('.cm-mm__pop');
    if (p) p.remove();
    if (stage.__popClic) {
      document.removeEventListener('pointerdown', stage.__popClic, true);
      document.removeEventListener('keydown', stage.__popTouche, true);
      stage.__popClic = null;
      stage.__popTouche = null;
    }
  }

  function ouvrePartage(stage, ctx, bouton) {
    if (stage.querySelector('.cm-mm__pop')) { fermePop(stage); return; }
    var T = (ctx && ctx.T) || {};
    var pop = el('div', 'cm-mm__pop');
    pop.setAttribute('role', 'dialog');
    if (ctx.data && ctx.data.image) {
      var ap = el('img', 'cm-mm__pop-img');
      /* la vignette suffit : elle est affichee sur 240 px de large et elle est deja en cache,
         la carte des favoris vient de l'afficher. */
      ap.src = ctx.data.image;
      ap.alt = '';
      pop.appendChild(ap);
    }
    function ligne(libelle, svg, quoi) {
      var b = el('button', 'cm-mm__pop-act');
      b.type = 'button';
      var t = el('span', 'cm-mm__pop-txt', libelle);
      var i = el('span', 'cm-mm__pop-ico');
      i.innerHTML = svg;
      b.appendChild(t);
      b.appendChild(i);
      b.addEventListener('click', function () { quoi(t); });
      pop.appendChild(b);
    }
    ligne(T.copyLink || 'Copy link', SVG_LIEN, function (t) {
      var url = lienDesign(ctx, stage);
      copieTexte(url, function (reussi) {
        if (!reussi) { montreLien(pop, url); return; }
        var avant = t.textContent;
        t.textContent = texteClair(T.shareCopie || 'Link copied');
        setTimeout(function () { t.textContent = avant; }, 1800);
      });
    });
    stage.appendChild(pop);
    stage.__popClic = function (e) {
      if (pop.contains(e.target) || (bouton && bouton.contains(e.target))) return;
      fermePop(stage);
    };
    stage.__popTouche = function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); fermePop(stage); }
    };
    /* pose au tour suivant : sinon le clic qui vient d'ouvrir la fenetre la referme */
    setTimeout(function () {
      document.addEventListener('pointerdown', stage.__popClic, true);
      document.addEventListener('keydown', stage.__popTouche, true);
    }, 0);
  }

  /* Les commandes ne sont posees que s'il y a quelque chose a montrer. */
  function poseControles(stage, ctx) {
    if (stage.querySelector('.cm-mm__ctrl')) return;
    stage.__T = (ctx && ctx.T) || {};
    var barre = el('div', 'cm-mm__ctrl');
    var loupe = el('button', 'cm-mm__loupe');
    loupe.type = 'button';
    loupe.addEventListener('click', function () { fermePop(stage); basculeZoom(stage); });
    barre.appendChild(loupe);
    var part = el('button', 'cm-mm__part');
    part.type = 'button';
    part.innerHTML = SVG_PARTAGE;
    part.setAttribute('aria-label', (ctx && ctx.T && ctx.T.share) || 'Share my watch');
    part.title = part.getAttribute('aria-label');
    part.addEventListener('click', function () { ouvrePartage(stage, ctx, part); });
    barre.appendChild(part);
    stage.appendChild(barre);
    majLoupe(stage);
    poseNavigation(stage);
  }

  function poseVues(stage, imgBase, ctx) {
    var id = designDeCtx(ctx);
    if (!id) return;
    demandeVues(id, function (rep) {
      /* le numero court du design, celui que Kickflip met dans ses propres liens de
         partage. Le relais le renvoie a chaque appel : on le garde pour « Copier le
         lien ». Pose AVANT les sorties anticipees, il vaut meme si aucune vue n est
         composable. */
      if (rep && rep.designId) stage.__designNum = String(rep.designId);
      if (!rep || !rep.vues || !rep.vues.length) return;
      var jeux = rep.vues;
      var grav = rep.gravures || [];
      var teint = rep.teintes || [];
      var piles = rep.pile || [];
      /* Une vue COMPOSEE d'une seule couche ne montre rien d'utile, on l'ecarte. Mais quand
         Kickflip a deja genere ses images, le relais rend UNE image complete par vue : la
         meme regle la jetterait alors que c'est la meilleure source possible. */
      var mini = rep.viewIndices || rep.source !== 'compose' ? 1 : 2;
      /* on ecarte les vues et LEURS gravures ensemble : filtrer les seules images decalait
         d'un cran la liste des textes, et la gravure du fond partait sur le cadran. */
      var gardees = [];
      jeux.forEach(function (v, i) {
        if (v && v.length >= mini) {
          gardees.push({ index: rep.viewIndices && Number.isInteger(rep.viewIndices[i]) ? rep.viewIndices[i] : i, urls: v, grav: grav[i] || [], teint: teint[i] || [], spec: piles[i] || null });
        }
      });
      if (!gardees.length) return;
      jeux = gardees.map(function (x) { return x.urls; });
      grav = gardees.map(function (x) { return x.grav; });
      teint = gardees.map(function (x) { return x.teint; });
      var specs = gardees.map(function (x) { return x.spec; });
      /* la pile ordonnee quand le relais la donne, l'ancien chemin sinon */
      function faisPile(i, t) {
        return specs[i] ? pileDeSpec(specs[i], t) : pileAvecGravures(jeux[i], grav[i], t, teint[i]);
      }
      /* la fenetre a pu se fermer pendant l'appel */
      if (!stage.isConnected) return;
      var noms = LIB_VUES[lang()] || LIB_VUES.en;
      var motVue = { fr: 'Vue', en: 'View', de: 'Ansicht', it: 'Vista', es: 'Vista', nl: 'Aanzicht', pt: 'Vista' }[lang()] || 'View';
      /* Face, Profil, Fond : l'ordre des modeles a 3 vues. Les modeles a 5 vues (SeaRanger,
         OceanMaster) rangent autrement leurs vues, donc un numero plutot qu'un nom faux. */
      var nomme = !rep.viewCount || rep.viewCount === 3;
      function nomVue(i) { return (nomme && noms[gardees[i].index]) || motVue + ' ' + (gardees[i].index + 1); }
      var titre = (ctx.data && ctx.data.title) || '';
      var pile = faisPile(0, titre);
      /* 28/09/2026 : la pile n'entre en scene qu'une fois ses couches chargees (3 s au plus).
         Posee tout de suite, elle poussait la vignette de cote puis montrait la montre couche
         par couche. Si toutes ses couches echouent, la vignette reste, et aucune vue n'est
         proposee (les vignettes de vues n'auraient plus rien a montrer). */
      quandPrete(pile, 3000, function (ok) {
        if (!ok || !stage.isConnected) return;
        stage.insertBefore(pile, stage.firstChild);
        if (imgBase) imgBase.style.display = 'none';
        if (etatZoom(stage).actif) reinitZoom(stage);
        if (jeux.length < 2) return;
        var barre = el('div', 'cm-mm__vues');
        function marque(b) {
          barre.querySelectorAll('.cm-mm__vue').forEach(function (x) { x.classList.remove('est-actif'); x.setAttribute('aria-pressed', 'false'); });
          b.classList.add('est-actif');
          b.setAttribute('aria-pressed', 'true');
        }
        jeux.forEach(function (urls, i) {
          var b = el('button', 'cm-mm__vue' + (i === 0 ? ' est-actif' : ''));
          b.type = 'button';
          b.title = nomVue(i);
          b.setAttribute('aria-label', nomVue(i));
          b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
          TAILLE_COUCHE = '60px';
          try { b.appendChild(faisPile(i, null)); } finally { TAILLE_COUCHE = null; }
          b.addEventListener('click', function () {
            if (b.classList.contains('est-actif')) return;
            var avant = barre.querySelector('.cm-mm__vue.est-actif');
            marque(b);
            /* l'ancienne vue reste affichee jusqu'a ce que la nouvelle soit prete (2,5 s au
               plus) : la grande image ne passe plus par le blanc. */
            var neuve = faisPile(i, titre);
            quandPrete(neuve, 2500, function (ok2) {
              if (!b.classList.contains('est-actif') || !stage.isConnected) return;
              if (!ok2) { if (avant) marque(avant); return; }
              var vieille = stage.querySelector('.cm-mm__pile');
              if (vieille) stage.replaceChild(neuve, vieille);
              else stage.insertBefore(neuve, stage.firstChild);
              reinitZoom(stage);
              /* la haute definition est redemandee au prochain zoom, pour CETTE vue */
              etatZoom(stage).grand = false;
            });
          });
          barre.appendChild(b);
        });
        stage.parentNode.insertBefore(barre, stage.nextSibling);
      });
    });
  }

  /* Appelle cb(ok) quand toutes les images du noeud sont chargees ou en echec, ou au bout de
     max ms. ok est faux seulement si TOUTES ont echoue. Les images se chargent meme hors de
     la page, ce qui permet de preparer une vue avant de la montrer. */
  function quandPrete(noeud, max, cb) {
    var imgs = noeud.querySelectorAll('img'), reste = imgs.length, rates = 0, fini = false;
    function fin() { if (fini) return; fini = true; cb(!imgs.length || rates < imgs.length); }
    if (!reste) { fin(); return; }
    [].forEach.call(imgs, function (im) {
      if (im.complete) { if (!im.naturalWidth) rates++; if (--reste === 0) fin(); return; }
      im.addEventListener('load', function () { if (--reste === 0) fin(); }, { once: true });
      im.addEventListener('error', function () { rates++; if (--reste === 0) fin(); }, { once: true });
    });
    setTimeout(fin, max);
  }

  function render(host, ctx) {
    ensureCss();
    if (ctx && ctx.T) completeLibelles(ctx.T);
    host.innerHTML = '';
    var saved = false;
    var achatParti = 0;
    /* Retrait de l ecouteur Echap, pose plus bas et seulement en mode fenetre. Il se retirait
       DEJA lui-meme, mais a la premiere touche pressee apres la disparition de la carte : entre
       la fermeture et cette touche, chaque ouverture en ajoutait un de plus sur document. */
    var retireEchap = null;
    /* TOUTE fermeture passe par ici : la croix, Echap, le clic sur le voile, « Retour au
       configurateur » et « Continuer mes achats ». C est le chemin qui detruit la carte, donc
       le seul endroit ou l ecouteur clavier peut mourir avec elle. */
    function fermeEcran() {
      try { track(saved ? 'fermeture_apres_save' : 'fermeture'); } catch (e) {}
      if (retireEchap) { try { retireEchap(); } catch (e) {} retireEchap = null; }
      if (ctx.onClose) ctx.onClose();
    }
    /* la surface le DIT, le moteur ne le devine pas. Un test sur le parent .cm-ov ferait
       dependre le moteur d un nom de classe cree dans un autre fichier et absent de son contrat
       d API : renommer .cm-ov ferait disparaitre la fenetre en silence, sans erreur console. */
    var mm = el('div', 'cm-mm' + (ctx.fenetre ? ' cm-mm--fenetre' : ''));
    host.appendChild(mm);
    if (ctx.showClose && ctx.onClose) {
      /* v6.24 (13/09, Marc) : sur l ecran d apres configuration la croix devient un bouton libelle
         « Modifier ma montre », a GAUCHE de la carte. Une croix anonyme dit « fermer », donc « perdre
         plusieurs minutes de travail » ; le configurateur reste charge derriere avec la configuration
         intacte, donc le libelle dit vrai. A gauche parce qu a droite, sur telephone, la croix
         recouvrait l icone de partage a 82 % (mesure du 13/09). La fiche d un favori garde la croix :
         fermer y ramene a la liste, pas au configurateur. */
      var enOverlay = !!ctx.interceptKey;
      var close = el('button', 'cm-mm__close' + (enOverlay ? ' cm-mm__close--libelle' : ' cm-mm__close--scene'));
      close.type = 'button';
      if (enOverlay) {
        close.appendChild(el('span', 'cm-mm__close-ch', '\u2039'));
        close.appendChild(el('span', 'cm-mm__close-txt', ctx.T.modify));
      } else {
        /* v6.30 : une icone au trait, pas le caractere « x » : le glyphe changeait de graisse et
           de centrage selon la police du client, l icone se dessine pareil partout. */
        close.innerHTML = SVG_CROIX;
        close.title = ctx.T.close;
      }
      /* l etiquette etait le mot anglais 'close', ecrit en dur, sur un ecran qui existe en
         7 langues. Elle vient maintenant des SECOURS, comme tous les autres libelles. */
      close.setAttribute('aria-label', enOverlay ? ctx.T.modify : ctx.T.close);
      /* TOUTE sortie passe par ici et jamais par ctx.onClose en direct.
         v6.29 (14/09, Lino) : « Modifier ma montre » ferme, tout de suite. L ecran d attente
         (« Cette montre n est gardee que sur cet appareil » + « Recevoir le lien par email »)
         est retire : il barrait la route a un client qui demandait seulement a retoucher sa
         montre, et il la barrait au pire moment, celui ou l envie de modifier est encore
         chaude. Rien n est perdu en fermant : le configurateur est reste charge derriere avec
         la configuration intacte, donc le bouton tenait deja sa promesse sans peage.
         Le verrou de 700 ms reste : Echap, le clic sur le voile et le double clic reflexe
         arrivent tous ici, et fermer deux fois rejouerait ctx.onClose sur un hote demonte. */
      var dernierGeste = 0;
      function demandeFermeture() {
        var t = Date.now();
        if (t - dernierGeste < 700) return;
        dernierGeste = t;
        fermeEcran();
      }
      close.addEventListener('click', demandeFermeture);
      /* v6.29 (14/09, 0 h) avait retire la croix de la fiche d un favori, en comptant sur le
         retour du navigateur (la page pousse une entree d historique vers /pages/my-watch?d=).
         v6.30 (14/09, 10 h 40, Lino) la remet : « quand on clique sur sa montre, met une croix en
         haut a gauche, bien affichee, bien alignee, pour quitter la fenetre ». Le retour du
         navigateur ferme toujours (popstate cote page) ; la croix est une deuxieme porte, visible
         celle-la. Elle est posee plus bas, sur la scene, comme le bouton « Modifier ma montre »
         de l ecran d apres configuration, au coin oppose de la loupe et du partage.
         Echap et le clic sur le voile restent armes sur grand ecran (bloc ci-dessous). */
      /* Sorties supplementaires, surface fenetre seulement : un fond assombri cree l attente
         qu Echap et le clic dehors ferment, et une carte qui ignore les deux passe pour cassee la
         ou une page pleine ne promettait rien.
         L ecouteur clavier se retire LUI-MEME : le moteur n est pas prevenu de la fermeture de
         l hote, et l overlay etant recree a neuf a chaque ouverture, un ecouteur oublie sur
         document se declencherait en double a la reouverture.
         Echap est ignore dans un champ de saisie : sur l ecran post-enregistrement le client tape
         son adresse, input.focus() est meme force a 250 ms, et le reflexe Echap dans un champ
         detruirait tout l ecran.
         Le clic sur le voile teste mousedown ET click : la carte est un descendant de l hote, donc
         un clic interieur remonte jusqu ici, bouton d achat compris ; et une selection de texte
         commencee dans la carte et relachee sur le voile emet un click dont la cible est le voile,
         donc fermeture en pleine lecture de la configuration. Il est gate par mqFenetre pour que
         redimensionner sous le seuil ne laisse pas un clic-pour-fermer sur un ecran redevenu blanc
         et plein, ou le fond n est plus lisible comme un dehors. */
      if (ctx.fenetre) {
        var surEchap = function (e) {
          if (!document.contains(mm)) { document.removeEventListener('keydown', surEchap); return; }
          if (e.repeat) return;
          if (e.key !== 'Escape' && e.key !== 'Esc') return;
          var balise = e.target && e.target.tagName;
          if (balise === 'INPUT' || balise === 'TEXTAREA' || balise === 'SELECT') return;
          e.preventDefault();
          /* 28/09/2026 : en zoom, Echap ramene d'abord la montre a sa taille */
          var sc = mm.querySelector('.cm-mm__stage');
          if (sc && etatZoom(sc).actif) { reinitZoom(sc); return; }
          demandeFermeture();
        };
        document.addEventListener('keydown', surEchap);
        retireEchap = function () { document.removeEventListener('keydown', surEchap); };
        var cibleBas = null;
        host.addEventListener('mousedown', function (e) { cibleBas = e.target; });
        host.addEventListener('click', function (e) {
          if (!mqFenetre || !mqFenetre.matches) return;
          if (e.target !== host || cibleBas !== host) return;
          demandeFermeture();
        });
      }
      /* Plus de logo de sortie ici. Il n'existait que parce que cet ecran recouvrait tout
         le site et qu'il fallait une porte vers l'avant. Depuis le 31/08 l'ecran s'ouvre
         SOUS le header, qui offre deja le logo, le menu, la recherche, les favoris et le
         panier : en remettre un ferait deux logos Chrono Mod l'un au-dessus de l'autre. */
    }
    var inner = el('div', 'cm-mm__inner');
    mm.appendChild(inner);
    /* v5.5 : entete pleine largeur, puis deux colonnes (montre a gauche, infos a droite),
       puis la bande lunette pleine largeur. Objectif : tout voir sans scroller. */
    var head = el('div', 'cm-mm__head');
    head.appendChild(el('div', 'cm-mm__eyebrow', ctx.T.eyebrow));
    head.appendChild(el('h1', 'cm-mm__title', ctx.data.title || 'Chrono Mod'));
    /* ctx.meta : sous le titre, en gris discret. La fiche de « Mes montres » y met sa date de
       sauvegarde, qui occupait le sur-titre et sortait donc en capitales espacees. */
    if (ctx.meta) head.appendChild(el('div', 'cm-mm__meta', ctx.meta));
    var col = el('div', 'cm-mm__col');
    col.appendChild(head);
    var hero = el('div', 'cm-mm__hero');
    /* la scene porte la montre, le bloc d achat est colle sous elle. C est la reponse au
       « y a beaucoup d espace en dessous de la montre » : on le consomme au lieu de
       l agrandir, et le chemin d achat sort de la zone defilante. */
    var stage = el('div', 'cm-mm__stage');
    /* la vignette Kickflip s'affiche tout de suite, les couches viennent par-dessus quand le
       relais repond. Si le relais est muet, lent ou en panne, l'ecran reste exactement celui
       d'avant : jamais de scene vide. */
    var imgBase = null;
    if (ctx.data.image) {
      imgBase = el('img', 'cm-mm__base');
      imgBase.src = ctx.data.image;
      imgBase.alt = ctx.data.title || '';
      stage.appendChild(imgBase);
    }
    hero.appendChild(stage);
    /* v6.30 : la croix (favori) comme le bouton libelle (apres configuration) vivent sur la scene */
    if (typeof close !== 'undefined' && close) stage.appendChild(close);
    if (ctx.data.image) poseControles(stage, ctx);
    var buy = el('div', 'cm-mm__buy');
    hero.appendChild(buy);
    inner.appendChild(hero);
    /* 28/09/2026 : APRES l'accrochage du hero. Un design deja en cache repond tout de suite, a
       un moment ou la scene n'etait pas encore dans la page : poseVues abandonnait, et la
       fenetre rouverte pour le meme design restait sans vues. */
    poseVues(stage, imgBase, ctx);
    inner.appendChild(col);
    /* dans la carte, le seul conteneur defilant est la colonne de droite : le hero, inner, la
       carte, le voile et <html> sont tous bloques. La molette posee sur l image de la montre,
       soit 42 % de la carte et justement l element que le client regarde, ne ferait plus rien et
       la fenetre passerait pour figee. On relaie. Le gate est mqFenetre et non un test sur la
       scrollabilite : entre 900 px et le seuil, la colonne EST deja un ascenseur et le rendu de
       cette plage ne doit pas bouger. L ecouteur meurt avec le noeud hero. */
    /* le gate ctx.fenetre a saute : mqFenetre suffit, et le relais doit exister des que la
       carte existe. Sans lui, la moitie gauche de la carte, l element que le client regarde,
       ne repond pas a la molette et la fenetre passe pour figee. */
    hero.addEventListener('wheel', function (e) {
      if (!mqFenetre || !mqFenetre.matches) return;
      if (col.scrollHeight <= col.clientHeight) return;
      col.scrollTop += e.deltaY;
      e.preventDefault();
    }, { passive: false });
    /* v5.9 : meme enchainement que la fiche detail de "Mes montres" : prix, carte
       d'identite, tableau de configuration, bandes composants, puis les boutons. */
    /* v5.4 : carte d'identite, trois lignes qui repondent a "vraie montre ou gadget" */
    var idcard = specsFor((ctx.data && ctx.data.handle) || '', lang(), ctx.data && ctx.data.options);
    if (idcard) {
      var idc = el('div', 'cm-mm__id');
      idcard.forEach(function (line) { idc.appendChild(el('span', null, line)); });
      col.appendChild(idc);
    }
    /* v6.24 (13/09, Marc) : le tableau ne montre plus les lignes techniques que le tiroir panier
       filtre depuis le 08/09 (drapeau « Custom Text », code hexadecimal, porte « Add engraving »,
       adresse de fichier), et les textes graves en SORTENT pour aller en tete du recapitulatif,
       entre guillemets, avec « definitive : relisez-la ». Une gravure non relue est une piece
       invendable ; noyee en douzieme ligne, elle n etait pas relue. */
    var gravures = [], lignesTable = [];
    if (ctx.data.options && ctx.data.options.length) {
      optionsUniques(ctx.data.options).forEach(function (p) {
        var k = String(p[0] || ''), v = String(p[1] || '').trim();
        if (ligneTechnique(k, v)) return;
        if (RE_GRAV_CLE.test(k) && !RE_GRAV_NOT.test(k)) { gravures.push(p); return; }
        lignesTable.push(p);
      });
    }
    if (gravures.length) {
      var gb = el('div', 'cm-mm__gravure');
      gb.appendChild(el('div', 'cm-mm__h2', ctx.T.gravTitle));
      gravures.forEach(function (p) {
        var it = el('div', 'cm-mm__gravure-item');
        if (gravures.length > 1) it.appendChild(el('span', 'cm-mm__gravure-k', ctx.traduitOptions ? libelle(p[0]) : p[0]));
        /* 28/09/2026 : le texte EXACT, sans passer par texteClair (qui remplacait les tirets,
           fusionnait les espaces et decodait les entites). C'est le bloc « relisez-la ». */
        var gt = el('span', 'cm-mm__gravure-txt');
        gt.textContent = '\u00ab\u00a0' + String(p[1]) + '\u00a0\u00bb';
        it.appendChild(gt);
        gb.appendChild(it);
      });
      gb.appendChild(el('div', 'cm-mm__gravure-note', ctx.T.gravNote));
      col.appendChild(gb);
    }
    if (lignesTable.length) {
      col.appendChild(el('h2', 'cm-mm__h2', ctx.T.confTitle));
      var ul = el('ul', 'cm-mm__opts cm-mm__opts--conf');
      lignesTable.forEach(function (p) {
        var li = el('li');
        /* ctx.traduitOptions : les libelles arrivent dans la langue ou la montre a ete
           configuree, pas dans celle de la page qu on regarde. libelle() fait l aller-retour
           par le glossaire et rend de, es, nl et pt lisibles. Le drapeau est pose par la fiche
           de « Mes montres » et par elle seule. */
        li.appendChild(el('span', null, ctx.traduitOptions ? libelle(p[0]) : p[0]));
        var val = el('span', null, ctx.traduitOptions ? libelle(p[1]) : p[1]);
        /* v5.17 : une couleur choisie par le client arrive en code hexadecimal. « #FF0000 »
           tout nu ne dit rien a personne : on pose la pastille de la couleur devant. */
        if (RE_HEX.test(String(p[1] || '').trim())) {
          var pastille = el('span', 'cm-mm__pastille');
          pastille.style.background = String(p[1]).trim();
          val.insertBefore(pastille, val.firstChild);
        }
        li.appendChild(val);
        ul.appendChild(li);
      });
      col.appendChild(ul);
    }
    /* v6.24 (13/09, Marc) : trois engagements sous le tableau, avant les specifications. Effet
       conversion nul ou legerement negatif, assume : coherence avec ce qu on tient vraiment, et la
       photo avant expedition est la seule phrase de cet ecran que ni Rolex ni les concurrents ne
       peuvent ecrire. Pas de « vous validez le rendu par ecrit » tant que ce n est pas fait sur
       100 % des commandes gravees. */
    var eng = el('ul', 'cm-mm__engagements');
    [ctx.T.made, ctx.T.photo, ctx.T.warranty].forEach(function (t) { if (t) eng.appendChild(el('li', null, t)); });
    col.appendChild(eng);

    /* v6.4 : le bloc SPECIFICATIONS, sous le tableau de configuration et JAMAIS au-dessus du
       bouton : le releve CRO du 05/09 dit que 60 % des visiteurs ne descendent pas plus bas que
       la zone d'achat, donc rien de ce qui rassure ne doit s'interposer avant elle.
       Ouvert sur la fiche d'une montre favorite, ou le client compare et reviendra ; replie sur
       l'ecran d'apres configuration, ou il vient d'ajouter au panier et n'a rien a lire. */
    var lignesSpec = ficheSpecs((ctx.data && ctx.data.handle) || '', lang(), ctx.data && ctx.data.options);
    if (lignesSpec) {
      var det = el('details', 'cm-mm__specs');
      /* v6.6 : ouvert PARTOUT. Il etait replie apres l'ajout au panier, au motif que le client
         venait d'acheter et n'avait plus rien a lire. Lino, 08/09 : « je veux que les specs
         soient affichees en fonction de la montre configuree ». Le bloc vit dans la colonne de
         droite, sous le tableau de configuration ; le bouton d'achat est dans la colonne de
         gauche, sous l'image. L'ouvrir n'eloigne donc pas le bouton, ca ne fait qu'allonger la
         colonne qui se defile deja. */
      /* v6.24 (13/09, Marc) : ouvert en fenetre (PC), ou la colonne a la place ; replie en flux
         (telephone, page), ou ses 439 px repoussaient les bandes et la reassurance a 1 793 px.
         Le titre garde diametre et epaisseur en apercu, donc rien d utile n est cache. */
      det.open = !!(mqFenetre && mqFenetre.matches);
      /* Replie, le bloc ne disait que « Specifications » : les deux cotes que le client cherche
         vraiment restaient derriere un clic qu'il ne fait pas. On les remonte dans le titre,
         diametre et epaisseur, ce qui laisse le detail au clic sans rien cacher d'utile. */
      var LS = LIB_SPEC[lang()] || LIB_SPEC.en;
      var apercu = [];
      lignesSpec.forEach(function (pp) {
        if (pp[0] === LS.diam || pp[0] === LS.ep) apercu.push(pp[1]);
      });
      var sum = el('summary', null, LS.titre + (apercu.length ? '  ·  ' + apercu.join('  ·  ') : ''));
      det.appendChild(sum);
      var uls = el('ul', 'cm-mm__opts');
      lignesSpec.forEach(function (p) {
        var li = el('li');
        li.appendChild(el('span', null, p[0]));
        li.appendChild(el('span', null, p[1]));
        uls.appendChild(li);
      });
      det.appendChild(uls);
      col.appendChild(det);
    }

    /* --- bande composant : image a gauche, texte a droite (v5.2 : fonction partagee) --- */
    /* v5.7 : trois bandes dans l'ordre lunette, cadran, bracelet. L'image alterne d'un cote
       a l'autre au fil des bandes reellement affichees, pour garder le rythme meme quand une
       piece n'a pas d'image. */
    var h = (ctx.data && ctx.data.handle) || '';
    /* les bandes sont posees dans un conteneur a elles : si la table arrive apres coup, on les
       redessine sans toucher au reste de la fiche (boutons, mentions). */
    var bandes = el('div', 'cm-mm__bandes');
    /* v6.25 (13/09, Lino) : les bandes ne sont plus posees. Elles repetaient le tableau de
       configuration avec une image, sous un hero qui montre deja la montre en trois vues, et
       la promesse de photo avant expedition vit maintenant dans les engagements. « L oeil est
       perdu avec toutes ces infos. » Le code des bandes reste, il n est plus appele. */
    function poseBandes() {
      bandes.innerHTML = '';
      [buildBand(ctx.data.options, h, true),
       buildDialBand(ctx.data.options, h, true, true, ctx.data && ctx.data.logo),
       buildStrapBand(ctx.data.options, h, true)].forEach(function (b) {
        if (!b) return;
        /* plus d alternance : concue pour des bandes pleine largeur, elle decalait le texte
           d une bande sur deux de 244 px dans une colonne et cassait la marge gauche. */
        b.className = b.className.replace(/ ?cm-mm__comp--rev/, '');
        bandes.appendChild(b);
      });
    }
    /* poseBandes() n est plus appele (v6.25). */

    /* v5.9 : les boutons viennent APRES les bandes, comme sur la fiche detail. Places avant,
       ils recouvraient le bas de la bande bracelet, donc le fermoir. */
    var actions = el('div', 'cm-mm__actions');
    col.appendChild(actions);
    /* v6.24 (13/09, Marc) : la ligne de confiance etait a 1 793 px de profondeur sur telephone et sous
       la ligne de flottaison sur les trois tailles : payee, jamais lue. En fenetre (PC) elle vit sous
       le bouton d achat, dans le vide de la colonne gauche ; en flux (telephone, page) elle vit sous
       la carte d identite, avant le recapitulatif. */
    if (ctx.trust && ctx.trust.length) {
      /* deux noeuds, le CSS n en montre qu un a la fois : celui de la colonne partout, celui du
         hero seulement en fenetre d au moins 1000 px de haut. Sur un 1440x900 la ligne posee sous
         le bouton prenait 40 px a la montre (560 -> 370 de haut, mesure du 13/09). */
      function fabriqueTrust(cls) {
        var n = el('div', 'cm-mm__trust ' + cls);
        ctx.trust.forEach(function (t, i) {
          if (!t) return;
          /* v6.25 (13/09, Lino) : pas de delai ici, il change par region et il est calcule au
             panier et au checkout. Seules les deux premieres mentions passent (suivi, taxes),
             quel que soit ce que la surface envoie en troisieme. */
          if (i >= 2) return;
          /* la deuxieme mention est cart.drawer.tax_line du theme, 55 caracteres : en pastille
             sur 307 px elle prend deux lignes a elle seule. Version courte, meme sens. Ordre du
             tableau fixe par le snippet, la review et la page : suivi, taxes, delai. */
          if (i === 1 && ctx.T.taxes) t = ctx.T.taxes;
          n.appendChild(el('span', 'cm-mm__trust-item', t));
        });
        return n;
      }
      var trHaut = fabriqueTrust('cm-mm__trust--haut');
      if (idc) col.insertBefore(trHaut, idc.nextSibling);
      else col.insertBefore(trHaut, head.nextSibling);
      hero.appendChild(fabriqueTrust('cm-mm__trust--hero'));
    }

    /* v5.4 : plus de second bouton "Ajouter au panier" en bas. Il faisait doublon avec celui
       du haut et laissait croire au client qu'il avait rate quelque chose entre les deux. */

    var sticky = el('div', 'cm-mm__sticky');
    mm.appendChild(sticky);
    /* La barre du telephone n a pas une hauteur fixe : une rangee nue, deux des qu un lien
       secondaire existe, trois quand l appelant y glisse un message d echec d ajout. La reserve
       .cm-mm{padding-bottom:88px} etait une valeur DEVINEE pour une rangee, et le bas de la
       colonne passait sous la barre des qu il y en avait deux. On mesure la barre reelle et on
       pose ce qu elle demande, plus 16 px de respiration.
       Hauteur nulle = barre masquee, c est a dire une carte au-dessus du seuil, qui pose
       elle-meme padding-bottom:0 : on efface la mesure, un style en ligne battrait cette regle
       et rouvrirait un trou en pied de carte. C est la BARRE qu on interroge et non le seuil :
       /pages/my-watch n est pas une fenetre et garde sa barre a toutes les tailles, la reserve
       doit donc y vivre aussi sur grand ecran. */
    function caleReserve() {
      var h = sticky.offsetHeight;
      mm.style.paddingBottom = h ? (h + 16) + 'px' : '';
    }
    /* la hauteur bouge aussi sans nouvelle garniture : message d erreur insere par l appelant,
       rotation de l ecran, franchissement du seuil de la carte. L observateur suit la barre
       elle-meme, ce qui couvre les trois cas d un seul geste. Il s eteint tout seul avec le
       noeud observe, qui meurt avec la couche. */
    try {
      if (window.ResizeObserver) new window.ResizeObserver(function () { caleReserve(); }).observe(sticky);
    } catch (e) {}

    function scrollToActions() {
      try { actions.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
    }
    /* v5.4 : mesure. Le debat "le bouton email cannibalise-t-il l'achat" n'est pas tranche :
       on compte les clics de chaque bouton avant de decider quoi que ce soit. */
    /* v6.23 (13/09) : quatre sorties mesurables, fenetre vue / achat / save / fermeture, sur les
       canaux deja presents dans le theme : GA4 par gtag (sinon dataLayer), Clarity, Klaviyo,
       pixels Shopify. Surface : overlay = apres configuration, fiche = depuis « Mes montres »,
       page = /pages/my-watch. Sans ces evenements on ne saura jamais ce que la fenetre a fait
       (Marc, du 25/08 au 13/09). Chaque canal est isole dans son try : un tracker absent ou
       casse ne doit jamais toucher l ecran d achat. */
    var surface = ctx.interceptKey ? 'overlay' : (ctx.fenetre ? 'fiche' : 'page');
    function track(bouton) {
      var master = (ctx.data && ctx.data.handle) || '';
      var designId = ctx.interceptKey || (ctx.data && ctx.data.id) || '';
      try {
        if (window.klaviyo && window.klaviyo.push) {
          window.klaviyo.push(['track', 'Ma Montre Click', { Button: bouton, Surface: surface, Master: master, DesignID: designId }]);
        }
      } catch (e) {}
      try {
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'ma_montre', { action: bouton, surface: surface, master: master, design_id: designId });
        } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          window.dataLayer.push({ event: 'ma_montre', action: bouton, surface: surface, master: master, design_id: designId });
        }
      } catch (e) {}
      try {
        if (typeof window.clarity === 'function') {
          window.clarity('set', 'ma_montre', bouton);
          window.clarity('event', 'ma_montre_' + bouton);
        }
      } catch (e) {}
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('ma_montre', { action: bouton, surface: surface, master: master, design_id: designId });
        }
      } catch (e) {}
    }
    track('vue');
    /* v6 : la mise en favori est un GESTE du client, plus une consequence du chargement.
       claimed dit si CETTE montre a deja ete revendiquee ; le clic appelle ctx.onFavClaim,
       qui est ce qui fait vraiment entrer la montre dans « Mes montres », puis ouvre le
       bloc email. Avant le v6 la montre y etait deja avant l'affichage, et le badge du
       coeur montait tout seul (retour Lino du 03/09). */
    var claimed = !!ctx.isClaimed;
    /* La barre collante porte les DEUX gestes, a toutes les tailles. Les reproduire dans
       la colonne ferait deux objets identiques sur le meme ecran, ce que la version
       mobile evitait deja par CSS ; le PC suit maintenant la meme regle. Le bouton
       enveloppe du v5186 est remplace par ce coeur : il ouvre le meme bloc email, mais il
       commence par faire entrer la montre en favori, ce que l'enveloppe ne pouvait pas
       dire tant que l'enregistrement etait automatique. */
    /* sansCoeur : la barre garde le prix et le bouton d achat, mais pas le coeur. Elle sert aux
       deux ecrans de sortie, ou le coeur ferait doublon avec le bouton deja affiche dans
       .cm-mm__actions. Avant ce parametre, ces deux ecrans masquaient la barre ENTIERE : or son
       bouton est le seul « Ajouter au panier » de l ecran depuis le v5.4, il ne restait donc
       aucun chemin d achat, sur aucune taille. Depuis le 04/09 la barre ne se masque plus du
       tout : le prix et le bouton noir restent la dans TOUS les etats, sur toutes les tailles,
       et seul le coeur s efface quand l ecran en affiche deja un. */
    /* Une seule fabrique pour les deux conteneurs : le bloc sous la montre (PC) et la barre
       basse (telephone). Le CSS n en montre qu un a la fois, donc le prix, le coeur et le
       bouton noir ne peuvent plus exister en double a l ecran, dans aucun etat. */
    /* v6.26 (13/09, Lino : « ca on affiche vrai ou pas ? ») : Klarna via Shopify Payments France
       n est propose qu aux acheteurs de ces 19 pays, dans ces 8 devises (help.shopify.com, Klarna
       for Shopify Payments). Ailleurs, Etats-Unis compris, il n y a pas de Klarna au checkout :
       la ligne 3x y serait une promesse fausse. Pays et devise inconnus = pas de ligne. */
    var KLARNA_PAYS = { AT: 1, BE: 1, CZ: 1, DK: 1, FI: 1, FR: 1, DE: 1, GR: 1, IE: 1, IT: 1, NL: 1,
                        NO: 1, PL: 1, PT: 1, RO: 1, ES: 1, SE: 1, CH: 1, GB: 1 };
    var KLARNA_DEVISES = { CHF: 1, CZK: 1, DKK: 1, EUR: 1, GBP: 1, NOK: 1, PLN: 1, SEK: 1 };
    function klarnaOffert() {
      var sh = window.Shopify || {};
      var pays = String(sh.country || '').toUpperCase();
      var devise = String((sh.currency && sh.currency.active) || (ctx.data && ctx.data.currency) || '').toUpperCase();
      return !!(KLARNA_PAYS[pays] && KLARNA_DEVISES[devise]);
    }
    function garnitAchat(box, sansCoeur) {
      box.innerHTML = '';
      var haut = el('div', 'cm-mm__buy-top');
      var prixBloc = el('div', 'cm-mm__buy-prixbloc');
      prixBloc.appendChild(el('div', 'cm-mm__buy-price', ctx.fmtPrice(ctx.data.price, ctx.data.currency)));
      /* v6.24 (13/09, Marc) : le paiement en trois fois sur la ligne du prix, meme regle que le tiroir
         panier (a partir de 35, libelles du theme cart.klarna.*). Meilleur rapport euros/pixel du
         dossier apres une hausse de 50 EUR du prix de base. */
      var tiers = null;
      if (ctx.klarna && ctx.klarna.length === 2 && ctx.data.price >= 35 && klarnaOffert()) {
        tiers = el('div', 'cm-mm__buy-3x');
        /* phrase maison (SECOURS.troisX) : le libelle du theme se terminait par « avec » suivi
           d un logo de 11 px, ce qui faisait etiquette de supermarche sous un prix en 26 px
           (Lino, 13/09). Le badge Klarna est a part, lisible, aux couleurs de la marque. */
        var phrase = String(ctx.T.troisX || 'or 3 \u00d7 {x} interest-free').split('{x}');
        var txt3 = el('span', 'cm-mm__buy-3x-txt');
        txt3.appendChild(document.createTextNode(phrase[0]));
        txt3.appendChild(el('strong', null, montant3x(ctx.data.price, ctx.data.currency)));
        txt3.appendChild(document.createTextNode(phrase[1] || ''));
        tiers.appendChild(txt3);
        var logo = el('span', 'cm-mm__klarna-wrap');
        logo.innerHTML = KLARNA_SVG;
        tiers.appendChild(logo);
        /* dans la barre du telephone, la ligne va SOUS la rangee prix / coeur / bouton, pleine
           largeur : posee a cote du prix elle elargissait le bloc prix et ecrasait le bouton noir
           a 128 px de large sur deux lignes (mesure du 13/09). */
        if (!(box.classList && box.classList.contains('cm-mm__sticky'))) prixBloc.appendChild(tiers);
      }
      haut.appendChild(prixBloc);
      if (!ctx.hideSave && !sansCoeur) {
        var sf = el('button', 'cm-mm-btn cm-mm-btn--ghost cm-mm__buy-fav');
        sf.type = 'button';
        if (claimed) {
          sf.innerHTML = HEART_FILL_SVG;
          sf.setAttribute('data-on', '1');
          sf.setAttribute('aria-label', ctx.T.kept);
          sf.title = ctx.T.kept;
        } else {
          sf.innerHTML = HEART_SVG + '<span></span>';
          sf.querySelector('span').textContent = ctx.T.favShort;
          sf.setAttribute('aria-label', ctx.T.favBtn);
        }
        sf.addEventListener('click', function () {
          track(claimed ? 'fav_deja_faite' : 'save_fav_sticky');
          renderKept(true);
        });
        haut.appendChild(sf);
      }
      box.appendChild(haut);
      /* ctx.cta est LU ICI, a chaque garniture, et jamais retenu : c est ce qui permet a
         l appelant de reposer l etat du bouton puis de rejouer le seul bloc d achat. Absent,
         le bouton dit « Ajouter au panier » comme avant et l ecran d apres configuration, qui
         ne pose pas cette entree, ne bouge pas d un pixel. */
      var cta = ctx.cta || null;
      var sb = el('button', 'cm-mm-btn cm-mm-btn--primary cm-mm__buy-btn', (cta && cta.texte) ? cta.texte : ctx.T.addCart);
      sb.type = 'button';
      /* un bouton d achat desactive est la seule chose qui empeche un second ajout de la meme
         montre : elle est unique, et Shopify fusionnerait les deux lignes en quantite 2 sans
         rien dire. */
      if (cta && cta.desactive) { sb.disabled = true; sb.setAttribute('data-fait', '1'); }
      /* 28/09/2026 : majAchat reconstruit ce bouton (rafraichissement du prix, accessoires) et
         le rendait actif pendant un ajout deja parti : un second clic posait la montre deux
         fois. Reconstruit dans les 4 s qui suivent un clic, il nait desactive et se rearme seul
         (un ajout en echec doit pouvoir etre retente). */
      var depuisAchat = Date.now() - achatParti;
      if (depuisAchat < 4000 && !sb.disabled) {
        sb.disabled = true;
        setTimeout(function () { if (!sb.hasAttribute('data-fait') && !sb.hasAttribute('data-marque')) sb.disabled = false; }, 4000 - depuisAchat);
      }
      /* v6.40 : garde-fou marques deposees. Le message passe AU-DESSUS du bouton, le bouton est
         desactive, et le clic est rejete une seconde fois au cas ou un appelant le reactiverait. */
      var marque = marqueInterdite(ctx.data && ctx.data.options);
      if (marque) {
        sb.disabled = true;
        sb.setAttribute('data-marque', '1');
        var avert = el('p', 'cm-mm__buy-marque', String(COPY_MARQUE[lang()] || COPY_MARQUE.en).replace('{m}', nomMarque(marque)));
        avert.setAttribute('role', 'alert');
        avert.style.cssText = 'flex-basis:100%;width:100%;margin:8px 0;font-size:13px;line-height:1.45;color:#b3261e;';
        box.appendChild(avert);
      }
      sb.addEventListener('click', function () {
        if (marqueInterdite(ctx.data && ctx.data.options)) return;
        if (sb.disabled) return;
        achatParti = Date.now();
        track('add_to_cart_sticky'); ctx.addToCart(sb);
      });
      box.appendChild(sb);
      /* lien et non second bouton : le seul objet noir de l ecran reste celui qui paie. Il est
         garni dans les DEUX conteneurs, comme le prix et le bouton, parce que le CSS n en montre
         qu un a la fois selon la taille d ecran.
         Le lien de ctx.cta REMPLACE ctx.lienSecondaire au lieu de s y ajouter : une montre deja
         au panier propose « Voir mon panier », pas « Voir mon panier » ET « Reprendre ma
         configuration » l un sous l autre. */
      var lien = (cta && cta.lien) ? cta.lien : ctx.lienSecondaire;
      if (lien && lien.texte && lien.href) {
        var ls = el('a', 'cm-mm-link cm-mm__buy-lien', lien.texte);
        ls.href = lien.href;
        ls.addEventListener('click', function () { track('lien_secondaire'); });
        box.appendChild(ls);
      }
      if (tiers && box.classList && box.classList.contains('cm-mm__sticky')) box.appendChild(tiers);
      caleReserve();
    }
    /* le nom ne change pas : les quatre appels existants restent valables. */
    /* retenu pour majAchat : rejouer le bloc d achat ne doit pas faire revenir le coeur sur
       les ecrans de sortie, qui en affichent deja un. */
    var dernierSansCoeur;
    function majSticky(sansCoeur) {
      dernierSansCoeur = sansCoeur;
      sticky.style.display = '';
      garnitAchat(buy, sansCoeur);
      garnitAchat(sticky, sansCoeur);
    }
    function renderChoice() {
      actions.innerHTML = '';
      /* le conteneur porte un filet et une marge : vide, il laisserait un trait tout seul
         sous la fiche. Les ecrans email et interception le remontrent. */
      actions.style.display = 'none';
      /* on quitte l etat de sortie : c est le chemin emprunte par « annuler » depuis l ecran
         post-enregistrement, le coeur doit revenir dans le bloc d achat. */
      majSticky();
    }
    function renderKept(garderBarre) {
      saved = true;
      /* le seul endroit qui fait entrer la montre dans « Mes montres » : un clic du client,
         ici ou sur l'ecran de sortie. */
      if (!claimed) {
        claimed = true;
        if (ctx.onFavClaim) { try { ctx.onFavClaim(); } catch (e) {} }
      }
      if (ctx.onFavKept) { try { ctx.onFavKept(); } catch (e) {} }
      /* garderBarre faux = on arrive de l ecran d attente : le coeur serait un doublon du
         « Enregistre » affiche juste en dessous, mais le prix et le bouton d achat restent. */
      /* toujours sans coeur : cet ecran affiche deja un coeur vert plein dans « Enregistre »,
         le reconstruire dans la barre en mettait deux a l ecran (retour du 04/09). */
      majSticky(true);
      actions.style.display = '';
      actions.innerHTML = '';
      var t = el('div', 'cm-mm__kept');
      t.innerHTML = HEART_FILL_SVG + '<span></span>';
      t.querySelector('span').textContent = ctx.T.kept + ' ✓';
      actions.appendChild(t);
      var mail = el('div', 'cm-mm__mail');
      var input = el('input');
      input.type = 'email';
      input.autocomplete = 'email';
      input.placeholder = ctx.T.sendWhere;
      if (ctx.savedEmail) input.value = ctx.savedEmail;
      var btn = el('button', null, ctx.T.send);
      btn.type = 'button';
      var hint = el('p', 'cm-mm__hint', ctx.T.hint);
      /* v6.29 (14/09, Lino) : la RAISON avant le champ, la case d abonnement apres.
         « Pas de newsletter » a disparu des libelles : on demande maintenant l abonnement,
         et promettre le contraire de ce qu on demande faisait perdre les deux. La raison
         affichee est celle que le client vient de vivre (il a configure sur un ecran, il
         paiera peut-etre sur un autre), pas une promesse de stockage qu on ne tient pas.
         La case n est JAMAIS pre-cochee : en France et en Allemagne, deux des trois marches,
         un consentement pre-coche n en est pas un, et la sanction coute plus cher que les
         abonnes gagnes. Le gain se joue sur le libelle, pas sur la case. */
      var why = ctx.T.mailWhy ? el('p', 'cm-mm__why', ctx.T.mailWhy) : null;
      var consent = null, consentBox = null;
      if (ctx.T.consent) {
        consent = el('label', 'cm-mm__consent');
        consentBox = el('input');
        consentBox.type = 'checkbox';
        consent.appendChild(consentBox);
        consent.appendChild(el('span', null, ctx.T.consent));
      }
      var links = el('div', 'cm-mm__links');
      function renderFinalLinks() {
        links.innerHTML = '';
        var seeall = el('a', 'cm-mm-link', ctx.T.seeAll);
        seeall.href = ctx.favPageUrl || '#';
        links.appendChild(seeall);
        if (ctx.onClose) {
          var cont = el('button', 'cm-mm-link', ctx.T.cont);
          cont.type = 'button';
          cont.addEventListener('click', fermeEcran);
          links.appendChild(cont);
        }
      }
      btn.addEventListener('click', function () {
        var email = (input.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { input.focus(); return; }
        btn.disabled = true;
        /* 3e argument : la surface abonne elle-meme si la case est cochee. Le moteur ne
           connait ni la clef Klaviyo ni la liste, et ne doit pas les connaitre. Une surface
           ecrite avant ce jour ignore simplement l argument en trop. */
        ctx.sendEmail(email, function (ok) {
          btn.disabled = false;
          if (ok) {
            mail.innerHTML = '';
            mail.appendChild(el('span', 'cm-mm__sent', ctx.T.sentShort));
            hint.remove();
            if (why) why.remove();
            if (consent) consent.remove();
            renderFinalLinks();
          }
        }, !!(consentBox && consentBox.checked));
      });
      mail.appendChild(input);
      mail.appendChild(btn);
      if (why) actions.appendChild(why);
      actions.appendChild(mail);
      if (consent) actions.appendChild(consent);
      actions.appendChild(hint);
      var skip = el('button', 'cm-mm-link', ctx.T.skipKeep);
      skip.type = 'button';
      skip.addEventListener('click', function () {
        mail.remove();
        hint.remove();
        if (why) why.remove();
        if (consent) consent.remove();
        renderFinalLinks();
      });
      links.appendChild(skip);
      var undo = el('button', 'cm-mm-link', ctx.T.undo);
      undo.type = 'button';
      undo.addEventListener('click', function () {
        saved = false;
        claimed = false;
        if (ctx.onFavUndo) { try { ctx.onFavUndo(); } catch (e) {} }
        renderChoice();
      });
      links.appendChild(undo);
      actions.appendChild(links);
      scrollToActions();
      setTimeout(function () { try { input.focus(); } catch (e) {} }, 250);
    }
    renderChoice();
    /* poignee de rendu. L appelant qui reste sur place apres un ajout au panier rejoue le SEUL
       bloc d achat, au lieu de rappeler render() : la fiche n est pas redessinee sous le doigt
       du client et ses ecouteurs ne s empilent pas. Le contrat etant relu a chaque garniture,
       il suffit de poser ctx.cta puis d appeler ceci. */
    return {
      majAchat: function () { majSticky(dernierSansCoeur); }
    };
  }
  /* texteClair est expose comme libelle pret a afficher : la page Mes montres l'appelle pour
     nettoyer son tableau de configuration, et gagne ainsi la mise en langue sans modification
     du liquid. Le nettoyage seul reste texteClair() en interne. */
  /* --- garde-fous de la page Mes montres (terrain d'entente du 28/08) ---------------- */

  /* la fiche ouverte ne dit pas quel favori elle montre ; son image, elle, est unique. */
  /* deux URL designent-elles la meme image ? On compare le CHEMIN resolu : le stockage garde
     parfois une adresse protocole-relative et les parametres de taille varient. */
  function memeImage(a, b) {
    if (!a || !b) return false;
    try {
      return new URL(a, location.href).pathname === new URL(b, location.href).pathname;
    } catch (e) {
      return a === b;
    }
  }
  function favoriParImage(src) {
    try {
      var s = JSON.parse(localStorage.getItem('cm_favoris_v1') || '{}');
      var items = (s && s.items) || [];
      for (var i = 0; i < items.length; i++) {
        if (items[i] && memeImage(items[i].image, src)) return items[i];
      }
    } catch (e) {}
    return null;
  }

  /* id du theme previsualise, s'il y en a un */
  function themeApercu() {
    try {
      var th = window.Shopify && Shopify.theme;
      if (th && th.id && th.role && th.role !== 'main') return String(th.id);
    } catch (e) {}
    var m = /[?&]preview_theme_id=(\d+)/.exec(location.search);
    return m ? m[1] : null;
  }
  function avecApercu(url) {
    var id = themeApercu();
    if (!id || !url || url.indexOf('preview_theme_id') >= 0) return url;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'preview_theme_id=' + id;
  }
  /* garde la previsualisation d'un ecran a l'autre : sans cela, « Reprendre ma configuration »
     ramene sur le theme publie, ou la fiche recap n'existe pas encore. */
  function propageApercu() {
    if (!themeApercu()) return;
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      /* liens internes seulement, et pas les ancres */
      if (href.charAt(0) !== '/' || href.charAt(1) === '/') return;
      var neuf = avecApercu(href);
      if (neuf !== href) a.setAttribute('href', neuf);
    }, true);
  }

  /* --- prix a jour, dans la devise du client ------------------------------------------ */
  var CACHE_PRODUIT = {};
  function chargeProduit(handle) {
    if (!handle) return Promise.resolve(null);
    if (CACHE_PRODUIT[handle]) return CACHE_PRODUIT[handle];
    var racine = '';
    try {
      if (window.Shopify && Shopify.routes && Shopify.routes.root) racine = Shopify.routes.root.replace(/\/$/, '');
    } catch (e) {}
    CACHE_PRODUIT[handle] = fetch(racine + '/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return CACHE_PRODUIT[handle];
  }
  function deviseActive() {
    try {
      if (window.Shopify && Shopify.currency && Shopify.currency.active) return Shopify.currency.active;
    } catch (e) {}
    return null;
  }
  function formatePrix(montant, devise) {
    var l = document.documentElement.getAttribute('lang') || 'en';
    try {
      return new Intl.NumberFormat(l, { style: 'currency', currency: devise,
                                        maximumFractionDigits: 0 }).format(montant);
    } catch (e) {
      return montant + ' ' + devise;
    }
  }
  /* met a jour un element de prix a partir de la variante reellement memorisee */
  function rafraichitPrix(el, fav) {
    if (!el || !fav) return;
    var devise = deviseActive();
    if (!devise) return;
    var vid = fav.lineAdd && fav.lineAdd.id;
    chargeProduit(fav.handle).then(function (p) {
      if (!p || !p.variants) return;
      var v = null;
      for (var i = 0; i < p.variants.length; i++) {
        if (vid && String(p.variants[i].id) === String(vid)) { v = p.variants[i]; break; }
      }
      /* variante disparue (palier de prix retire) : on ne bricole pas, on garde l'affichage. */
      if (!v || typeof v.price !== 'number') return;
      el.textContent = formatePrix(v.price / 100, devise);
    });
  }
  /* favOuvert : la montre reellement ouverte, DONNEE par la page qui la connait. */
  function corrigePrixFavoris(favOuvert) {
    var store;
    try { store = JSON.parse(localStorage.getItem('cm_favoris_v1') || '{}'); } catch (e) { return; }
    var items = (store && store.items) || [];
    if (!items.length) return;
    function favDe(racine, selImg) {
      var im = racine.querySelector(selImg);
      if (!im) return null;
      for (var i = 0; i < items.length; i++) {
        if (memeImage(items[i].image, im.getAttribute('src') || im.src)) return items[i];
      }
      return null;
    }
    [].forEach.call(document.querySelectorAll('.cm-fav-card'), function (carte) {
      var el = carte.querySelector('.cm-fav-card__price');
      if (el) rafraichitPrix(el, favDe(carte, '.cm-fav-card__img img'));
    });
    /* La fiche d une montre favorite n est plus un noeud persistant de la page : c est la
       couche .cm-ov, creee a l ouverture et detruite a la fermeture, garnie par render().
       Et le prix y existe EN DOUBLE, garnitAchat garnissant le bloc sous la montre ET la
       barre du bas ; le CSS n en montre qu un a la fois selon la taille d ecran. N en
       corriger qu un afficherait donc deux prix differents pour la meme montre selon
       l ecran. On les corrige tous. */
    var couche = document.querySelector('.cm-ov .cm-mm');
    if (!couche) return;
    /* On ne devine plus la montre ouverte en comparant le src de son image aux images du
       magasin : une montre sans image n etait jamais reconnue, et son prix restait celui du
       jour de la sauvegarde sur l ecran meme ou le client decide d acheter, sans la moindre
       erreur visible. La page sait laquelle elle a ouverte, elle nous la passe. Le repli par
       image reste pour les appelants qui n ont pas d item sous la main. */
    var favFiche = favOuvert || favDe(couche, '.cm-mm__stage img');
    if (!favFiche) return;
    [].forEach.call(couche.querySelectorAll('.cm-mm__buy-price'), function (e2) {
      rafraichitPrix(e2, favFiche);
    });
  }

  function gardeFousFavoris() {
    /* La garde d entree est la GRILLE, pas la fiche. Elle testait le balisage de l ancienne
       seconde fiche, celle que la page construisait a la main ; ce balisage a disparu avec la
       fusion des deux ecrans. Garder ce test aurait fait sortir la fonction des sa
       premiere ligne et emporte avec elle propageApercu() ET la correction du prix des CARTES,
       qui n ont pourtant rien a voir avec la fiche. Panne silencieuse, sans erreur console :
       sur un theme non publie, « Reprendre ma configuration » renvoie vers le theme publie,
       ou l ecran n existe pas. C est la grille qui identifie la page « Mes montres ». */
    var grille = document.querySelector('.cm-fav-grid');
    if (!grille) return;

    /* 2) plus de logo injecte. Il etait en position:fixed donc coupe en deux par l arete de
       la carte, il doublait le logo du header, et son lien perdait le prefixe de langue.
       render() refuse deja d en poser un, pour la meme raison. */
    propageApercu();
    /* la grille est reconstruite par la page a chaque rendu : on suit ses changements plutot
       que de corriger une seule fois. */
    corrigePrixFavoris();
    /* plus de MutationObserver sur la fiche : le voile est cree puis detruit, il n a aucun
       attribut hidden a observer. La page appelle window.cmMaMontre.corrigePrix() juste apres
       render(), c est le seul declencheur qui reste et il est explicite. */
    try {
      new MutationObserver(function () { corrigePrixFavoris(); })
        .observe(grille, { childList: true });
    } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gardeFousFavoris);
  } else {
    gardeFousFavoris();
  }

  /* ensureCss expose : sur la page favoris, si les trois bandes retournent null, la feuille
     n etait posee par personne et la carte se disloquait. specs alimente la carte d identite
     de l ecran B, qui montrait moins que A pour la meme montre. */
  /* corrigePrix est expose parce que la fiche de « Mes montres » est desormais une couche
     creee puis detruite : plus d attribut a observer, c est la page qui declenche la
     correction du prix courant juste apres render(). */
  window.cmMaMontre = { marqueInterdite: marqueInterdite, render: render, buildBand: buildBand, buildStrapBand: buildStrapBand, buildDialBand: buildDialBand, texteClair: libelle, libelle: libelle, ensureCss: ensureCss, specs: specsFor, corrigePrix: corrigePrixFavoris };
})();
